// TamalePage.jsx
import React, { useState, useEffect } from "react";
import MapVisualization from "./components/MapVisualization";
import HeatmapChart from "./components/HeatmapChart";
import TimeSeriesChart from "./components/TimeSeriesChart";
import SpatialGridOverlay from "./components/SpatialGridOverlay";
import { MapContainer, TileLayer } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import "./App.css"; // Assuming the styling is shared from App.css

const ncFiles = [
  "rx1day_Bekwai_CHIRPS.nc",
  "rx5day_clipped_Bekwai.nc",
  "r99ptot_clipped_Bekwai.nc",

  "rx7day_clipped_Bekwai.nc",
  "rx5day_Bekwai_CHIRPS.nc",
  "r95p_Bekwai_CHIRPS.nc",

  "r99ptot_Bekwai_CHIRPS.nc",
  "sdii_Bekwai_CHIRPS.nc",
  "r30mm_Bekwai_CHIRPS.nc",

  "rx7day_Bekwai_CHIRPS.nc",
  "r20mm_Bekwai_CHIRPS.nc",
  "cdd_clipped_Bekwai.nc",

  "r10mm_clipped_Bekwai.nc",
  "r20mm_clipped_Bekwai.nc",
  "r95ptot_Bekwai_CHIRPS.nc",

  "r95p_clipped_Bekwai.nc",
  "rx1day_clipped_Bekwai.nc",
  "cdd_Bekwai_CHIRPS.nc",

  "r99p_Bekwai_CHIRPS.nc",
  "prcptot_clipped_Bekwai.nc",
  "prcptot_Bekwai_CHIRPS.nc",

  "r30mm_clipped_Bekwai.nc",
  "r99p_clipped_Bekwai.nc",
  "sdii_clipped_Bekwai.nc",

  "r95ptot_clipped_Bekwai.nc",
  "cwd_clipped_Bekwai.nc",
  "r10mm_Bekwai_CHIRPS.nc",

  "cwd_Bekwai_CHIRPS.nc",
];

const descriptions = {
  rx1day: "Max 1-day rainfall",
  rx5day: "Max 5-day rainfall",
  rx7day: "Max 7-day rainfall",

  r95p: "Very wet days",
  r99p: "Extremely wet days",
  r95ptot: "Total from very wet days",

  r99ptot: "Total from extremely wet days",
  cdd: "Consecutive Dry Days",
  cwd: "Consecutive Wet Days",

  prcptot: "Annual total precipitation",
  r10mm: "Days ≥10mm",
  r20mm: "Days ≥20mm",

  r30mm: "Days ≥30mm",
  sdii: "Simple Daily Intensity Index",
};

function TamalePage() {
  const [selectedFile, setSelectedFile] = useState(null);
  const [response, setResponse] = useState(null);
  const [loading, setLoading] = useState(false);
  const [selectedVariable, setSelectedVariable] = useState("");
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [geojson, setBoundaryGeoJson] = useState({});
  useEffect(() => {
    const fetchBoundary = async () => {
      try {
        const geojson = {
          type: "FeatureCollection",
          name: "BekwaiMuni",
          crs: {
            type: "name",
            properties: { name: "urn:ogc:def:crs:OGC:1.3:CRS84" },
          },
          features: [
            {
              type: "Feature",
              properties: {
                Label: "Bekwai Municipal",
                Region: "Ashanti",
                District: "Bekwai Municipal",
              },
              geometry: {
                type: "Polygon",
                coordinates: [
                  [
                    [-1.657808758999977, 6.544860219000043],
                    [-1.657464158999971, 6.544822077000049],
                    [-1.657160952999959, 6.544822474000057],
                    [-1.656133336999972, 6.545223532000023],
                    [-1.655375000999925, 6.544976421000058],
                    [-1.655143487999965, 6.544996020000042],
                    [-1.654622852999978, 6.545247554000071],
                    [-1.654319550999958, 6.545172139000044],
                    [-1.65401624499998, 6.545096727000043],
                    [-1.65365806899996, 6.545215729000063],
                    [-1.653178908999962, 6.545567826000024],
                    [-1.652699748999964, 6.545919923000042],
                    [-1.652443482999956, 6.546005273000048],
                    [-1.652176255999962, 6.546094273000051],
                    [-1.65183170499995, 6.546094719000052],
                    [-1.651453745999959, 6.545961273000046],
                    [-1.651316781999981, 6.545880451000073],
                    [-1.651179240999966, 6.545799289000058],
                    [-1.650714832999938, 6.545405120000055],
                    [-1.650551654999958, 6.545266621000053],
                    [-1.650470781999957, 6.545225964000053],
                    [-1.649911749999944, 6.544944919000045],
                    [-1.649645265999936, 6.544564842000057],
                    [-1.649378781999928, 6.544184767000047],
                    [-1.649264266999978, 6.54408843300007],
                    [-1.649149749999935, 6.543992097000057],
                    [-1.647770635999962, 6.543285412000046],
                    [-1.647309824999979, 6.54290282900007],
                    [-1.647233875999973, 6.542788524000059],
                    [-1.647157926999967, 6.542674220000038],
                    [-1.647055344999956, 6.542211233000046],
                    [-1.646798671999932, 6.541955192000046],
                    [-1.646541996999929, 6.541699153000025],
                    [-1.646332097999959, 6.541376892000073],
                    [-1.646293213999968, 6.54114813800004],
                    [-1.646141338999939, 6.540936070000043],
                    [-1.64547080799997, 6.540369058000067],
                    [-1.645316001999959, 6.540019159000053],
                    [-1.645191102999945, 6.539346692000038],
                    [-1.644419385999925, 6.538037452000026],
                    [-1.644210516999976, 6.537683101000027],
                    [-1.643942506999963, 6.537228413000037],
                    [-1.643886532999943, 6.536566883000035],
                    [-1.643680844999949, 6.536302507000073],
                    [-1.643475157999944, 6.536038129000076],
                    [-1.643284479999977, 6.53565519600005],
                    [-1.643296523999936, 6.535374],
                    [-1.643308567999952, 6.535092804000044],
                    [-1.643007454999974, 6.534896913000068],
                    [-1.642828561999977, 6.534780535000039],
                    [-1.642678006999972, 6.534682590000045],
                    [-1.642348556999934, 6.534468265000044],
                    [-1.642218759999935, 6.53427270800006],
                    [-1.641573224999945, 6.533843490000038],
                    [-1.640870504999953, 6.533962921000068],
                    [-1.640277586999957, 6.533726602000058],
                    [-1.639673351999932, 6.533258735000061],
                    [-1.639185270999974, 6.533096711000042],
                    [-1.638743720999969, 6.532675500000039],
                    [-1.638514796999971, 6.532560010000054],
                    [-1.638170161999938, 6.532488773000068],
                    [-1.63746737799994, 6.532555823000052],
                    [-1.637257807999958, 6.53248717200006],
                    [-1.637017451999952, 6.532049165000046],
                    [-1.636807704999967, 6.531839923000064],
                    [-1.636428512999942, 6.531686027000035],
                    [-1.636049319999927, 6.531532133000042],
                    [-1.635509054999943, 6.531514895000043],
                    [-1.63496878899997, 6.531497659000024],
                    [-1.634067280999943, 6.53156632300005],
                    [-1.633859643999926, 6.531582137000044],
                    [-1.633717525999941, 6.531592962000047],
                    [-1.633405902999925, 6.531469303000051],
                    [-1.633268077999958, 6.531463963000022],
                    [-1.63313025399998, 6.531458622000059],
                    [-1.632896031999962, 6.53151129400004],
                    [-1.632661806999977, 6.531563965000032],
                    [-1.632419264999953, 6.531576675000053],
                    [-1.63217672199994, 6.531589384000029],
                    [-1.631809899999951, 6.531407903000058],
                    [-1.631619611999952, 6.53132819800004],
                    [-1.631540981999933, 6.531270407000022],
                    [-1.631462355999929, 6.531212614000026],
                    [-1.631387847999974, 6.531143792000023],
                    [-1.631078780999928, 6.53089237100005],
                    [-1.630973525999934, 6.530810432000067],
                    [-1.630608666999933, 6.530528245000028],
                    [-1.630398052999965, 6.530503730000021],
                    [-1.630058756999972, 6.530464239000025],
                    [-1.62979504499998, 6.530433545000051],
                    [-1.629576117999932, 6.530213951000064],
                    [-1.629354242999966, 6.529991400000029],
                    [-1.62925336099994, 6.52967805000003],
                    [-1.629214931999968, 6.52956084300007],
                    [-1.628861522999955, 6.529166447000023],
                    [-1.628655465999941, 6.528935784000055],
                    [-1.628401083999961, 6.528325899000038],
                    [-1.628101693999952, 6.528077405000033],
                    [-1.627889724999932, 6.527900591000048],
                    [-1.62772911299993, 6.527657905000069],
                    [-1.627115930999935, 6.527122649000034],
                    [-1.624711941999976, 6.527369800000031],
                    [-1.621415529999979, 6.528142397000067],
                    [-1.618558381999947, 6.529939636000051],
                    [-1.618188436999958, 6.530001037000034],
                    [-1.617042519999927, 6.530102997000029],
                    [-1.616654309999944, 6.530459084000029],
                    [-1.616534983999941, 6.530543284000032],
                    [-1.616208166999968, 6.53077389200007],
                    [-1.615806021999958, 6.531005945000061],
                    [-1.615686259999961, 6.531120494000049],
                    [-1.615579189999949, 6.531226942000046],
                    [-1.615349139999978, 6.531557841000051],
                    [-1.615237543999967, 6.531715580000025],
                    [-1.614728882999941, 6.531495194000058],
                    [-1.614453191999928, 6.531448667000063],
                    [-1.614210675999971, 6.531484799000054],
                    [-1.614005566999936, 6.531523113000048],
                    [-1.613717194999936, 6.531408212000031],
                    [-1.613438648999932, 6.531281745000058],
                    [-1.613231804999941, 6.531185512000036],
                    [-1.613024960999951, 6.53108928100005],
                    [-1.612346492999961, 6.530756546000021],
                    [-1.611734294999962, 6.530520215000024],
                    [-1.611271665999936, 6.530272358000047],
                    [-1.611030966999976, 6.530143401000032],
                    [-1.610443516999965, 6.529857419000052],
                    [-1.609743100999935, 6.529607408000061],
                    [-1.609061994999934, 6.529368400000067],
                    [-1.608579470999928, 6.529233904000023],
                    [-1.607876204999968, 6.528903951000075],
                    [-1.607464233999963, 6.528668687000049],
                    [-1.607418024999959, 6.528645941000036],
                    [-1.606875017999926, 6.528378628000041],
                    [-1.606251782999948, 6.528128521000042],
                    [-1.60592365399998, 6.528025540000044],
                    [-1.605595524999956, 6.527922558000057],
                    [-1.60513502799995, 6.527765980000027],
                    [-1.604779472999951, 6.52777743300004],
                    [-1.604641754999932, 6.527858921000075],
                    [-1.604572894999933, 6.527899664000074],
                    [-1.604504032999955, 6.527940408000063],
                    [-1.604159686999935, 6.528103466000061],
                    [-1.603851017999943, 6.528139673000055],
                    [-1.603321637999954, 6.528002472000026],
                    [-1.602543590999971, 6.527957293000043],
                    [-1.602205239999932, 6.527937646000055],
                    [-1.601585026999942, 6.527908063000041],
                    [-1.601204526999936, 6.527803763000065],
                    [-1.600847358999943, 6.527695504000064],
                    [-1.600714504999928, 6.527709870000024],
                    [-1.600572246999945, 6.52773172600007],
                    [-1.60032309199994, 6.527868002000048],
                    [-1.600135155999965, 6.527879468000037],
                    [-1.599928402999979, 6.527857660000052],
                    [-1.599725422999938, 6.527770195000073],
                    [-1.599525914999958, 6.52780714000005],
                    [-1.599328193999952, 6.527840889000061],
                    [-1.599151063999955, 6.527958948000048],
                    [-1.599068604999957, 6.528010301000052],
                    [-1.59882614199995, 6.528090533000068],
                    [-1.598275368999964, 6.528093007000052],
                    [-1.598156089999975, 6.528093543000068],
                    [-1.597654659999932, 6.528061600000058],
                    [-1.597437032999949, 6.528166612000064],
                    [-1.597223190999955, 6.528298052000025],
                    [-1.597127098999977, 6.528298165000024],
                    [-1.597019816999932, 6.528298293000034],
                    [-1.596906133999937, 6.528271148000044],
                    [-1.596720647999973, 6.528226858000039],
                    [-1.596601609999936, 6.528221330000065],
                    [-1.596469404999937, 6.528215190000026],
                    [-1.596279422999942, 6.528214847000072],
                    [-1.596056020999924, 6.528199441000027],
                    [-1.595899141999951, 6.528295240000034],
                    [-1.595794237999939, 6.528157530000044],
                    [-1.595945591999964, 6.527950599000064],
                    [-1.595983674999957, 6.527868400000045],
                    [-1.595988749999947, 6.527857444000063],
                    [-1.596036319999939, 6.527754766000044],
                    [-1.595989299999928, 6.527616987000044],
                    [-1.595887262999952, 6.527573],
                    [-1.59574943299998, 6.527562136000029],
                    [-1.595575863999954, 6.527631259000032],
                    [-1.595460084999957, 6.527620369000033],
                    [-1.59543795299993, 6.527551478000021],
                    [-1.595407600999977, 6.52746559600007],
                    [-1.59549760699997, 6.527241057000026],
                    [-1.595299673999932, 6.527160190000075],
                    [-1.595263730999932, 6.52706650500005],
                    [-1.59536830899998, 6.526928546000022],
                    [-1.595401207999942, 6.526779646000023],
                    [-1.595384589999981, 6.526710749000074],
                    [-1.595367969999927, 6.526641851000022],
                    [-1.59524117899997, 6.526642001000027],
                    [-1.595147624999925, 6.526779945000044],
                    [-1.595010013999968, 6.526953780000042],
                    [-1.594839146999959, 6.526976035000075],
                    [-1.594770155999925, 6.52690719900005],
                    [-1.594769955999936, 6.526736284000037],
                    [-1.594733986999927, 6.526620546000061],
                    [-1.594675982999945, 6.526518616000033],
                    [-1.594551904999946, 6.526482926000028],
                    [-1.59421522599996, 6.526138735000075],
                    [-1.594055332999972, 6.526116870000067],
                    [-1.593884453999976, 6.526128098000072],
                    [-1.593790792999926, 6.526175072000058],
                    [-1.593837838999946, 6.526334905000056],
                    [-1.594033619999948, 6.526403592000065],
                    [-1.594160534999958, 6.526508197000055],
                    [-1.594251721999967, 6.526701057000025],
                    [-1.594149817999948, 6.526770096000064],
                    [-1.594023042999936, 6.526784029000055],
                    [-1.593551519999949, 6.526624696000056],
                    [-1.593377733999944, 6.526509119000025],
                    [-1.593319621999967, 6.526313462000076],
                    [-1.593275315999961, 6.526139842000021],
                    [-1.593159335999928, 6.525958037000066],
                    [-1.59305444599994, 6.525831352000068],
                    [-1.593054108999979, 6.525544656000022],
                    [-1.592985063999947, 6.525428955000052],
                    [-1.592767327999979, 6.525440239000034],
                    [-1.592651561999958, 6.525440375000073],
                    [-1.592560508999952, 6.52536053700004],
                    [-1.592629134999925, 6.525120624000067],
                    [-1.592755721999936, 6.524946804000024],
                    [-1.592766597999969, 6.524819983000043],
                    [-1.592697582999961, 6.524729094000065],
                    [-1.59257080499998, 6.524740269000063],
                    [-1.592466239999965, 6.524889253000026],
                    [-1.592353190999972, 6.524856305000071],
                    [-1.592339178999964, 6.524660596000047],
                    [-1.59231701899995, 6.524566896000067],
                    [-1.592237004999959, 6.524498072000029],
                    [-1.592143344999954, 6.524545046000071],
                    [-1.591994555999975, 6.524592084000062],
                    [-1.591881506999925, 6.524556379000046],
                    [-1.591787645999943, 6.524432438000076],
                    [-1.591754407999929, 6.524294643000076],
                    [-1.591740409999943, 6.524109960000033],
                    [-1.592026743999952, 6.523833955000043],
                    [-1.592051440999967, 6.523740198000041],
                    [-1.59195761899997, 6.523649337000052],
                    [-1.591797807999967, 6.523696388000076],
                    [-1.591511093999941, 6.523649861000024],
                    [-1.591246501999933, 6.52366119800007],
                    [-1.591004040999962, 6.523744183000076],
                    [-1.590775384999972, 6.523846449000075],
                    [-1.590637717999925, 6.523973418000026],
                    [-1.590477958999941, 6.524067333000062],
                    [-1.590384201999939, 6.524031606000051],
                    [-1.590326201999972, 6.523929675000034],
                    [-1.590394931999924, 6.523777977000066],
                    [-1.590521510999963, 6.523595887000056],
                    [-1.590716898999972, 6.523331014000064],
                    [-1.590807696999946, 6.523193074000062],
                    [-1.590796467999951, 6.523019415000022],
                    [-1.59071645399996, 6.52295059000005],
                    [-1.590567667999949, 6.522997629000031],
                    [-1.590498920999948, 6.523135545000059],
                    [-1.590463224999951, 6.523251368000047],
                    [-1.590372452999929, 6.523411362000047],
                    [-1.590267817999973, 6.523502456000074],
                    [-1.590107887999977, 6.52344750900005],
                    [-1.590016712999955, 6.523262917000068],
                    [-1.590060610999956, 6.523089194000022],
                    [-1.590140395999924, 6.522962292000045],
                    [-1.590187038999943, 6.522780295000075],
                    [-1.590208900999926, 6.522617625000066],
                    [-1.590139805999968, 6.522457817000031],
                    [-1.590001897999969, 6.522378033000052],
                    [-1.589874994999946, 6.522284455000033],
                    [-1.589748141999962, 6.522229469000024],
                    [-1.589530363999927, 6.522204913000053],
                    [-1.589403507999975, 6.522149927000044],
                    [-1.589381322999941, 6.522034172000076],
                    [-1.589414318999957, 6.521965216000069],
                    [-1.58953001499998, 6.521907190000036],
                    [-1.589634781999962, 6.521929121000028],
                    [-1.589816765999956, 6.521986799000047],
                    [-1.58997945599998, 6.52204449900006],
                    [-1.590128364999941, 6.522102216000064],
                    [-1.590266191999945, 6.522113082000033],
                    [-1.59027135599996, 6.521813974000054],
                    [-1.590139025999974, 6.521790697000029],
                    [-1.589827549999939, 6.521780034000074],
                    [-1.589707562999934, 6.52170574400003],
                    [-1.589587576999975, 6.521631453000055],
                    [-1.589609156999927, 6.521228949000033],
                    [-1.589540187999944, 6.521176653000055],
                    [-1.589471218999961, 6.52112435600003],
                    [-1.589297667999972, 6.52120726000004],
                    [-1.589032939999925, 6.521102815000063],
                    [-1.588866109999969, 6.521039605000055],
                    [-1.588699278999968, 6.520976395000048],
                    [-1.588643952999973, 6.52080554500003],
                    [-1.588698955999973, 6.52070072600003],
                    [-1.588814641999932, 6.520631673000025],
                    [-1.589126104999934, 6.520631310000056],
                    [-1.589216969999939, 6.520551260000047],
                    [-1.58912582399995, 6.520391478000022],
                    [-1.588814361999937, 6.520391841000048],
                    [-1.588792121999973, 6.520229222000069],
                    [-1.589009750999935, 6.520126970000035],
                    [-1.589136431999975, 6.520033095000031],
                    [-1.58919136999998, 6.519873142000051],
                    [-1.589064444999963, 6.519757509000044],
                    [-1.588857751999967, 6.519782559000021],
                    [-1.588640071999976, 6.519840705000036],
                    [-1.588502201999972, 6.519794002000026],
                    [-1.588473158999932, 6.519707199000038],
                    [-1.588444115999948, 6.51962039600005],
                    [-1.588479602999939, 6.519322632000069],
                    [-1.588465498999938, 6.519046979000052],
                    [-1.588316431999942, 6.518851427000072],
                    [-1.588167442999975, 6.518724792000057],
                    [-1.588167255999963, 6.518564904000073],
                    [-1.588247132999925, 6.518517947000021],
                    [-1.588384868999981, 6.518448869000053],
                    [-1.588522722999926, 6.51848178900002],
                    [-1.588591898999937, 6.518713271000024],
                    [-1.588638874999958, 6.518815214000028],
                    [-1.588776652999968, 6.518781973000046],
                    [-1.58902739499996, 6.518712763000053],
                    [-1.589153956999951, 6.518516889000068],
                    [-1.589084871999944, 6.518365352000046],
                    [-1.588888920999977, 6.518147801000055],
                    [-1.588924350999946, 6.517803171000025],
                    [-1.588993139999957, 6.517701094000074],
                    [-1.589210832999925, 6.517653976000076],
                    [-1.58930129099997, 6.517226582000035],
                    [-1.589174450999963, 6.517182623000053],
                    [-1.589014690999932, 6.517273781000029],
                    [-1.588990139999964, 6.517491588000041],
                    [-1.588866173999975, 6.517549623000036],
                    [-1.588783500999966, 6.517563504000066],
                    [-1.588703445999954, 6.517458842000053],
                    [-1.588692141999957, 6.517219022000063],
                    [-1.58874985999995, 6.517078363000053],
                    [-1.588862802999927, 6.517023098000038],
                    [-1.589105300999961, 6.516975951000063],
                    [-1.589254085999926, 6.516928914000061],
                    [-1.589220875999956, 6.516813171000024],
                    [-1.588597810999943, 6.516689846000077],
                    [-1.588404803999936, 6.516632181000034],
                    [-1.588321941999936, 6.516483415000039],
                    [-1.588277651999931, 6.516320822000068],
                    [-1.588137029999928, 6.516276878000042],
                    [-1.587908227999947, 6.516252334000058],
                    [-1.587828164999962, 6.516139403000068],
                    [-1.587861051999937, 6.515976719000037],
                    [-1.587976535999928, 6.515736752000066],
                    [-1.587976346999938, 6.51557410700002],
                    [-1.587896334999925, 6.515505282000049],
                    [-1.587631610999949, 6.51540359300003],
                    [-1.587273189999962, 6.515313038000045],
                    [-1.587044270999968, 6.515186496000069],
                    [-1.586964285999954, 6.51513972500004],
                    [-1.586843628999929, 6.515281255000048],
                    [-1.586734088999947, 6.515215694000062],
                    [-1.586679300999947, 6.515168316000029],
                    [-1.58664263999998, 6.515018736000059],
                    [-1.586569868999959, 6.515193989000068],
                    [-1.586427684999933, 6.515296334000027],
                    [-1.586186955999949, 6.515373250000039],
                    [-1.586033689999965, 6.515358830000025],
                    [-1.585873153999955, 6.515366316000041],
                    [-1.585789379999937, 6.515494139000054],
                    [-1.585778614999924, 6.515651073000072],
                    [-1.585697616999937, 6.515779313000053],
                    [-1.585578245999955, 6.515921354000056],
                    [-1.585380434999934, 6.516012681000063],
                    [-1.584986471999969, 6.516175783000051],
                    [-1.584892945999968, 6.516335780000077],
                    [-1.584857212999964, 6.516421279000042],
                    [-1.58482147999996, 6.516506778000064],
                    [-1.58473902999998, 6.516713626000069],
                    [-1.58467021599995, 6.516793651000057],
                    [-1.584540732999926, 6.516848934000052],
                    [-1.584369936999963, 6.516929077000043],
                    [-1.584299709999925, 6.516980156000045],
                    [-1.584229482999945, 6.517031237000026],
                    [-1.58412491699994, 6.517180220000057],
                    [-1.583984568999938, 6.51737335100006],
                    [-1.583869043999925, 6.51758023800005],
                    [-1.583808628999975, 6.51777327700006],
                    [-1.583795033999934, 6.517935937000061],
                    [-1.583806270999958, 6.518117867000058],
                    [-1.583776029999967, 6.518186820000039],
                    [-1.583745791999945, 6.518255771000042],
                    [-1.583666004999941, 6.518382673000076],
                    [-1.583572434999951, 6.518506832000071],
                    [-1.583489891999932, 6.518633736000027],
                    [-1.583454257999961, 6.51880469200006],
                    [-1.583476533999942, 6.519000393000056],
                    [-1.583575960999951, 6.519173950000038],
                    [-1.583678119999945, 6.519325451000043],
                    [-1.583678333999956, 6.519510149000041],
                    [-1.583617813999979, 6.519612217000031],
                    [-1.583491140999968, 6.519714362000059],
                    [-1.583375455999942, 6.519783413000027],
                    [-1.583317650999959, 6.519851019000043],
                    [-1.583259846999965, 6.519918625000059],
                    [-1.583177275999958, 6.520020719000058],
                    [-1.583177474999957, 6.520194391000075],
                    [-1.583187223999971, 6.520281215000068],
                    [-1.58319697099995, 6.520368040000051],
                    [-1.583139247999952, 6.520505942000057],
                    [-1.583045716999948, 6.520665939000025],
                    [-1.582916418999957, 6.520881111000051],
                    [-1.582789826999942, 6.521052173000044],
                    [-1.582649333999939, 6.521121252000057],
                    [-1.582431673999963, 6.521198690000062],
                    [-1.582200273999945, 6.521311983000032],
                    [-1.58210801599995, 6.521379629000023],
                    [-1.582015755999976, 6.521447274000025],
                    [-1.581898751999972, 6.521567326000024],
                    [-1.581781745999933, 6.521687377000035],
                    [-1.58153939999994, 6.52186959900007],
                    [-1.581343802999925, 6.521958039000026],
                    [-1.581123347999949, 6.522002400000076],
                    [-1.580847766999966, 6.522046825000075],
                    [-1.580721038999968, 6.522102105000045],
                    [-1.580594420999944, 6.522251112000049],
                    [-1.580465027999935, 6.522386340000025],
                    [-1.580356190999964, 6.522419545000048],
                    [-1.580247355999973, 6.52245275100006],
                    [-1.580015941999932, 6.522555015000023],
                    [-1.579864500999975, 6.522693024000034],
                    [-1.579806828999949, 6.522875033000048],
                    [-1.579743786999927, 6.52318385600006],
                    [-1.579661442999964, 6.523484432000032],
                    [-1.579463196999939, 6.523666602000048],
                    [-1.579295669999965, 6.523743529000058],
                    [-1.579355213999975, 6.523213358000021],
                    [-1.579274503999955, 6.52263305200006],
                    [-1.57957414599997, 6.521305011000038],
                    [-1.579225294999958, 6.520416385000033],
                    [-1.578953341999977, 6.519179790000067],
                    [-1.577522267999939, 6.518215097000052],
                    [-1.575743551999949, 6.517405408000059],
                    [-1.573772216999942, 6.517137078000076],
                    [-1.573732953999979, 6.516595977000065],
                    [-1.573924434999981, 6.515049624000028],
                    [-1.573870916999965, 6.513902260000066],
                    [-1.573958528999981, 6.513732212000036],
                    [-1.573802394999973, 6.513375395000025],
                    [-1.573708368999974, 6.513099830000044],
                    [-1.573781017999977, 6.512753782000061],
                    [-1.573820846999979, 6.512633820000076],
                    [-1.573871576999977, 6.512403577000043],
                    [-1.573882476999927, 6.512293297000042],
                    [-1.57386441899996, 6.512167887000032],
                    [-1.573846360999937, 6.512042477000023],
                    [-1.573891647999972, 6.511874267000053],
                    [-1.573936935999939, 6.511706056000037],
                    [-1.573986889999958, 6.511647739000068],
                    [-1.574045663999925, 6.511579124000036],
                    [-1.574154392999958, 6.511452192000036],
                    [-1.574258961999931, 6.51130321100004],
                    [-1.574280881999925, 6.511188783000023],
                    [-1.574320657999976, 6.511021957000025],
                    [-1.574338513999976, 6.510969559000046],
                    [-1.574487244999943, 6.510875662000046],
                    [-1.574772386999939, 6.510759556000039],
                    [-1.575002351999956, 6.510598027000071],
                    [-1.575129019999963, 6.510494507000033],
                    [-1.575230832999978, 6.510344149000048],
                    [-1.575332642999967, 6.510193794000031],
                    [-1.575412273999973, 6.509929059000058],
                    [-1.575365037999973, 6.509595552000064],
                    [-1.57516574999994, 6.508859736000034],
                    [-1.574898080999958, 6.508584370000051],
                    [-1.574630409999941, 6.508309005000058],
                    [-1.574448541999971, 6.508347806000074],
                    [-1.574266671999965, 6.508386606000045],
                    [-1.57403777199994, 6.508271084000057],
                    [-1.573945558999981, 6.508375944000022],
                    [-1.573853342999939, 6.508480803000054],
                    [-1.573883973999955, 6.508755061000045],
                    [-1.573914602999935, 6.509029319000035],
                    [-1.573727247999955, 6.509091557000033],
                    [-1.573539892999975, 6.509153796000021],
                    [-1.573388557999976, 6.509382774000073],
                    [-1.573154298999953, 6.50940233700004],
                    [-1.573024562999933, 6.509232946000054],
                    [-1.572465260999934, 6.509425171000032],
                    [-1.572236534999945, 6.509464024000067],
                    [-1.571983099999954, 6.509362549000059],
                    [-1.571663361999924, 6.509577698000044],
                    [-1.571470639999973, 6.509770885000023],
                    [-1.571480353999959, 6.509828765000066],
                    [-1.571490066999957, 6.509886645000051],
                    [-1.571606174999943, 6.510192508000046],
                    [-1.571567715999947, 6.510305577000054],
                    [-1.57145208399993, 6.510421489000066],
                    [-1.57137481999996, 6.510344389000068],
                    [-1.571300273999952, 6.51023144800007],
                    [-1.571223010999972, 6.510154348000071],
                    [-1.571107291999965, 6.51019307200005],
                    [-1.571030243999928, 6.510306184000058],
                    [-1.571068962999959, 6.510421922000035],
                    [-1.571069091999959, 6.510537704000058],
                    [-1.570878911999955, 6.510537919000058],
                    [-1.57053437899998, 6.510538308000037],
                    [-1.570189973999959, 6.510651722000034],
                    [-1.570074210999962, 6.510651852000024],
                    [-1.569958447999966, 6.510651983000059],
                    [-1.569729762999941, 6.510729429000037],
                    [-1.569500756999958, 6.510802014000035],
                    [-1.569384377999938, 6.510782750000033],
                    [-1.569229180999969, 6.510736373000043],
                    [-1.569122099999959, 6.51081143600004],
                    [-1.569016021999971, 6.510880144000055],
                    [-1.56903835199995, 6.511094093000054],
                    [-1.568900640999971, 6.511610807000068],
                    [-1.56875780699994, 6.511622319000026],
                    [-1.568617247999953, 6.511632126000052],
                    [-1.568388669999933, 6.511803299000064],
                    [-1.568168209999953, 6.511842141000045],
                    [-1.568054549999943, 6.511944439000047],
                    [-1.567899746999956, 6.512085033000062],
                    [-1.567631283999958, 6.512327925000022],
                    [-1.567066300999954, 6.512375423000037],
                    [-1.566339094999933, 6.512778719000039],
                    [-1.566375182999934, 6.51300748400007],
                    [-1.566411270999936, 6.51323625200007],
                    [-1.566320468999947, 6.513374188000057],
                    [-1.566091804999928, 6.51347093000004],
                    [-1.566148490999979, 6.513633512000069],
                    [-1.566205176999972, 6.513796095000032],
                    [-1.566186140999946, 6.514027680000027],
                    [-1.566054227999928, 6.514372417000061],
                    [-1.565842228999941, 6.514582164000046],
                    [-1.565692357999978, 6.514892462000034],
                    [-1.565433684999959, 6.515266286000042],
                    [-1.565289349999944, 6.515597253000067],
                    [-1.565175006999937, 6.515635975000066],
                    [-1.56506066299994, 6.515674697000065],
                    [-1.564829135999958, 6.515674956000055],
                    [-1.56471616999994, 6.515713676000075],
                    [-1.564639119999924, 6.515826788000027],
                    [-1.56450414699998, 6.515904126000066],
                    [-1.564272665999965, 6.515945736000049],
                    [-1.564156987999979, 6.516023053000026],
                    [-1.564063359999977, 6.516100345000041],
                    [-1.563947849999977, 6.516329281000026],
                    [-1.563832214999934, 6.516445192000049],
                    [-1.563603525999952, 6.516519878000054],
                    [-1.563496101999931, 6.51660733600005],
                    [-1.563460901999974, 6.516635992000033],
                    [-1.563488049999933, 6.51677913900005],
                    [-1.563526733999936, 6.516864554000051],
                    [-1.563642583999979, 6.516941612000039],
                    [-1.563794436999956, 6.51717024900006],
                    [-1.563833152999962, 6.517285988000026],
                    [-1.563794672999961, 6.517382516000055],
                    [-1.563756231999946, 6.517514881000068],
                    [-1.563681896999981, 6.51759215200002],
                    [-1.563566241999979, 6.517688766000049],
                    [-1.563450562999947, 6.517766083000026],
                    [-1.563337618999981, 6.517824100000041],
                    [-1.563279841999929, 6.51791789300006],
                    [-1.563431717999947, 6.518168584000023],
                    [-1.563451138999937, 6.518281587000047],
                    [-1.563338256999941, 6.518397496000034],
                    [-1.563106729999959, 6.518397754000034],
                    [-1.562993677999941, 6.51835928600002],
                    [-1.562877911999976, 6.51835941500002],
                    [-1.562762233999933, 6.518436732000055],
                    [-1.562743001999934, 6.518493266000064],
                    [-1.562723769999934, 6.518549800000073],
                    [-1.56272389999998, 6.51866558200004],
                    [-1.562688196999943, 6.518781404000038],
                    [-1.562577857999941, 6.518899511000029],
                    [-1.562283243999957, 6.518983094000021],
                    [-1.562170440999978, 6.519167920000029],
                    [-1.56199616899994, 6.519461367000076],
                    [-1.561975531999963, 6.519510715000024],
                    [-1.561909445999959, 6.519605459000047],
                    [-1.561731064999947, 6.519918477000033],
                    [-1.561535152999966, 6.520090001000028],
                    [-1.561500518999935, 6.52019679600005],
                    [-1.561491455999942, 6.520209815000044],
                    [-1.561426166999979, 6.520303634000072],
                    [-1.561344903999952, 6.520390062000047],
                    [-1.561231938999924, 6.520428782000067],
                    [-1.56111630099997, 6.520544692000044],
                    [-1.56107783799996, 6.520657760000063],
                    [-1.561039335999965, 6.52073499100004],
                    [-1.560849363999978, 6.520928172000026],
                    [-1.560733554999956, 6.520889707000038],
                    [-1.560714132999976, 6.520773947000066],
                    [-1.560733296999956, 6.520658143000048],
                    [-1.560656037999934, 6.520583798000075],
                    [-1.560542985999973, 6.520545330000061],
                    [-1.560427262999951, 6.520584051000071],
                    [-1.560350190999941, 6.520677866000028],
                    [-1.560389036999936, 6.520909387000074],
                    [-1.560389183999973, 6.521041709000031],
                    [-1.560312091999947, 6.521118982000075],
                    [-1.56017976499993, 6.521099832000061],
                    [-1.560083315999975, 6.521119236000061],
                    [-1.559967678999953, 6.521235146000038],
                    [-1.559931971999958, 6.521348211000031],
                    [-1.559816292999926, 6.521425528000066],
                    [-1.559700568999972, 6.521464249000076],
                    [-1.55964268699995, 6.52146431400007],
                    [-1.55958480399994, 6.521464378000076],
                    [-1.559507519999954, 6.521367979000047],
                    [-1.559430278999969, 6.521310174000064],
                    [-1.559314511999958, 6.521310302000074],
                    [-1.55920158899994, 6.521387615000037],
                    [-1.559085866999965, 6.521426337000037],
                    [-1.558970100999943, 6.521426465000047],
                    [-1.558857048999926, 6.521387997000033],
                    [-1.558741302999977, 6.521407422000038],
                    [-1.558551330999933, 6.521600602000035],
                    [-1.558435669999938, 6.521694459000059],
                    [-1.558377806999943, 6.521713820000059],
                    [-1.558319945999926, 6.521733180000069],
                    [-1.558206935999976, 6.521733305000055],
                    [-1.558091212999955, 6.521772027000054],
                    [-1.557994869999959, 6.521887916000026],
                    [-1.557937111999934, 6.52200100500005],
                    [-1.557824187999927, 6.522078318000069],
                    [-1.557708420999973, 6.522078446000023],
                    [-1.55759274199994, 6.522155762000068],
                    [-1.557479773999944, 6.522194481000042],
                    [-1.557364007999979, 6.522194609000053],
                    [-1.557286958999953, 6.52231047600003],
                    [-1.557287083999938, 6.522423501000048],
                    [-1.557248621999975, 6.522539325000025],
                    [-1.557116274999942, 6.522500878000073],
                    [-1.557000531999961, 6.522520302000032],
                    [-1.556884785999955, 6.522539727000037],
                    [-1.556655925999962, 6.522462792000056],
                    [-1.556559453999967, 6.522462898000072],
                    [-1.55644652999996, 6.522540211000035],
                    [-1.556408025999929, 6.522617441000023],
                    [-1.556388855999955, 6.522730488000036],
                    [-1.556408277999935, 6.522846248000064],
                    [-1.556408405999946, 6.522962030000031],
                    [-1.556292763999977, 6.52307518300006],
                    [-1.55606131899998, 6.523155383000073],
                    [-1.555945511999937, 6.523116916000049],
                    [-1.555887585999926, 6.523078386000066],
                    [-1.555829658999926, 6.523039856000025],
                    [-1.555755365999971, 6.523155720000034],
                    [-1.55571690599993, 6.523271544000067],
                    [-1.555717029999926, 6.523384569000029],
                    [-1.555601304999925, 6.523423291000029],
                    [-1.55548553999995, 6.52342341800005],
                    [-1.555372486999943, 6.523384949000047],
                    [-1.555256805999932, 6.523462264000045],
                    [-1.555199028999937, 6.523558813000022],
                    [-1.555124859999978, 6.52378770200005],
                    [-1.555009156999972, 6.523845720000054],
                    [-1.554606813999953, 6.523923350000075],
                    [-1.554539317999968, 6.523952370000075],
                    [-1.554301703999954, 6.524690052000039],
                    [-1.554243798999948, 6.52467081900005],
                    [-1.554185893999943, 6.524651585000072],
                    [-1.554072798999925, 6.524574521000034],
                    [-1.55395699099995, 6.524536054000066],
                    [-1.553841224999928, 6.524536182000077],
                    [-1.553728256999932, 6.524574900000061],
                    [-1.553689793999979, 6.524689346000059],
                    [-1.55365132999998, 6.524803791000068],
                    [-1.553651455999955, 6.524919574000023],
                    [-1.55361299599997, 6.525035398000057],
                    [-1.553651707999961, 6.525148380000076],
                    [-1.55361324699993, 6.525264205000042],
                    [-1.553536152999925, 6.52534147800003],
                    [-1.553420470999924, 6.525418793000028],
                    [-1.553346131999945, 6.525493306000044],
                    [-1.55330491199993, 6.525609133000046],
                    [-1.553305038999952, 6.525724914000023],
                    [-1.553382340999974, 6.52583785500002],
                    [-1.553438878999941, 6.525866739000037],
                    [-1.553495415999976, 6.525895622000064],
                    [-1.553611288999946, 6.525991980000072],
                    [-1.553572825999936, 6.526107803000059],
                    [-1.553495772999952, 6.526220914000021],
                    [-1.553457310999931, 6.526336738000055],
                    [-1.55345781699998, 6.526797109000029],
                    [-1.553419350999945, 6.526910177000047],
                    [-1.553306340999939, 6.526910301000044],
                    [-1.553267804999962, 6.526958586000035],
                    [-1.553229268999928, 6.527006871000026],
                    [-1.55315221799998, 6.52712273700007],
                    [-1.552942877999953, 6.527255289000038],
                    [-1.55294313099995, 6.527486853000028],
                    [-1.552923961999966, 6.527599899000052],
                    [-1.552846826999939, 6.527638578000051],
                    [-1.552731058999939, 6.527638704000026],
                    [-1.552618089999953, 6.527677423000057],
                    [-1.552502407999953, 6.527754736000077],
                    [-1.552386597999941, 6.527716270000042],
                    [-1.552273628999956, 6.527754988000027],
                    [-1.552235123999935, 6.527832218000071],
                    [-1.552235248999978, 6.527945243000033],
                    [-1.552158154999972, 6.528022516000021],
                    [-1.55202576399995, 6.527945473000045],
                    [-1.551929207999933, 6.527868391000027],
                    [-1.551794127999926, 6.527851998000074],
                    [-1.551681115999941, 6.52785212200007],
                    [-1.551594405999936, 6.527956971000037],
                    [-1.551507694999941, 6.528061822000041],
                    [-1.551449853999941, 6.528100479000045],
                    [-1.551392010999962, 6.528139137000039],
                    [-1.551317671999925, 6.528213649000065],
                    [-1.551279187999967, 6.528310177000037],
                    [-1.551353862999974, 6.528541659000041],
                    [-1.551431143999935, 6.528635302000055],
                    [-1.551389924999967, 6.528751130000046],
                    [-1.551277038999956, 6.528867036000065],
                    [-1.551199984999926, 6.528980145000048],
                    [-1.551180743999964, 6.529028407000055],
                    [-1.551161501999957, 6.529076672000031],
                    [-1.551026668999953, 6.529286330000048],
                    [-1.550970288999963, 6.52940217400004],
                    [-1.550913909999963, 6.529518018000033],
                    [-1.55091403299997, 6.529631042000062],
                    [-1.55087556899997, 6.529746867000028],
                    [-1.550837107999939, 6.529862691000062],
                    [-1.550779346999946, 6.52997577900004],
                    [-1.550702294999951, 6.530091645000027],
                    [-1.550589283999955, 6.530091769000023],
                    [-1.550434884999959, 6.530053344000066],
                    [-1.550319073999958, 6.530014876000052],
                    [-1.550206105999962, 6.530053594000037],
                    [-1.550167642999952, 6.530169417000025],
                    [-1.550167765999959, 6.530282443000033],
                    [-1.550071376999938, 6.530359736000037],
                    [-1.549975008999979, 6.530456327000024],
                    [-1.549842930999944, 6.530665981000027],
                    [-1.549727204999954, 6.530704701000047],
                    [-1.54967070999993, 6.530714412000066],
                    [-1.549614214999963, 6.530724122000038],
                    [-1.549305363999963, 6.530747061000056],
                    [-1.549049200999946, 6.530766088000064],
                    [-1.548878242999933, 6.530708383000047],
                    [-1.548751506999963, 6.530763656000033],
                    [-1.548624814999926, 6.530854766000061],
                    [-1.548561415999927, 6.530853456000045],
                    [-1.548498016999929, 6.530852147000076],
                    [-1.548384866999925, 6.530725461000031],
                    [-1.548257885999931, 6.530551926000044],
                    [-1.548122655999975, 6.530400453000027],
                    [-1.547995812999943, 6.530353728000023],
                    [-1.547824912999943, 6.530351157000041],
                    [-1.547629270999948, 6.530406504000041],
                    [-1.547549285999935, 6.530359726000029],
                    [-1.547447173999956, 6.530244054000036],
                    [-1.547356087999958, 6.530128372000036],
                    [-1.54722923099996, 6.530070617000035],
                    [-1.547055587999978, 6.530079077000039],
                    [-1.546884740999928, 6.530123370000069],
                    [-1.546790984999973, 6.530087633000051],
                    [-1.546677897999928, 6.530018839000036],
                    [-1.546622633999959, 6.529892090000033],
                    [-1.546495750999952, 6.529809525000076],
                    [-1.546357928999953, 6.529806919000066],
                    [-1.546184312999969, 6.529840188000037],
                    [-1.546023104999961, 6.529878957000051],
                    [-1.545861898999931, 6.529917725000075],
                    [-1.545622102999971, 6.529926255000021],
                    [-1.545459450999942, 6.529901620000032],
                    [-1.545277416999966, 6.529797063000046],
                    [-1.545128446999968, 6.529681442000026],
                    [-1.545015231999969, 6.529494107000062],
                    [-1.544937928999957, 6.529378408000071],
                    [-1.544777945999954, 6.529273826000065],
                    [-1.544604277999952, 6.529260229000045],
                    [-1.544433395999931, 6.529271442000038],
                    [-1.544237614999929, 6.529199978000065],
                    [-1.544088681999938, 6.529117438000071],
                    [-1.544033381999952, 6.528957608000042],
                    [-1.543953318999968, 6.528839155000071],
                    [-1.543851221999944, 6.528737265000075],
                    [-1.543680285999926, 6.528698856000062],
                    [-1.543448735999959, 6.528685323000047],
                    [-1.54321994299994, 6.528671786000075],
                    [-1.542908467999951, 6.528669365000042],
                    [-1.542610722999939, 6.528617308000037],
                    [-1.542467343999931, 6.528571976000023],
                    [-1.542323963999934, 6.528526645000056],
                    [-1.541855169999963, 6.528332800000044],
                    [-1.541690982999967, 6.528162060000056],
                    [-1.541708825999933, 6.528094501000055],
                    [-1.54174437599994, 6.527829818000043],
                    [-1.541746859999932, 6.52757619700003],
                    [-1.54162264799993, 6.527413684000066],
                    [-1.54140476799995, 6.527295379000066],
                    [-1.541131723999968, 6.52714405200004],
                    [-1.54100478099997, 6.527003596000043],
                    [-1.540949481999974, 6.526843765000024],
                    [-1.540950761999966, 6.526751414000046],
                    [-1.540952040999969, 6.526659062000022],
                    [-1.540827829999955, 6.526496549000058],
                    [-1.540689960999941, 6.526449833000072],
                    [-1.540541152999936, 6.526483073000065],
                    [-1.540345448999972, 6.526480526000057],
                    [-1.540207553999949, 6.526408999000068],
                    [-1.540069611999968, 6.526293364000026],
                    [-1.539840720999962, 6.526188854000054],
                    [-1.539567747999968, 6.526103688000035],
                    [-1.539292086999978, 6.526079172000038],
                    [-1.539060487999961, 6.526018772000043],
                    [-1.538889543999971, 6.525972091000028],
                    [-1.538693776999935, 6.525911651000058],
                    [-1.538453947999926, 6.525887098000055],
                    [-1.538247228999978, 6.525895588000026],
                    [-1.537993764999953, 6.526008883000031],
                    [-1.537795437999932, 6.526133149000032],
                    [-1.537588805999974, 6.526221584000041],
                    [-1.537439961999951, 6.526221743000065],
                    [-1.537150587999975, 6.526263401000051],
                    [-1.536910745999933, 6.526227820000031],
                    [-1.536577245999979, 6.526247472000023],
                    [-1.536232648999942, 6.526198218000047],
                    [-1.535888134999936, 6.526228908000064],
                    [-1.535598748999973, 6.526259539000023],
                    [-1.535301018999974, 6.526221261000046],
                    [-1.534967412999947, 6.526138914000057],
                    [-1.534738483999945, 6.52599856300003],
                    [-1.534556381999948, 6.525825083000029],
                    [-1.534410061999949, 6.525604700000031],
                    [-1.534268060999977, 6.525307525000073],
                    [-1.534113100999946, 6.524951778000059],
                    [-1.534039838999945, 6.524783589000037],
                    [-1.533986992999928, 6.524334298000042],
                    [-1.533780043999968, 6.524125007000066],
                    [-1.533609027999944, 6.524009405000072],
                    [-1.533403591999956, 6.523926921000054],
                    [-1.533198155999969, 6.523844436000047],
                    [-1.532784552999942, 6.523701523000057],
                    [-1.532453676999978, 6.52359436100005],
                    [-1.532268878999957, 6.523478773000022],
                    [-1.532169490999934, 6.523327259000041],
                    [-1.532053624999946, 6.523233652000044],
                    [-1.531766912999956, 6.523184333000074],
                    [-1.53152707299995, 6.523148749000029],
                    [-1.531309268999962, 6.523099357000035],
                    [-1.531160351999972, 6.523029217000044],
                    [-1.531011434999925, 6.522959078000042],
                    [-1.530644677999931, 6.522805086000062],
                    [-1.530288961999929, 6.522664868000049],
                    [-1.530051646999937, 6.522408742000039],
                    [-1.529938355999946, 6.522141458000021],
                    [-1.529871951999951, 6.521901693000075],
                    [-1.529794554999967, 6.521692263000034],
                    [-1.529565557999945, 6.521482993000063],
                    [-1.529303568999978, 6.521353701000066],
                    [-1.529005724999934, 6.521202394000056],
                    [-1.528661044999978, 6.521070432000045],
                    [-1.528352164999944, 6.520908109000061],
                    [-1.528215644999932, 6.52083106300006],
                    [-1.528079124999977, 6.520754018000048],
                    [-1.527883255999939, 6.520591576000072],
                    [-1.52766812699997, 6.520462234000036],
                    [-1.527494425999976, 6.520415552000031],
                    [-1.527232500999958, 6.520344150000028],
                    [-1.526956742999971, 6.520225899000025],
                    [-1.526774690999957, 6.520096523000063],
                    [-1.526650439999969, 6.519889898000031],
                    [-1.526457289999939, 6.519691615000056],
                    [-1.526239369999928, 6.519529196000065],
                    [-1.526021599999979, 6.519510125000068],
                    [-1.524321339999972, 6.519218631000058],
                    [-1.524174844999948, 6.519196687000033],
                    [-1.520111430999975, 6.518440719000068],
                    [-1.51900339499997, 6.519173378000062],
                    [-1.518034171999943, 6.519256880000057],
                    [-1.516878907999967, 6.518961567000076],
                    [-1.516687771999955, 6.518281831000024],
                    [-1.516384044999938, 6.517941069000074],
                    [-1.516359355999953, 6.517619953000064],
                    [-1.516447626999934, 6.517320871000038],
                    [-1.516531493999935, 6.517043939000075],
                    [-1.516608919999953, 6.516966344000025],
                    [-1.516628716999946, 6.516835653000044],
                    [-1.516934770999967, 6.516280813000037],
                    [-1.51696246299997, 6.516225291000069],
                    [-1.516987319999942, 6.516199677000031],
                    [-1.517060975999925, 6.516050907000022],
                    [-1.517139198999928, 6.515974367000069],
                    [-1.517190776999939, 6.515840439000044],
                    [-1.517366867999954, 6.515493400000025],
                    [-1.517417906999981, 6.515426106000064],
                    [-1.517427540999961, 6.515385828000035],
                    [-1.517493031999948, 6.515112031000058],
                    [-1.517419181999969, 6.514589177000062],
                    [-1.517478694999966, 6.51457593300006],
                    [-1.517478962999974, 6.514439320000065],
                    [-1.517598247999956, 6.514153494000027],
                    [-1.517719940999939, 6.514055919000043],
                    [-1.51779068899998, 6.513945109000076],
                    [-1.51790352699993, 6.513849758000049],
                    [-1.518034986999965, 6.513694613000041],
                    [-1.518081428999949, 6.513636982000037],
                    [-1.518138887999953, 6.513523969000062],
                    [-1.518217916999959, 6.513437998000029],
                    [-1.51825605099998, 6.513326736000067],
                    [-1.518253711999932, 6.513204927000061],
                    [-1.518218075999926, 6.51300563500007],
                    [-1.518215619999978, 6.512768658000027],
                    [-1.518177883999954, 6.512680107000051],
                    [-1.516841580999937, 6.511263912000061],
                    [-1.512467511999944, 6.510198036000077],
                    [-1.512428804999956, 6.51008229200005],
                    [-1.512276860999975, 6.509737855000026],
                    [-1.512218865999955, 6.50962488700003],
                    [-1.512199453999926, 6.509509124000033],
                    [-1.512122160999979, 6.509393419000048],
                    [-1.512044905999971, 6.509316309000042],
                    [-1.511970255999927, 6.50908757600007],
                    [-1.511683079999955, 6.508572357000048],
                    [-1.511663767999949, 6.508553079000023],
                    [-1.511601900999949, 6.508429640000031],
                    [-1.511586435999959, 6.50839878000005],
                    [-1.511354986999947, 6.508476203000043],
                    [-1.511242037999978, 6.508534209000061],
                    [-1.511126368999953, 6.508628054000042],
                    [-1.511010682999938, 6.508705360000022],
                    [-1.510897713999952, 6.508744068000055],
                    [-1.510782007999978, 6.508802077000041],
                    [-1.510666302999937, 6.508860085000038],
                    [-1.51055333499994, 6.508898794000061],
                    [-1.510321846999943, 6.50893762100003],
                    [-1.510208913999975, 6.509012168000027],
                    [-1.509977464999963, 6.509089590000031],
                    [-1.509520151999936, 6.509318860000064],
                    [-1.509520134999946, 6.509302319000028],
                    [-1.509404426999936, 6.509357571000066],
                    [-1.509288701999935, 6.509396282000068],
                    [-1.509060046999934, 6.509512295000036],
                    [-1.508831314999952, 6.509551120000026],
                    [-1.508599863999962, 6.509628541000041],
                    [-1.508485477999955, 6.509628656000075],
                    [-1.508371091999948, 6.509628772000042],
                    [-1.508142279999959, 6.509590407000076],
                    [-1.508026477999977, 6.509551929000054],
                    [-1.507910637999942, 6.509474857000043],
                    [-1.50779621199996, 6.509436377000043],
                    [-1.507681788999946, 6.509397898000032],
                    [-1.507565930999931, 6.509304286000031],
                    [-1.507450107999944, 6.509246510000025],
                    [-1.507334303999926, 6.50920803200006],
                    [-1.507218464999937, 6.50913096000005],
                    [-1.506760656999973, 6.508866772000033],
                    [-1.506529050999973, 6.508789816000046],
                    [-1.506300163999924, 6.508674262000056],
                    [-1.506184361999942, 6.508635784000035],
                    [-1.505955476999929, 6.50852298600006],
                    [-1.505839713999933, 6.508523102000026],
                    [-1.505726686999935, 6.508503918000031],
                    [-1.505610941999976, 6.508523331000049],
                    [-1.505495177999933, 6.508523447000073],
                    [-1.505322967999973, 6.50858013200002],
                    [-1.505150755999978, 6.508636817000024],
                    [-1.504922023999939, 6.508675640000035],
                    [-1.504693328999963, 6.508753057000035],
                    [-1.504348870999934, 6.508830590000059],
                    [-1.503888571999937, 6.508831049000037],
                    [-1.503659761999927, 6.508792682000035],
                    [-1.503083697999955, 6.508793256000047],
                    [-1.502970728999969, 6.508831963000034],
                    [-1.502912847999937, 6.508832019000067],
                    [-1.502854965999973, 6.508832078000069],
                    [-1.502739239999926, 6.508870787000035],
                    [-1.502626231999955, 6.508870900000034],
                    [-1.502510505999965, 6.508909608000067],
                    [-1.502281773999925, 6.508948431000022],
                    [-1.502166043999978, 6.50898438300004],
                    [-1.502050280999924, 6.508984498000075],
                    [-1.501821585999949, 6.509061914000029],
                    [-1.501703064999958, 6.509062032000031],
                    [-1.501590096999962, 6.509100738000029],
                    [-1.501358606999929, 6.50913956200003],
                    [-1.501245636999954, 6.509178267000038],
                    [-1.501129872999968, 6.509178383000062],
                    [-1.501014147999967, 6.509217092000029],
                    [-1.500785375999953, 6.509217319000072],
                    [-1.500556641999935, 6.509256140000048],
                    [-1.500325112999974, 6.50925636900007],
                    [-1.500212067999939, 6.509217887000034],
                    [-1.500096302999964, 6.509218001000022],
                    [-1.500038400999927, 6.50919876100005],
                    [-1.499186116999965, 6.509123449000072],
                    [-1.497811036999963, 6.507860149000066],
                    [-1.49735368499995, 6.506827338000051],
                    [-1.495780834999948, 6.507261143000051],
                    [-1.49258776399995, 6.509686610000074],
                    [-1.492042354999967, 6.50985745600002],
                    [-1.491496945999927, 6.51002830300007],
                    [-1.489661255999977, 6.50985365300005],
                    [-1.488915153999926, 6.510024604000023],
                    [-1.486429231999978, 6.511472733000062],
                    [-1.486394552999968, 6.511492935000035],
                    [-1.485747839999931, 6.51126578800006],
                    [-1.485298723999961, 6.511108043000036],
                    [-1.484811027999967, 6.511107305000053],
                    [-1.484323334999942, 6.511106568000059],
                    [-1.483606356999928, 6.510933406000049],
                    [-1.482889378999971, 6.510760245000029],
                    [-1.479443858999957, 6.510628082000039],
                    [-1.478742606999958, 6.510708259000069],
                    [-1.477495379999937, 6.511038288000066],
                    [-1.477035690999969, 6.511324390000027],
                    [-1.476576001999945, 6.511610492000045],
                    [-1.476116290999926, 6.51224015400004],
                    [-1.47611608699998, 6.512297701000023],
                    [-1.475427845999945, 6.512181876000056],
                    [-1.475198629999966, 6.511894873000074],
                    [-1.47496941299994, 6.511607870000034],
                    [-1.474970446999976, 6.510690560000057],
                    [-1.475487920999967, 6.510118048000038],
                    [-1.475488824999957, 6.50943006500006],
                    [-1.474801590999959, 6.508454305000043],
                    [-1.474802429999954, 6.507880900000032],
                    [-1.474481473999958, 6.507766452000055],
                    [-1.474160515999927, 6.507652003000032],
                    [-1.474344938999934, 6.507020017000059],
                    [-1.474575110999979, 6.506676413000037],
                    [-1.474346027999957, 6.506159909000075],
                    [-1.473314068999969, 6.505527340000071],
                    [-1.473314609999932, 6.505183607000049],
                    [-1.474176324999974, 6.504669011000033],
                    [-1.474176480999972, 6.50446828500003],
                    [-1.474176559999933, 6.504367921000039],
                    [-1.47417663899995, 6.504267559000027],
                    [-1.473890653999945, 6.503693906000024],
                    [-1.473833833999947, 6.50326373300004],
                    [-1.473802045999946, 6.502154688000076],
                    [-1.475183776999927, 6.501035530000024],
                    [-1.475409247999949, 6.500272732000042],
                    [-1.475634715999945, 6.499509934000059],
                    [-1.476010539999947, 6.498896806000062],
                    [-1.476386361999971, 6.498283678000064],
                    [-1.476398916999926, 6.49807988200007],
                    [-1.476411473999974, 6.497876087000066],
                    [-1.476424029999976, 6.497672291000072],
                    [-1.476436585999977, 6.497468495000021],
                    [-1.476442691999978, 6.497367005000058],
                    [-1.47678661599997, 6.496907856000064],
                    [-1.477762188999975, 6.496218438000028],
                    [-1.478736924999964, 6.495013505000031],
                    [-1.479711661999943, 6.49380857400007],
                    [-1.480170308999959, 6.493349313000067],
                    [-1.480802449999942, 6.493462947000069],
                    [-1.481664380999973, 6.493747452000036],
                    [-1.481692924999948, 6.493647148000036],
                    [-1.481721467999932, 6.493546844000036],
                    [-1.481778554999948, 6.493346236000036],
                    [-1.481834755999955, 6.49248676600007],
                    [-1.48212076599998, 6.491454952000026],
                    [-1.482062286999962, 6.490825091000033],
                    [-1.48280798899998, 6.490078680000067],
                    [-1.48286453399993, 6.489219383000034],
                    [-1.483438016999969, 6.488702807000038],
                    [-1.483637400999953, 6.488602771000046],
                    [-1.483968112999946, 6.488436964000073],
                    [-1.483838965999951, 6.487899866000021],
                    [-1.483319902999938, 6.486411544000021],
                    [-1.483289189999937, 6.486358506000045],
                    [-1.483619445999977, 6.485668315000055],
                    [-1.483949699999926, 6.484978123000076],
                    [-1.484006511999951, 6.484491158000026],
                    [-1.484063323999976, 6.484004193000033],
                    [-1.483947488999945, 6.483202261000031],
                    [-1.484174750999955, 6.481540586000051],
                    [-1.484402013999954, 6.479878911000071],
                    [-1.484543234999933, 6.47813142800004],
                    [-1.48465127399993, 6.476794568000059],
                    [-1.484684456999958, 6.476383944000077],
                    [-1.485486784999978, 6.474892810000028],
                    [-1.48577279899996, 6.474061635000055],
                    [-1.486058811999953, 6.473230460000025],
                    [-1.485971431999928, 6.472371385000031],
                    [-1.485949117999951, 6.472151996000036],
                    [-1.485916546999931, 6.471831790000067],
                    [-1.485842097999978, 6.471522411000024],
                    [-1.48581143399997, 6.471394994000036],
                    [-1.48542359299995, 6.470768427000053],
                    [-1.484561091999979, 6.470025616000044],
                    [-1.484559873999956, 6.469108998000024],
                    [-1.484415468999941, 6.468507733000024],
                    [-1.484285515999943, 6.467906509000045],
                    [-1.483499811999934, 6.467493626000021],
                    [-1.482353042999932, 6.466863875000058],
                    [-1.482265549999966, 6.466784432000054],
                    [-1.482157522999955, 6.466686345000028],
                    [-1.480826738999951, 6.465477233000058],
                    [-1.48020534799997, 6.464912652000066],
                    [-1.48012608099998, 6.464840632000062],
                    [-1.478355714999964, 6.463213831000076],
                    [-1.478191035999942, 6.463062507000075],
                    [-1.478084564999961, 6.462964670000076],
                    [-1.478006065999978, 6.462934112000028],
                    [-1.477900360999968, 6.46293421200005],
                    [-1.477489307999974, 6.462934597000071],
                    [-1.476626598999928, 6.463511152000024],
                    [-1.475822628999936, 6.463627170000052],
                    [-1.474041848999946, 6.46322961900006],
                    [-1.473820521999926, 6.463053698000067],
                    [-1.472891727999979, 6.462315446000048],
                    [-1.472258736999947, 6.461056367000026],
                    [-1.471970160999945, 6.460255108000069],
                    [-1.471165493999933, 6.459798231000036],
                    [-1.470073842999966, 6.459513915000059],
                    [-1.468982191999942, 6.459229597000046],
                    [-1.46835065199997, 6.459345273000054],
                    [-1.466859086999932, 6.460436940000022],
                    [-1.465700022999954, 6.460928529000057],
                    [-1.465366581999945, 6.461069949000034],
                    [-1.464678461999938, 6.462045436000039],
                    [-1.464334165999958, 6.462275079000051],
                    [-1.463826026999925, 6.463624459000073],
                    [-1.463119202999962, 6.463533268000049],
                    [-1.462314493999941, 6.463408567000045],
                    [-1.461952424999936, 6.463323005000063],
                    [-1.461597164999944, 6.463215028000036],
                    [-1.461290653999924, 6.46312186800003],
                    [-1.460984142999962, 6.463028707000035],
                    [-1.460667804999957, 6.462932559000024],
                    [-1.459716219999962, 6.462643334000063],
                    [-1.459163890999946, 6.462357129000054],
                    [-1.458691809999948, 6.462241254000048],
                    [-1.458333284999981, 6.462357293000025],
                    [-1.457725220999976, 6.462676582000029],
                    [-1.456682267999952, 6.462605077000035],
                    [-1.456968930999949, 6.461316919000069],
                    [-1.456597518999956, 6.459948310000073],
                    [-1.456430694999938, 6.459799416000067],
                    [-1.456074146999924, 6.459622096000032],
                    [-1.455717598999968, 6.459444777000044],
                    [-1.455493172999979, 6.459272765000037],
                    [-1.455268746999934, 6.459100754000076],
                    [-1.454416679999952, 6.458401642000069],
                    [-1.453887124999937, 6.457954657000073],
                    [-1.453633942999943, 6.457696694000049],
                    [-1.453380760999949, 6.457438731000025],
                    [-1.452977690999944, 6.45704883600007],
                    [-1.452809841999965, 6.456867078000073],
                    [-1.452585958999975, 6.456624642000065],
                    [-1.452213851999943, 6.456382144000031],
                    [-1.451929976999963, 6.456207967000068],
                    [-1.451541369999973, 6.456037345000027],
                    [-1.451265716999956, 6.455943421000029],
                    [-1.451174643999934, 6.455534438000029],
                    [-1.451035399999967, 6.45476670000005],
                    [-1.450029796999956, 6.453449834000025],
                    [-1.449707972999931, 6.453360144000044],
                    [-1.448363512999947, 6.452985445000024],
                    [-1.447091496999974, 6.452735716000063],
                    [-1.446963320999942, 6.452195086000074],
                    [-1.446852770999953, 6.451546223000037],
                    [-1.447309730999962, 6.45143009700007],
                    [-1.448337521999974, 6.451171539000029],
                    [-1.449592954999957, 6.450197734000028],
                    [-1.449655496999981, 6.450098487000048],
                    [-1.450119363999931, 6.449362386000075],
                    [-1.450378306999937, 6.448497183000029],
                    [-1.450484847999974, 6.448265744000025],
                    [-1.450613604999944, 6.44798604500005],
                    [-1.450752836999925, 6.44772354600002],
                    [-1.451259218999951, 6.446768843000029],
                    [-1.451168395999957, 6.446182733000057],
                    [-1.450668906999965, 6.44581396500007],
                    [-1.45008104599998, 6.445569422000062],
                    [-1.44980566299995, 6.445176642000035],
                    [-1.449176870999963, 6.445019986000034],
                    [-1.448468998999942, 6.444293515000027],
                    [-1.448252347999926, 6.443664869000031],
                    [-1.447505409999962, 6.443193895000036],
                    [-1.447053344999972, 6.442938826000045],
                    [-1.446922814999937, 6.442849969000065],
                    [-1.446620890999952, 6.44264443700007],
                    [-1.445987475999971, 6.442575423000051],
                    [-1.44535560099996, 6.442490687000031],
                    [-1.444494322999958, 6.442836378000038],
                    [-1.444035954999947, 6.443409840000072],
                    [-1.443662598999936, 6.443496486000072],
                    [-1.443289240999945, 6.443583131000025],
                    [-1.442254846999958, 6.443126922000033],
                    [-1.442192888999955, 6.44269831400004],
                    [-1.442138918999945, 6.44232497400003],
                    [-1.442074441999978, 6.442196788000047],
                    [-1.44202383399994, 6.442096176000064],
                    [-1.441908746999957, 6.44186737800004],
                    [-1.441994449999925, 6.441580685000076],
                    [-1.44208015199996, 6.441293993000045],
                    [-1.442022719999954, 6.441007683000066],
                    [-1.441678947999947, 6.441008239000041],
                    [-1.441333389999954, 6.441008797000052],
                    [-1.441103712999961, 6.441123917000027],
                    [-1.44075828299998, 6.440437091000035],
                    [-1.440298706999954, 6.440208848000054],
                    [-1.440011818999949, 6.440495799000075],
                    [-1.439551796999979, 6.440152977000025],
                    [-1.439206862999924, 6.439838571000053],
                    [-1.438861928999927, 6.439524165000023],
                    [-1.438114924999979, 6.439353714000049],
                    [-1.43765495599996, 6.43906826500006],
                    [-1.436851135999973, 6.439126845000033],
                    [-1.436333883999964, 6.438726866000025],
                    [-1.435271056999966, 6.43864291400007],
                    [-1.434208228999978, 6.438558963000048],
                    [-1.433863932999941, 6.438788929000054],
                    [-1.433232308999948, 6.43878998200006],
                    [-1.432601512999952, 6.439364098000055],
                    [-1.432256411999958, 6.439049772000033],
                    [-1.43191130799994, 6.438735448000045],
                    [-1.431337041999939, 6.438736450000022],
                    [-1.429727525999965, 6.437650775000066],
                    [-1.429095853999968, 6.437594447000038],
                    [-1.42877933799997, 6.437165517000039],
                    [-1.428462821999972, 6.436736587000041],
                    [-1.428289780999933, 6.435992058000068],
                    [-1.428057541999976, 6.435825381000029],
                    [-1.427825301999974, 6.435658705000037],
                    [-1.427254828999935, 6.435249284000065],
                    [-1.427115973999946, 6.435012662000076],
                    [-1.426506390999975, 6.433761422000032],
                    [-1.425126861999956, 6.432904352000037],
                    [-1.424523703999967, 6.432848338000042],
                    [-1.423920545999977, 6.432792325000037],
                    [-1.422770483999955, 6.431763103000037],
                    [-1.422671506999961, 6.430591554000046],
                    [-1.429328536999947, 6.429001309000057],
                    [-1.436123789999954, 6.427429938000046],
                    [-1.438735121999969, 6.426826052000024],
                    [-1.440005983999924, 6.426532153000039],
                    [-1.447297415999969, 6.424846012000046],
                    [-1.445983211999931, 6.420417057000066],
                    [-1.445667819999926, 6.419354156000054],
                    [-1.445196925999937, 6.417767181000045],
                    [-1.44445664999995, 6.415272336000044],
                    [-1.443012004999957, 6.41040356700006],
                    [-1.442413690999956, 6.408387086000062],
                    [-1.441919502999951, 6.406721526000069],
                    [-1.441292316999977, 6.404607902000066],
                    [-1.44020424799993, 6.400941049000039],
                    [-1.438230505999968, 6.39428926000005],
                    [-1.436397181999951, 6.388110522000034],
                    [-1.43531416999997, 6.384460431000036],
                    [-1.430993573999956, 6.38424446700003],
                    [-1.426672978999932, 6.384028468000054],
                    [-1.426262299999962, 6.378918078000027],
                    [-1.427556032999973, 6.377430024000034],
                    [-1.430459510999924, 6.373124984000071],
                    [-1.433736839999938, 6.368796012000075],
                    [-1.43811612199994, 6.369626241000049],
                    [-1.435471395999969, 6.361556452000059],
                    [-1.439838494999947, 6.355270985000061],
                    [-1.444205593999925, 6.348985519000053],
                    [-1.442450171999951, 6.343498273000023],
                    [-1.447866879999935, 6.339789372000041],
                    [-1.448658342999977, 6.338960966000059],
                    [-1.450996609999947, 6.336321800000064],
                    [-1.455375045999972, 6.33137982900007],
                    [-1.458285757999931, 6.328094419000024],
                    [-1.459743228999969, 6.327213991000065],
                    [-1.461858185999972, 6.325936376000072],
                    [-1.461686626999949, 6.326280607000058],
                    [-1.461543507999977, 6.326652985000067],
                    [-1.461400389999937, 6.327025362000029],
                    [-1.46174500799998, 6.32725386900006],
                    [-1.461803328999963, 6.327769679000028],
                    [-1.46237739299994, 6.327682760000073],
                    [-1.462951456999974, 6.327595841000061],
                    [-1.463181882999947, 6.327996230000053],
                    [-1.463986617999979, 6.32896865400005],
                    [-1.464503739999941, 6.329139458000043],
                    [-1.46502086299995, 6.329310259000067],
                    [-1.465538274999972, 6.329997094000021],
                    [-1.465539877999959, 6.331114188000072],
                    [-1.465541480999946, 6.332231285000034],
                    [-1.465714033999973, 6.332517402000065],
                    [-1.465915479999978, 6.332860698000047],
                    [-1.466288847999976, 6.332974252000042],
                    [-1.466605012999935, 6.333346134000067],
                    [-1.466921180999975, 6.333718013000066],
                    [-1.466922383999929, 6.334290904000056],
                    [-1.467496840999956, 6.334633950000068],
                    [-1.467554975999974, 6.335321195000063],
                    [-1.467785358999947, 6.335664206000047],
                    [-1.468531494999979, 6.335605641000029],
                    [-1.468904924999947, 6.335691022000049],
                    [-1.469239853999966, 6.336209437000036],
                    [-1.46987289499998, 6.33636757000005],
                    [-1.470025729999975, 6.336519538000061],
                    [-1.470542636999937, 6.336633131000042],
                    [-1.471039136999934, 6.336805554000023],
                    [-1.471409609999967, 6.33694747900006],
                    [-1.472553392999941, 6.337603410000042],
                    [-1.473667051999939, 6.337468048000062],
                    [-1.473988786999939, 6.337428941000042],
                    [-1.474160525999935, 6.336912753000036],
                    [-1.474389214999974, 6.336339308000049],
                    [-1.474848843999951, 6.336338715000068],
                    [-1.475267344999963, 6.336754930000041],
                    [-1.476055934999977, 6.337539216000039],
                    [-1.476251266999952, 6.337896499000067],
                    [-1.477495111999929, 6.34017164200003],
                    [-1.477897475999953, 6.340629584000055],
                    [-1.478243258999953, 6.341545200000041],
                    [-1.479402768999933, 6.343453437000051],
                    [-1.479912296999942, 6.344291983000062],
                    [-1.479740507999963, 6.344750626000064],
                    [-1.480545921999976, 6.345837596000024],
                    [-1.481466245999968, 6.347153442000035],
                    [-1.482156630999953, 6.348240517000022],
                    [-1.481584606999945, 6.34961650200006],
                    [-1.482307700999968, 6.349867526000025],
                    [-1.482520590999968, 6.349941431000047],
                    [-1.482733476999954, 6.350015337000059],
                    [-1.483192057999929, 6.349613282000064],
                    [-1.483479587999966, 6.349727420000022],
                    [-1.483537590999958, 6.350242881000042],
                    [-1.483761358999971, 6.350585803000058],
                    [-1.483825111999977, 6.350528799000074],
                    [-1.483997003999946, 6.350184906000038],
                    [-1.484341060999952, 6.349782957000059],
                    [-1.48480038799994, 6.350182947000064],
                    [-1.485145171999932, 6.350010671000064],
                    [-1.485489708999978, 6.350124410000035],
                    [-1.485490030999927, 6.350468487000057],
                    [-1.485605336999924, 6.350754222000035],
                    [-1.48618006199996, 6.35098249400005],
                    [-1.48663957499997, 6.351210875000049],
                    [-1.486812658999952, 6.351955381000039],
                    [-1.487559898999962, 6.352498190000063],
                    [-1.488307136999936, 6.353041],
                    [-1.48916855799996, 6.353038981000054],
                    [-1.489398394999967, 6.353239232000021],
                    [-1.48962823599993, 6.353439482000056],
                    [-1.490872250999928, 6.353545302000043],
                    [-1.490949408999938, 6.353551431000028],
                    [-1.491868388999933, 6.353950634000057],
                    [-1.495231779999926, 6.355589159000033],
                    [-1.494885477999958, 6.358206736000056],
                    [-1.494504326999959, 6.359000918000049],
                    [-1.494056289999946, 6.358357470000044],
                    [-1.493597097999952, 6.358472831000029],
                    [-1.493252043999973, 6.35818732000007],
                    [-1.492518267999969, 6.358229541000071],
                    [-1.490898009999967, 6.358191798000064],
                    [-1.489233727999931, 6.358767470000032],
                    [-1.488028032999978, 6.358769988000063],
                    [-1.48746101699993, 6.359148541000025],
                    [-1.486935628999959, 6.359662742000069],
                    [-1.48712450599993, 6.36051771700005],
                    [-1.487345882999932, 6.361519809000072],
                    [-1.485891377999963, 6.363739618000068],
                    [-1.485783776999938, 6.363903833000052],
                    [-1.484378042999936, 6.365662912000062],
                    [-1.483920653999974, 6.366235882000069],
                    [-1.483617717999948, 6.367256687000065],
                    [-1.48376271199993, 6.367516154000043],
                    [-1.484769050999944, 6.36931697700004],
                    [-1.486246937999965, 6.370841110000072],
                    [-1.487585591999959, 6.371545923000042],
                    [-1.488943017999929, 6.371678624000026],
                    [-1.489308488999939, 6.371714351000037],
                    [-1.489830187999928, 6.372002169000041],
                    [-1.49035188299996, 6.372289988000034],
                    [-1.490860162999979, 6.372570403000054],
                    [-1.491534877999925, 6.37275263500004],
                    [-1.491829392999932, 6.372832182000025],
                    [-1.492123908999929, 6.37291172700003],
                    [-1.492638252999939, 6.37358067100007],
                    [-1.492871592999961, 6.373884148000059],
                    [-1.493273731999977, 6.373883419000038],
                    [-1.493618372999947, 6.373997237000026],
                    [-1.494536191999941, 6.373594474000072],
                    [-1.495231284999932, 6.373506371000076],
                    [-1.496229942999946, 6.373430620000022],
                    [-1.496742475999952, 6.373391740000045],
                    [-1.497111540999924, 6.373421648000033],
                    [-1.497751813999969, 6.373473532000048],
                    [-1.498556249999979, 6.373815800000045],
                    [-1.498993801999973, 6.373778662000063],
                    [-1.500762934999955, 6.373814180000068],
                    [-1.500837381999929, 6.37386372900005],
                    [-1.50129770999996, 6.37401766000005],
                    [-1.501526439999964, 6.37403673600005],
                    [-1.501870791999977, 6.373939915000051],
                    [-1.501986448999958, 6.373862613000028],
                    [-1.502179300999956, 6.373823831000038],
                    [-1.50267531999998, 6.373842646000071],
                    [-1.502961876999962, 6.373820312000021],
                    [-1.503135365999981, 6.373707116000048],
                    [-1.503556828999933, 6.37356611000007],
                    [-1.504052927999965, 6.373667627000032],
                    [-1.504281768999931, 6.373799726000072],
                    [-1.504626532999964, 6.37412744300002],
                    [-1.505086840999979, 6.374259318000043],
                    [-1.505891405999932, 6.374200637000058],
                    [-1.506120192999958, 6.374277602000063],
                    [-1.506809419999968, 6.374621519000073],
                    [-1.507038207999926, 6.374698485000067],
                    [-1.507614117999935, 6.374697917000049],
                    [-1.507727058999933, 6.37465921200004],
                    [-1.507958562999931, 6.374697578000053],
                    [-1.508303233999925, 6.374926049000067],
                    [-1.508532284999944, 6.375270418000071],
                    [-1.50864805599997, 6.375308899000061],
                    [-1.509048969999981, 6.375289205000058],
                    [-1.509449884999981, 6.375269513000035],
                    [-1.509651109999936, 6.375338234000026],
                    [-1.510370231999957, 6.375257576000024],
                    [-1.511001322999959, 6.37532587100003],
                    [-1.511754003999954, 6.375741393000055],
                    [-1.511977283999954, 6.375821118000033],
                    [-1.512186913999926, 6.376030423000032],
                    [-1.512418456999967, 6.376107382000043],
                    [-1.51255068699993, 6.376068657000076],
                    [-1.512875596999947, 6.375820225000041],
                    [-1.513106946999926, 6.375704213000063],
                    [-1.513238587999979, 6.375072785000043],
                    [-1.513238472999944, 6.374957002000031],
                    [-1.513238245999958, 6.37472819200002],
                    [-1.513125171999945, 6.374631818000069],
                    [-1.512893686999973, 6.374612751000029],
                    [-1.512664993999977, 6.374632277000046],
                    [-1.512436301999969, 6.374651800000038],
                    [-1.512091742999928, 6.374536359000047],
                    [-1.511995186999968, 6.374423428000057],
                    [-1.51197566999997, 6.374194637000073],
                    [-1.512242656999945, 6.373888374000046],
                    [-1.51224252399993, 6.373756049000065],
                    [-1.512148605999926, 6.373524576000023],
                    [-1.51201337699996, 6.373315196000021],
                    [-1.512013262999972, 6.373199413000066],
                    [-1.512148076999949, 6.372989767000035],
                    [-1.512261014999979, 6.372951060000048],
                    [-1.512423583999976, 6.372941249000064],
                    [-1.512586150999937, 6.37293143900007],
                    [-1.51266322999993, 6.372854174000054],
                    [-1.512720926999975, 6.372683198000061],
                    [-1.512624197999969, 6.37239659200003],
                    [-1.51254692699996, 6.372280885000066],
                    [-1.512337449999961, 6.372223201000054],
                    [-1.512221754999928, 6.372261911000066],
                    [-1.511993006999944, 6.372223543000075],
                    [-1.511783451999975, 6.372088670000039],
                    [-1.511551949999955, 6.372053063000067],
                    [-1.511458070999936, 6.371860182000034],
                    [-1.511438439999949, 6.371515609000028],
                    [-1.511476791999939, 6.371286760000032],
                    [-1.511551077999968, 6.371170903000063],
                    [-1.511531672999979, 6.371055139000021],
                    [-1.511647197999935, 6.370845512000074],
                    [-1.511914238999964, 6.37059713900004],
                    [-1.512049050999963, 6.370384735000073],
                    [-1.512048689999972, 6.370020844000067],
                    [-1.512216444999979, 6.369684354000071],
                    [-1.512163911999949, 6.369505219000075],
                    [-1.512028699999973, 6.369312379000064],
                    [-1.512009052999929, 6.368951265000021],
                    [-1.511780115999954, 6.368719924000061],
                    [-1.51181844599995, 6.36847178000005],
                    [-1.511969792999935, 6.368262116000039],
                    [-1.511969677999957, 6.368146332000038],
                    [-1.511931042999947, 6.36808848000004],
                    [-1.511721507999937, 6.367972903000066],
                    [-1.511547419999943, 6.367475483000021],
                    [-1.511547191999966, 6.367245293000053],
                    [-1.511624119999965, 6.36701640800004],
                    [-1.51162349599997, 6.366385111000056],
                    [-1.511622870999929, 6.365753816000051],
                    [-1.511699795999959, 6.365522174000034],
                    [-1.512096130999964, 6.365058646000023],
                    [-1.512465070999951, 6.36475779500006],
                    [-1.51260265999997, 6.36457019900007],
                    [-1.512769943999956, 6.363762305000023],
                    [-1.512846869999976, 6.363530662000073],
                    [-1.513083568999946, 6.363254752000046],
                    [-1.513320266999926, 6.362978843000064],
                    [-1.514529183999969, 6.362227804000042],
                    [-1.514757661999965, 6.361998766000056],
                    [-1.515131916999962, 6.361504936000074],
                    [-1.51517862299994, 6.361367052000048],
                    [-1.51523917999998, 6.361303587000066],
                    [-1.515419304999966, 6.360942272000045],
                    [-1.515599426999927, 6.36058096000005],
                    [-1.515731499999958, 6.360387855000056],
                    [-1.51582738899998, 6.359833653000067],
                    [-1.515826930999935, 6.359373276000042],
                    [-1.515947804999939, 6.359006507000061],
                    [-1.516322038999931, 6.358493379000038],
                    [-1.516418251999937, 6.35826447200003],
                    [-1.516436965999958, 6.357688293000024],
                    [-1.517044836999958, 6.355129890000057],
                    [-1.518782348999935, 6.348536295000031],
                    [-1.519012387999965, 6.34849747100003],
                    [-1.51972006799997, 6.348036384000068],
                    [-1.51992938099994, 6.347939687000064],
                    [-1.520158064999976, 6.347922917000062],
                    [-1.521133566999936, 6.348010154000065],
                    [-1.521535769999957, 6.347921532000043],
                    [-1.521767204999946, 6.347902004000048],
                    [-1.52367953299995, 6.347974505000025],
                    [-1.524272160999942, 6.348186177000059],
                    [-1.524961321999967, 6.348491478000028],
                    [-1.525192776999972, 6.348491243000069],
                    [-1.525402090999933, 6.34839454400003],
                    [-1.525630616999933, 6.348223394000058],
                    [-1.525784723999948, 6.348030266000023],
                    [-1.525955093999926, 6.347572473000071],
                    [-1.526109162999944, 6.347340750000058],
                    [-1.526337707999971, 6.347188896000034],
                    [-1.526797759999965, 6.34709194200002],
                    [-1.527218982999955, 6.346741408000071],
                    [-1.52765693799995, 6.346592098000031],
                    [-1.527945963999969, 6.34630510300002],
                    [-1.52830128599993, 6.34618344200004],
                    [-1.528656609999928, 6.346061784000028],
                    [-1.529755915999942, 6.345964175000063],
                    [-1.529907195999954, 6.345913745000075],
                    [-1.530507776999968, 6.345610544000067],
                    [-1.530866255999968, 6.345671314000072],
                    [-1.531109008999977, 6.345732204000058],
                    [-1.531389700999966, 6.345802612000057],
                    [-1.531847171999971, 6.345876575000034],
                    [-1.532497444999933, 6.34587590600006],
                    [-1.532850045999965, 6.345788706000064],
                    [-1.533202646999939, 6.345701506000069],
                    [-1.533340320999969, 6.345607635000022],
                    [-1.533684627999946, 6.345494255000062],
                    [-1.533913283999937, 6.345455425000068],
                    [-1.534307439999964, 6.34558458600003],
                    [-1.534450940999932, 6.345799464000038],
                    [-1.534872947999929, 6.346218055000065],
                    [-1.535308258999976, 6.346176252000021],
                    [-1.53574356799993, 6.346134453000047],
                    [-1.535886737999931, 6.346026791000043],
                    [-1.536115395999957, 6.345987960000059],
                    [-1.536688260999938, 6.345739260000073],
                    [-1.536919652999927, 6.34568113000006],
                    [-1.537032604999979, 6.345661715000062],
                    [-1.537090487999933, 6.345680953000056],
                    [-1.537473536999926, 6.345728798000039],
                    [-1.537589251999975, 6.345719030000055],
                    [-1.538046390999966, 6.345470448000071],
                    [-1.538277662999974, 6.345296534000056],
                    [-1.538734777999935, 6.345028655000021],
                    [-1.538964293999925, 6.344949652000025],
                    [-1.539194391999956, 6.344928856000024],
                    [-1.539359371999979, 6.344833317000052],
                    [-1.539598334999937, 6.344627504000073],
                    [-1.539874368999961, 6.343770287000041],
                    [-1.539950332999979, 6.343559003000053],
                    [-1.540497058999961, 6.342910262000032],
                    [-1.542928752999956, 6.344828363000033],
                    [-1.545087566999939, 6.346531194000022],
                    [-1.545648665999977, 6.346973776000027],
                    [-1.547285526999929, 6.347528071000056],
                    [-1.547847555999965, 6.347352914000055],
                    [-1.548733876999961, 6.347076686000037],
                    [-1.549307988999942, 6.346676205000051],
                    [-1.54993607199998, 6.345825610000077],
                    [-1.550195561999942, 6.346033666000039],
                    [-1.550446450999971, 6.346234829000025],
                    [-1.550945353999964, 6.346399703000031],
                    [-1.55127041999998, 6.34633595300005],
                    [-1.551595489999954, 6.346272201000033],
                    [-1.552168651999978, 6.34631018500005],
                    [-1.552629127999978, 6.346615693000047],
                    [-1.553164244999948, 6.347152684000037],
                    [-1.553566673999967, 6.347284579000075],
                    [-1.553506150999965, 6.347647894000033],
                    [-1.553427043999932, 6.348122775000036],
                    [-1.554170953999972, 6.348086739000053],
                    [-1.554503040999975, 6.348038369000051],
                    [-1.554573421999976, 6.348028118000059],
                    [-1.55506687999997, 6.347956245000034],
                    [-1.555500234999954, 6.347893124000052],
                    [-1.555938995999952, 6.347862058000032],
                    [-1.556355826999948, 6.347832543000038],
                    [-1.556706585999962, 6.347807705000037],
                    [-1.556725779999965, 6.347806347000073],
                    [-1.556983479999928, 6.34778809900007],
                    [-1.557241182999974, 6.34776985000002],
                    [-1.557699076999938, 6.347737428000073],
                    [-1.558011389999933, 6.347715311000059],
                    [-1.558162317999972, 6.347704624000073],
                    [-1.558507534999933, 6.347680179000065],
                    [-1.559077842999955, 6.347639794000031],
                    [-1.559460841999964, 6.347639381000022],
                    [-1.559995467999954, 6.347713234000025],
                    [-1.560339934999945, 6.347751456000026],
                    [-1.560838949999948, 6.348018319000062],
                    [-1.561106324999969, 6.34811451500002],
                    [-1.561412342999972, 6.348268561000054],
                    [-1.561795404999941, 6.348326037000049],
                    [-1.562139827999943, 6.348325663000026],
                    [-1.56248425299998, 6.348325290000048],
                    [-1.562982834999957, 6.348192426000026],
                    [-1.563805201999969, 6.348084017000076],
                    [-1.564627568999924, 6.347975610000049],
                    [-1.56497190999994, 6.347898047000058],
                    [-1.565239098999939, 6.347820567000042],
                    [-1.565580639999951, 6.347704413000031],
                    [-1.565847831999974, 6.34762968800004],
                    [-1.566117689999942, 6.347475017000022],
                    [-1.566423454999949, 6.347397496000042],
                    [-1.566709890999959, 6.347284156000057],
                    [-1.566957707999961, 6.347129507000034],
                    [-1.567913698999973, 6.347012678000056],
                    [-1.568567040999937, 6.347301418000029],
                    [-1.569101900999954, 6.347587530000055],
                    [-1.569534823999959, 6.347884781000062],
                    [-1.569894481999938, 6.348253556000031],
                    [-1.570136662999971, 6.348501874000021],
                    [-1.570496103999972, 6.348870428000055],
                    [-1.570618683999953, 6.348996112000066],
                    [-1.570959590999962, 6.349345657000072],
                    [-1.571132097999964, 6.349614247000034],
                    [-1.571132477999925, 6.34995883800002],
                    [-1.570981477999965, 6.350455216000057],
                    [-1.570943238999973, 6.350761254000076],
                    [-1.570599447999939, 6.351337788000023],
                    [-1.570503345999953, 6.351643891000037],
                    [-1.570368625999947, 6.351911442000073],
                    [-1.570178923999947, 6.352294836000056],
                    [-1.570111562999955, 6.35242861200004],
                    [-1.569796721999978, 6.353023033000056],
                    [-1.569532747999972, 6.353519533000053],
                    [-1.569301546999952, 6.353751353000064],
                    [-1.569227443999978, 6.354018837000069],
                    [-1.56910228299995, 6.354210567000052],
                    [-1.568690769999932, 6.354595582000059],
                    [-1.568443056999968, 6.354846718000033],
                    [-1.568035703999954, 6.355257916000028],
                    [-1.567832210999939, 6.355630298000051],
                    [-1.567813469999976, 6.356129287000044],
                    [-1.567926735999947, 6.356396565000068],
                    [-1.568062065999925, 6.356683115000067],
                    [-1.568120285999953, 6.357008346000043],
                    [-1.568197735999945, 6.357278419000068],
                    [-1.56827244699997, 6.357565037000029],
                    [-1.568311464999965, 6.357967477000045],
                    [-1.568466063999949, 6.358234709000044],
                    [-1.568637193999962, 6.358501924000052],
                    [-1.568811080999978, 6.358769134000056],
                    [-1.569194342999936, 6.359000278000053],
                    [-1.569652038999948, 6.35926717600006],
                    [-1.569922137999924, 6.359324771000047],
                    [-1.570572653999932, 6.359533565000049],
                    [-1.570801564999954, 6.359723525000049],
                    [-1.570994703999929, 6.359954879000043],
                    [-1.571262426999965, 6.360357063000038],
                    [-1.571433686999967, 6.360740060000069],
                    [-1.571607765999943, 6.361178186000075],
                    [-1.571721055999944, 6.361464760000047],
                    [-1.571837125999934, 6.361773385000049],
                    [-1.572030406999943, 6.362134302000072],
                    [-1.572259490999954, 6.362478639000074],
                    [-1.572681650999925, 6.36299643600006],
                    [-1.573137775999953, 6.363329018000059],
                    [-1.573738049999974, 6.363630011000055],
                    [-1.575016655999946, 6.363690336000047],
                    [-1.575761476999958, 6.363725474000034],
                    [-1.577800473999957, 6.363965676000021],
                    [-1.578172132999953, 6.364418306000061],
                    [-1.578338304999932, 6.36441811900005],
                    [-1.578822423999952, 6.36441757700004],
                    [-1.57891882499996, 6.364381631000072],
                    [-1.579626936999944, 6.364342244000056],
                    [-1.580180024999947, 6.364195966000068],
                    [-1.580401393999978, 6.36418399400003],
                    [-1.580747654999925, 6.364261940000063],
                    [-1.581170653999948, 6.364428438000061],
                    [-1.581217674999948, 6.364446947000033],
                    [-1.581559732999949, 6.364450687000044],
                    [-1.581732629999976, 6.364492907000056],
                    [-1.58177821299995, 6.364504038000064],
                    [-1.582383801999924, 6.364822724000021],
                    [-1.58233082199996, 6.367111776000058],
                    [-1.582191932999933, 6.367327918000058],
                    [-1.582108614999925, 6.36745324900005],
                    [-1.581250034999925, 6.368772657000022],
                    [-1.579734415999951, 6.369493306000038],
                    [-1.578811150999968, 6.369511093000028],
                    [-1.578462358999957, 6.369553521000057],
                    [-1.578508798999962, 6.369710734000023],
                    [-1.578583030999937, 6.369784834000029],
                    [-1.57856395999994, 6.369842286000051],
                    [-1.578635888999941, 6.369995356000061],
                    [-1.578657519999979, 6.370086267000033],
                    [-1.578693482999938, 6.370162802000038],
                    [-1.578698359999976, 6.370244157000059],
                    [-1.578735260999963, 6.370245382000064],
                    [-1.578832023999951, 6.370531973000027],
                    [-1.578928624999946, 6.370815824000033],
                    [-1.579010048999976, 6.370904272000075],
                    [-1.57914180399996, 6.371081205000053],
                    [-1.579235218999941, 6.371195963000048],
                    [-1.579216089999932, 6.371203164000065],
                    [-1.579275953999968, 6.37126052900004],
                    [-1.579309550999938, 6.371358603000033],
                    [-1.579383760999974, 6.371413558000029],
                    [-1.579465256999924, 6.371564226000032],
                    [-1.579541862999974, 6.371621571000048],
                    [-1.579616176999934, 6.371767459000068],
                    [-1.579654518999973, 6.371829634000051],
                    [-1.579652143999965, 6.371846388000051],
                    [-1.579997103999972, 6.372310241000037],
                    [-1.580013851999979, 6.372312613000076],
                    [-1.580018758999927, 6.372425080000028],
                    [-1.580114526999978, 6.372503940000058],
                    [-1.580117004999977, 6.37258051200007],
                    [-1.580155358999946, 6.372654652000051],
                    [-1.580157980999957, 6.372858055000052],
                    [-1.580116062999934, 6.372961958000076],
                    [-1.580116149999981, 6.373039146000053],
                    [-1.580074553999964, 6.373118982000051],
                    [-1.580021969999962, 6.37315254300006],
                    [-1.579947984999933, 6.373300991000065],
                    [-1.579885867999963, 6.373365671000045],
                    [-1.579768833999935, 6.373518955000065],
                    [-1.579768936999926, 6.373609887000043],
                    [-1.579728276999958, 6.373612327000046],
                    [-1.579233573999943, 6.373995759000024],
                    [-1.579276628999935, 6.37399571100002],
                    [-1.579240788999925, 6.374031647000038],
                    [-1.579202605999967, 6.374110658000063],
                    [-1.579102211999952, 6.37417059400002],
                    [-1.57904968899993, 6.374259195000036],
                    [-1.578946866999956, 6.374288025000055],
                    [-1.578906251999967, 6.374331144000053],
                    [-1.578796322999949, 6.374419808000027],
                    [-1.578748562999976, 6.374491652000074],
                    [-1.578657716999942, 6.374534827000048],
                    [-1.578600387999927, 6.374604289000047],
                    [-1.578507156999933, 6.374652252000033],
                    [-1.578445031999934, 6.374712148000071],
                    [-1.57835784599996, 6.374819115000037],
                    [-1.57835787099998, 6.374842087000047],
                    [-1.577822372999947, 6.37510917000003],
                    [-1.577823947999946, 6.375148989000024],
                    [-1.577782698999954, 6.375222547000021],
                    [-1.577573189999953, 6.375418815000046],
                    [-1.577517684999975, 6.375495542000067],
                    [-1.577286476999973, 6.375724608000041],
                    [-1.577244489999941, 6.375805124000067],
                    [-1.577180227999975, 6.375835825000024],
                    [-1.57709611599995, 6.375912495000023],
                    [-1.57705806499996, 6.375992266000026],
                    [-1.576634403999947, 6.376453635000075],
                    [-1.576677264999944, 6.376452056000062],
                    [-1.57667582299996, 6.37653016400003],
                    [-1.576594751999949, 6.376588452000021],
                    [-1.576542762999964, 6.376642114000049],
                    [-1.576498439999966, 6.376706487000035],
                    [-1.576427925999951, 6.376778635000051],
                    [-1.57633167299997, 6.376949660000037],
                    [-1.57619953699998, 6.377065590000029],
                    [-1.576026190999926, 6.377294591000066],
                    [-1.575968390999947, 6.377352547000044],
                    [-1.57594920799994, 6.377449053000021],
                    [-1.575492259999976, 6.377871342000049],
                    [-1.575492302999976, 6.377909936000037],
                    [-1.575453808999953, 6.377984410000067],
                    [-1.575415273999965, 6.378023047000056],
                    [-1.575376782999967, 6.378100278000034],
                    [-1.575299755999936, 6.378216147000046],
                    [-1.575203397999928, 6.378293442000029],
                    [-1.575129167999933, 6.378445145000057],
                    [-1.57507138699998, 6.37852239700004],
                    [-1.574955907999936, 6.378751334000071],
                    [-1.57487879699994, 6.37879001400006],
                    [-1.57487888199995, 6.378867202000038],
                    [-1.574460507999959, 6.379289448000065],
                    [-1.574496373999978, 6.379328001000033],
                    [-1.574496455999963, 6.379402432000063],
                    [-1.574347994999926, 6.379708595000068],
                    [-1.574309461999974, 6.379747232000057],
                    [-1.57427096999993, 6.379824462000045],
                    [-1.57427105599993, 6.379901650000022],
                    [-1.574251831999959, 6.379959564000046],
                    [-1.57423393199997, 6.380013930000075],
                    [-1.574230192999948, 6.380094340000028],
                    [-1.574193915999956, 6.38016712700005],
                    [-1.574176763999958, 6.380230320000067],
                    [-1.574203696999973, 6.380358554000054],
                    [-1.574351599999943, 6.380858045000025],
                    [-1.57447435399996, 6.380981346000056],
                    [-1.574658115999966, 6.381165921000047],
                    [-1.57481908099993, 6.381366753000066],
                    [-1.575087768999936, 6.381627783000056],
                    [-1.575177309999958, 6.381714771000077],
                    [-1.575366745999929, 6.381806606000055],
                    [-1.575858915999959, 6.382045199000061],
                    [-1.576188559999935, 6.382044239000038],
                    [-1.576568911999971, 6.382118245000072],
                    [-1.576723268999956, 6.38215666800005],
                    [-1.576949266999975, 6.382195008000053],
                    [-1.577065001999927, 6.382194878000064],
                    [-1.577964693999945, 6.382193870000037],
                    [-1.578201186999934, 6.382192395000061],
                    [-1.578263164999953, 6.382207287000028],
                    [-1.578348675999962, 6.382252079000068],
                    [-1.578496131999941, 6.382283974000075],
                    [-1.578570978999949, 6.382343738000031],
                    [-1.57871634299994, 6.382416247000037],
                    [-1.578803989999926, 6.382458897000049],
                    [-1.57887878799994, 6.382475913000064],
                    [-1.578904454999929, 6.382503670000062],
                    [-1.579032894999955, 6.382721544000049],
                    [-1.579174171999966, 6.382958639000037],
                    [-1.57920835699997, 6.382958601000041],
                    [-1.57921268399997, 6.38300775600004],
                    [-1.579229832999943, 6.383056899000053],
                    [-1.579285477999974, 6.383142333000023],
                    [-1.579289808999931, 6.38319576300006],
                    [-1.579360469999926, 6.383332480000036],
                    [-1.579362704999937, 6.383420112000067],
                    [-1.579478330999962, 6.383644412000024],
                    [-1.579497647999972, 6.383723475000068],
                    [-1.57963250499995, 6.383949891000043],
                    [-1.579634732999978, 6.384031110000024],
                    [-1.579664684999955, 6.384067413000025],
                    [-1.580207757999972, 6.384415202000071],
                    [-1.580256872999939, 6.384391635000043],
                    [-1.580412885999976, 6.384432071000049],
                    [-1.580509135999932, 6.384526008000023],
                    [-1.580590348999976, 6.384547291000047],
                    [-1.580667325999968, 6.384602777000055],
                    [-1.58073573799993, 6.384639037000056],
                    [-1.580911082999933, 6.384771360000059],
                    [-1.581047975999979, 6.384908],
                    [-1.581124934999934, 6.38494638700007],
                    [-1.581280530999948, 6.385057791000065],
                    [-1.581420015999925, 6.385157660000061],
                    [-1.582018580999943, 6.385451949000071],
                    [-1.582892806999951, 6.385786535000022],
                    [-1.583298981999974, 6.385989131000031],
                    [-1.583536470999945, 6.386283827000057],
                    [-1.583517293999932, 6.386328735000063],
                    [-1.583534466999936, 6.386399251000057],
                    [-1.583575139999937, 6.386469741000042],
                    [-1.583575232999976, 6.386550962000058],
                    [-1.583613777999972, 6.386627865000037],
                    [-1.583613870999955, 6.386711224000067],
                    [-1.583633956999961, 6.386782929000049],
                    [-1.583653333999962, 6.386860095000031],
                    [-1.583730574999947, 6.386934438000026],
                    [-1.583730660999947, 6.38701162600006],
                    [-1.58376932699997, 6.387088771000037],
                    [-1.58376941399996, 6.387165959000072],
                    [-1.583805323999968, 6.387243107000074],
                    [-1.583805409999968, 6.387317537000058],
                    [-1.583844073999956, 6.387394682000036],
                    [-1.583844162999981, 6.387471869000024],
                    [-1.583882827999957, 6.387549013000068],
                    [-1.58384429399996, 6.387587651000047],
                    [-1.584494871999937, 6.387815721000038],
                    [-1.58453349499996, 6.387854272000027],
                    [-1.584610651999981, 6.387854183000059],
                    [-1.58476509299993, 6.387967033000052],
                    [-1.584839581999972, 6.388044137000065],
                    [-1.584994025999947, 6.388159743000074],
                    [-1.585338865999972, 6.388503942000057],
                    [-1.585396819999971, 6.388581063000061],
                    [-1.585454732999949, 6.388619591000065],
                    [-1.58583836899993, 6.389153958000065],
                    [-1.585893501999976, 6.389173193000033],
                    [-1.58602867999997, 6.389308117000041],
                    [-1.586067343999957, 6.389382504000025],
                    [-1.586144544999968, 6.389421010000035],
                    [-1.586219121999932, 6.389575302000026],
                    [-1.586296365999942, 6.389652403000071],
                    [-1.586393070999975, 6.389881099000036],
                    [-1.58648969199993, 6.39003260800007],
                    [-1.586528311999928, 6.390071158000069],
                    [-1.586564224999961, 6.390148305000025],
                    [-1.586602801999959, 6.390148261000036],
                    [-1.586565008999969, 6.390837484000031],
                    [-1.586603631999935, 6.39087603400003],
                    [-1.586604283999975, 6.391448494000031],
                    [-1.586604830999931, 6.391929097000059],
                    [-1.586585629999945, 6.392006306000042],
                    [-1.586604940999962, 6.392025581000041],
                    [-1.586605636999934, 6.392637571000023],
                    [-1.586644260999947, 6.392676121000022],
                    [-1.586644347999936, 6.392753310000046],
                    [-1.586605854999959, 6.392827784000076],
                    [-1.586644520999926, 6.392904928000064],
                    [-1.586621273999924, 6.393316777000052],
                    [-1.586643880999929, 6.393384368000056],
                    [-1.586644290999971, 6.393744991000062],
                    [-1.586209103999977, 6.394091084000024],
                    [-1.586058870999977, 6.394061202000046],
                    [-1.585995554999954, 6.394071834000044],
                    [-1.585923715999968, 6.394083896000041],
                    [-1.585848435999935, 6.394087256000034],
                    [-1.585750992999976, 6.394091605000028],
                    [-1.585660126999926, 6.394127258000026],
                    [-1.585608328999967, 6.394147580000038],
                    [-1.585556235999945, 6.394168020000052],
                    [-1.585443168999973, 6.394167086000039],
                    [-1.585193121999964, 6.394310491000056],
                    [-1.585091156999965, 6.394354661000023],
                    [-1.584985321999966, 6.394400509000036],
                    [-1.584724386999937, 6.394867387000033],
                    [-1.584708014999933, 6.394896681000034],
                    [-1.584738181999967, 6.395009341000048],
                    [-1.584713041999976, 6.395249921000072],
                    [-1.584717341999976, 6.39555221300003],
                    [-1.58487759999997, 6.396602261000055],
                    [-1.585481643999969, 6.396251497000037],
                    [-1.58626495599998, 6.395948773000043],
                    [-1.586817125999971, 6.395677122000052],
                    [-1.587866906999977, 6.395644098000048],
                    [-1.588535483999976, 6.39608888600003],
                    [-1.589045177999935, 6.396692980000068],
                    [-1.589542241999936, 6.396601786000076],
                    [-1.589882314999954, 6.396539393000069],
                    [-1.590480824999929, 6.39625693000005],
                    [-1.590897505999976, 6.396230170000024],
                    [-1.591360300999952, 6.395954119000066],
                    [-1.591672331999973, 6.395767996000075],
                    [-1.591680799999949, 6.395762945000058],
                    [-1.591987988999961, 6.39557971000005],
                    [-1.592320781999945, 6.395445737000045],
                    [-1.592753701999925, 6.395271455000056],
                    [-1.59356005799998, 6.395026887000029],
                    [-1.594186128999979, 6.394837],
                    [-1.595145009999953, 6.394769729000075],
                    [-1.595642242999929, 6.394634075000056],
                    [-1.596139457999925, 6.394481880000058],
                    [-1.596213745999933, 6.394385309000029],
                    [-1.596733238999946, 6.394042904000059],
                    [-1.597667605999959, 6.39342704400002],
                    [-1.598509932999946, 6.392659700000024],
                    [-1.599617992999924, 6.391736291000029],
                    [-1.600394783999946, 6.391487282000071],
                    [-1.600537120999945, 6.391849623000041],
                    [-1.600575788999947, 6.391926767000029],
                    [-1.600653036999972, 6.39200386400006],
                    [-1.600766283999974, 6.39223253800003],
                    [-1.600843530999953, 6.39230963600005],
                    [-1.600882198999955, 6.392386778000059],
                    [-1.600998066999978, 6.392499668000028],
                    [-1.601149870999961, 6.392711757000029],
                    [-1.601188472999979, 6.392731009000045],
                    [-1.60153341399996, 6.393149625000035],
                    [-1.601629883999976, 6.39316881000002],
                    [-1.602060050999967, 6.393417788000022],
                    [-1.602294229999927, 6.394027694000044],
                    [-1.602599182999938, 6.394593881000048],
                    [-1.603402868999979, 6.395184851000067],
                    [-1.604468726999926, 6.395893895000029],
                    [-1.603965461999962, 6.397292007000033],
                    [-1.603270919999943, 6.397992358000067],
                    [-1.60369604999994, 6.398576424000055],
                    [-1.604194283999959, 6.399293960000023],
                    [-1.604483986999981, 6.399599614000067],
                    [-1.604961213999957, 6.400023585000042],
                    [-1.605438439999944, 6.400447556000074],
                    [-1.605728067999962, 6.40068980500007],
                    [-1.606072729999937, 6.400863070000071],
                    [-1.607222329999956, 6.401280732000032],
                    [-1.608024317999934, 6.401356972000031],
                    [-1.608886722999955, 6.401259467000045],
                    [-1.609402002999957, 6.401236802000028],
                    [-1.611291551999955, 6.401181704000066],
                    [-1.611701137999944, 6.401153858000043],
                    [-1.612186031999954, 6.401204664000034],
                    [-1.612944940999967, 6.401805467000031],
                    [-1.61355382499994, 6.402069317000041],
                    [-1.613893575999953, 6.40221654100003],
                    [-1.614684103999934, 6.402374647000045],
                    [-1.615379786999938, 6.402374647000045],
                    [-1.615537875999962, 6.402374647000045],
                    [-1.616612995999958, 6.402248162000035],
                    [-1.617466767999929, 6.401837087000047],
                    [-1.618099190999942, 6.401173044000075],
                    [-1.618607776999966, 6.400518710000028],
                    [-1.618830242999934, 6.399839937000024],
                    [-1.618952960999934, 6.399465500000076],
                    [-1.619205844999954, 6.39859073100007],
                    [-1.619387383999936, 6.397530674000052],
                    [-1.618946195999968, 6.39484765800006],
                    [-1.618770104999953, 6.394346386000052],
                    [-1.618449525999949, 6.394211582000025],
                    [-1.618250131999957, 6.39412773600003],
                    [-1.618546553999977, 6.393141860000071],
                    [-1.61884297499995, 6.392155984000055],
                    [-1.619183365999959, 6.391072192000024],
                    [-1.619328823999979, 6.390581325000028],
                    [-1.619529519999958, 6.390197903000058],
                    [-1.619757773999936, 6.389814447000049],
                    [-1.619986026999925, 6.38943099100004],
                    [-1.620423445999961, 6.388835017000076],
                    [-1.620698475999973, 6.388396371000056],
                    [-1.621069671999976, 6.387726046000068],
                    [-1.62350192599996, 6.38810353100007],
                    [-1.623740219999945, 6.388050866000071],
                    [-1.624313143999927, 6.387857203000067],
                    [-1.625065186999961, 6.387668834000067],
                    [-1.625547085999926, 6.387398095000037],
                    [-1.625767226999926, 6.387146966000046],
                    [-1.626091790999965, 6.386658637000039],
                    [-1.626416353999957, 6.386170307000043],
                    [-1.626741139999979, 6.385863920000077],
                    [-1.62691170599993, 6.385634906000064],
                    [-1.627255660999936, 6.385232010000038],
                    [-1.627466239999933, 6.385049811000044],
                    [-1.627991538999936, 6.384579227000074],
                    [-1.628384212999947, 6.384224442000061],
                    [-1.629230251999957, 6.384084875000042],
                    [-1.631026641999938, 6.386027089000038],
                    [-1.631300950999957, 6.386017123000045],
                    [-1.631917882999971, 6.386008289000074],
                    [-1.632702887999926, 6.386091341000053],
                    [-1.633246928999938, 6.385908101000041],
                    [-1.633663088999924, 6.38548912400006],
                    [-1.633905200999948, 6.385372497000048],
                    [-1.634026304999963, 6.385352959000045],
                    [-1.63437631499994, 6.385468636000041],
                    [-1.634701400999973, 6.385410345000025],
                    [-1.635045705999971, 6.385296896000057],
                    [-1.635158343999933, 6.385277243000075],
                    [-1.635395775999939, 6.385294722000026],
                    [-1.635800619999941, 6.385209130000021],
                    [-1.63621109099995, 6.38512178700006],
                    [-1.636246248999953, 6.385119658000065],
                    [-1.636496009999973, 6.385104526000021],
                    [-1.636536221999961, 6.385102089000043],
                    [-1.636748517999933, 6.385198311000067],
                    [-1.63722527699997, 6.385236315000043],
                    [-1.637624961999961, 6.385340574000054],
                    [-1.638024645999963, 6.385444834000054],
                    [-1.639044410999929, 6.38561448400003],
                    [-1.639733299999932, 6.385613629000034],
                    [-1.640058547999956, 6.385687657000062],
                    [-1.640538012999968, 6.385687062000045],
                    [-1.641323513999964, 6.385821160000035],
                    [-1.642031477999979, 6.385649365000063],
                    [-1.642480535999937, 6.385571617000039],
                    [-1.642929593999952, 6.385493869000072],
                    [-1.643502602999945, 6.38537737300004],
                    [-1.64442293299993, 6.385356926000043],
                    [-1.645150298999965, 6.385276071000021],
                    [-1.645589582999946, 6.38509633700005],
                    [-1.646028868999963, 6.384916601000043],
                    [-1.646257554999977, 6.38489701900005],
                    [-1.646334758999956, 6.384935515000052],
                    [-1.647071852999943, 6.384923563000029],
                    [-1.647456535999936, 6.385149127000034],
                    [-1.647655307999969, 6.385446599000034],
                    [-1.647868014999972, 6.385868105000043],
                    [-1.648044623999965, 6.386069120000059],
                    [-1.648283410999966, 6.386412027000063],
                    [-1.648461612999938, 6.386785333000034],
                    [-1.648748575999946, 6.387090964000038],
                    [-1.649074046999942, 6.387341413000058],
                    [-1.649247910999975, 6.387550701000066],
                    [-1.649423363999972, 6.387926767000067],
                    [-1.64959881599998, 6.388302832000022],
                    [-1.649712367999939, 6.388757542000064],
                    [-1.649825918999966, 6.38921225100006],
                    [-1.649846837999974, 6.389504834000036],
                    [-1.649842913999976, 6.389578868000058],
                    [-1.649881637999954, 6.389694601000031],
                    [-1.649882483999932, 6.390364474000023],
                    [-1.649778883999943, 6.391246742000021],
                    [-1.649888191999935, 6.392052042000046],
                    [-1.649902080999937, 6.392154362000042],
                    [-1.649970803999963, 6.392660678000027],
                    [-1.650037446999931, 6.39306306900005],
                    [-1.650036503999956, 6.393407655000033],
                    [-1.650035560999925, 6.393752242000062],
                    [-1.65007428499996, 6.393867973000056],
                    [-1.65007486199994, 6.394325583000068],
                    [-1.650036575999934, 6.394557193000026],
                    [-1.649943174999976, 6.394786114000055],
                    [-1.649924467999938, 6.395246504000056],
                    [-1.650230916999931, 6.395703725000033],
                    [-1.650460210999938, 6.396161045000042],
                    [-1.650785854999924, 6.396543811000072],
                    [-1.650926732999949, 6.396813789000021],
                    [-1.651417324999954, 6.396887597000045],
                    [-1.651858197999957, 6.39686774200004],
                    [-1.652048358999934, 6.396886797000036],
                    [-1.65233793799996, 6.397076643000048],
                    [-1.652663124999947, 6.397095525000054],
                    [-1.652853480999966, 6.397268954000026],
                    [-1.653066390999925, 6.397842073000049],
                    [-1.653200621999929, 6.39830089000003],
                    [-1.653334851999944, 6.398759707000067],
                    [-1.653486654999938, 6.398952481000038],
                    [-1.653718343999969, 6.399123101000043],
                    [-1.653850907999924, 6.399354493000033],
                    [-1.653870488999928, 6.399583273000076],
                    [-1.653832200999943, 6.399812126000029],
                    [-1.653890214999933, 6.39992783200006],
                    [-1.653929084999959, 6.400156587000026],
                    [-1.654158362999965, 6.400597364000021],
                    [-1.654312943999969, 6.400806675000069],
                    [-1.654541931999972, 6.401018648000047],
                    [-1.654754356999945, 6.401208589000021],
                    [-1.655040820999943, 6.401113117000023],
                    [-1.655327282999963, 6.40101764800005],
                    [-1.655900503999931, 6.401055509000059],
                    [-1.656225811999946, 6.401168118000044],
                    [-1.656457530999944, 6.401360789000023],
                    [-1.656706072999953, 6.401779486000066],
                    [-1.656896502999928, 6.402008047000038],
                    [-1.657128173999979, 6.402162125000075],
                    [-1.657241200999977, 6.402197817000058],
                    [-1.657472627999937, 6.402161684000021],
                    [-1.657701196999938, 6.402045611000062],
                    [-1.657968076999964, 6.401719983000021],
                    [-1.65819937599997, 6.401584608000064],
                    [-1.658427995999944, 6.401507129000038],
                    [-1.65861259299993, 6.401484839000034],
                    [-1.659037010999953, 6.40152426700007],
                    [-1.659461428999975, 6.40156369400006],
                    [-1.660111781999944, 6.401582155000028],
                    [-1.660417583999958, 6.401525251000066],
                    [-1.660723385999972, 6.401468346000058],
                    [-1.660987821999925, 6.401388062000024],
                    [-1.661228738999966, 6.401232],
                    [-1.661430939999946, 6.400968477000049],
                    [-1.661623587999941, 6.400778020000075],
                    [-1.661814696999954, 6.40046075500004],
                    [-1.662005802999943, 6.400143492000041],
                    [-1.662748761999978, 6.399321045000022],
                    [-1.663073405999967, 6.398918152000022],
                    [-1.663343206999969, 6.398724838000021],
                    [-1.663745354999946, 6.39859199700004],
                    [-1.663974070999927, 6.398591702000033],
                    [-1.664089756999942, 6.398552960000075],
                    [-1.665045951999957, 6.398551723000026],
                    [-1.666757083999926, 6.398472320000053],
                    [-1.667628398999966, 6.398890204000054],
                    [-1.667859920999945, 6.398928496000053],
                    [-1.668185403999928, 6.399176174000047],
                    [-1.668395105999934, 6.399388165000062],
                    [-1.668739853999966, 6.399616520000052],
                    [-1.668968696999968, 6.399712706000059],
                    [-1.669294181999931, 6.399960382000074],
                    [-1.66952446199997, 6.400103429000069],
                    [-1.670358636999936, 6.400565463000021],
                    [-1.670537899999943, 6.400678252000034],
                    [-1.670663336999951, 6.400720817000035],
                    [-1.67078877299997, 6.400763383000026],
                    [-1.671592696999937, 6.40126955900007],
                    [-1.672396622999941, 6.401775735000058],
                    [-1.67258981599997, 6.402004285000032],
                    [-1.672705650999944, 6.402081320000036],
                    [-1.67285751199995, 6.402309925000054],
                    [-1.672915628999931, 6.402500059000033],
                    [-1.673001204999935, 6.402615727000068],
                    [-1.673086779999949, 6.402731395000046],
                    [-1.673318475999963, 6.402902005000044],
                    [-1.673547318999965, 6.402998188000026],
                    [-1.673834331999956, 6.403323100000023],
                    [-1.674066005999975, 6.403477168000052],
                    [-1.674429893999957, 6.403586957000073],
                    [-1.674492012999963, 6.403632982000033],
                    [-1.674504450999962, 6.403663161000054],
                    [-1.674543025999981, 6.403702590000023],
                    [-1.674639471999967, 6.403702462000069],
                    [-1.674735919999932, 6.403702336000038],
                    [-1.674838724999972, 6.403637914000058],
                    [-1.67487045799993, 6.40363390400006],
                    [-1.674945134999973, 6.403624466000053],
                    [-1.675040690999936, 6.403624511000032],
                    [-1.675173964999942, 6.403624573000059],
                    [-1.67528972599996, 6.403643719000058],
                    [-1.675518443999977, 6.403643417000069],
                    [-1.675634205999927, 6.403662562000022],
                    [-1.675769230999947, 6.403662384000029],
                    [-1.675844960999939, 6.403623691000064],
                    [-1.675920689999941, 6.403584998000042],
                    [-1.675997747999929, 6.403510467000046],
                    [-1.675997443999961, 6.403278907000072],
                    [-1.675958716999958, 6.403165935000061],
                    [-1.675881355999934, 6.403011663000029],
                    [-1.675842574999933, 6.402857342000061],
                    [-1.675823111999932, 6.402725046000057],
                    [-1.675899964999928, 6.402493385000071],
                    [-1.675996288999954, 6.402399532000061],
                    [-1.676073293999934, 6.402283651000062],
                    [-1.676150349999944, 6.402206363000062],
                    [-1.67626323199994, 6.402131784000062],
                    [-1.67649475099995, 6.402167317000021],
                    [-1.676607782999952, 6.402205760000072],
                    [-1.676723619999962, 6.40228279400003],
                    [-1.676839406999932, 6.402321235000045],
                    [-1.67699106799995, 6.402398222000045],
                    [-1.677087565999955, 6.402436688000023],
                    [-1.677219885999932, 6.402475107000043],
                    [-1.677335719999974, 6.402549385000043],
                    [-1.677451506999944, 6.402587825000069],
                    [-1.677564487999973, 6.402587676000053],
                    [-1.677660985999978, 6.402626142000031],
                    [-1.677889752999931, 6.402664435000077],
                    [-1.678024778999941, 6.402664256000037],
                    [-1.678140463999966, 6.402625510000064],
                    [-1.678253341999948, 6.40254817400006],
                    [-1.678369027999963, 6.40250942800003],
                    [-1.678484614999945, 6.402396252000074],
                    [-1.678561616999957, 6.402280370000028],
                    [-1.678751505999969, 6.402089910000029],
                    [-1.678867139999966, 6.402012571000057],
                    [-1.678980042999967, 6.401954531000058],
                    [-1.679095753999945, 6.401935082000023],
                    [-1.67944005399994, 6.401818847000072],
                    [-1.679497871999956, 6.401781555000071],
                    [-1.679555688999926, 6.401744264000058],
                    [-1.679668543999981, 6.40164763100006],
                    [-1.679784176999931, 6.401570292000031],
                    [-1.679842005999944, 6.401541270000052],
                    [-1.679899836999937, 6.401512249000064],
                    [-1.680014193999966, 6.401512097000023],
                    [-1.680128552999975, 6.401511946000028],
                    [-1.680244261999974, 6.40149249600006],
                    [-1.680357242999946, 6.401492347000044],
                    [-1.680473004999953, 6.401511490000075],
                    [-1.680588688999933, 6.401472744000046],
                    [-1.680701668999973, 6.40147259400004],
                    [-1.680759487999978, 6.401435302000039],
                    [-1.680817306999927, 6.401398012000072],
                    [-1.68100703999994, 6.40109177000005],
                    [-1.681006961999969, 6.401033881000046],
                    [-1.681006885999977, 6.400975990000063],
                    [-1.68114137799995, 6.400573340000051],
                    [-1.681276125999943, 6.400363655000035],
                    [-1.681389053999965, 6.400324912000031],
                    [-1.681444183999929, 6.40033862100006],
                    [-1.68149931499994, 6.400352331000022],
                    [-1.681597158999978, 6.400367363000043],
                    [-1.682017422999934, 6.400392994000072],
                    [-1.682116533999931, 6.400323947000061],
                    [-1.682142644999942, 6.400272913000038],
                    [-1.682168755999953, 6.400221880000061],
                    [-1.682193383999959, 6.400092284000038],
                    [-1.682115922999969, 6.399863585000048],
                    [-1.68194479899995, 6.399654304000023],
                    [-1.681886800999962, 6.399557898000069],
                    [-1.681867434999958, 6.399500034000027],
                    [-1.681848068999955, 6.399442171000032],
                    [-1.681847766999965, 6.399213367000073],
                    [-1.681876472999932, 6.399041037000075],
                    [-1.681905178999955, 6.398868708000066],
                    [-1.681962416999966, 6.398394487000076],
                    [-1.682135788999972, 6.398220586000036],
                    [-1.682419864999929, 6.398407662000068],
                    [-1.682497071999933, 6.398446153000066],
                    [-1.682497123999951, 6.398484746000065],
                    [-1.682574434999935, 6.398600423000062],
                    [-1.682764719999966, 6.398713194000038],
                    [-1.682918832999974, 6.398561373000064],
                    [-1.682918781999945, 6.398522780000064],
                    [-1.682860760999972, 6.398407077000059],
                    [-1.682783478999966, 6.398313454000061],
                    [-1.682593087999976, 6.398120739000035],
                    [-1.682496465999975, 6.397988548000058],
                    [-1.682419205999963, 6.39791146400006],
                    [-1.682380473999956, 6.397795735000045],
                    [-1.68241889899997, 6.397679904000029],
                    [-1.682495931999938, 6.397586075000049],
                    [-1.682611538999936, 6.397489439000026],
                    [-1.682724414999939, 6.397412102000033],
                    [-1.683049425999968, 6.39729864800006],
                    [-1.68318439899997, 6.397259875000032],
                    [-1.683299979999958, 6.397143941000024],
                    [-1.683489554999937, 6.396721920000061],
                    [-1.683701506999967, 6.396550725000054],
                    [-1.683833596999932, 6.396415473000047],
                    [-1.683910599999933, 6.396299591000059],
                    [-1.683987553999941, 6.396147872000029],
                    [-1.683997121999937, 6.396089969000059],
                    [-1.684006689999933, 6.396032068000068],
                    [-1.683948364999935, 6.395687562000035],
                    [-1.68387105599993, 6.395574641000053],
                    [-1.683793772999934, 6.395478261000051],
                    [-1.683584067999959, 6.395266277000076],
                    [-1.683520564999981, 6.395172634000062],
                    [-1.683603001999927, 6.394998856000029],
                    [-1.683718632999955, 6.394921515000021],
                    [-1.683947246999935, 6.394846782000059],
                    [-1.684272503999978, 6.394920778000028],
                    [-1.684597763999932, 6.394997532000048],
                    [-1.684666643999947, 6.394989170000031],
                    [-1.684735521999926, 6.39498080900006],
                    [-1.684826374999943, 6.394920041000034],
                    [-1.68490338099997, 6.394806915000061],
                    [-1.68490322599996, 6.394691136000063],
                    [-1.68490307199994, 6.394575356000075],
                    [-1.684883633999959, 6.394462360000034],
                    [-1.684806169999945, 6.394230902000061],
                    [-1.684786729999928, 6.39411790500003],
                    [-1.684750804999965, 6.394040766000046],
                    [-1.684731284999941, 6.393867123000064],
                    [-1.684758675999944, 6.393743036000046],
                    [-1.684786065999958, 6.393618952000054],
                    [-1.684863071999928, 6.393505824000044],
                    [-1.685017281999933, 6.393428432000064],
                    [-1.685130208999965, 6.393389690000049],
                    [-1.685245993999956, 6.393428128000039],
                    [-1.685323298999947, 6.393541048000031],
                    [-1.685362031999944, 6.393656776000057],
                    [-1.685362336999958, 6.393885579000028],
                    [-1.685401068999965, 6.394001307000053],
                    [-1.685475674999964, 6.394155582000053],
                    [-1.685745745999952, 6.394174518000057],
                    [-1.68599364399995, 6.394097001000034],
                    [-1.686241515999939, 6.394000188000064],
                    [-1.686472783999932, 6.393848263000052],
                    [-1.686585607999973, 6.39373233200007],
                    [-1.686633791999952, 6.393703322000022],
                    [-1.686681975999932, 6.393674313000076],
                    [-1.686910431999934, 6.393483798000034],
                    [-1.687045379999972, 6.393425729000057],
                    [-1.687161061999973, 6.393386981000049],
                    [-1.68727393599994, 6.393309643000066],
                    [-1.687389515999939, 6.393193709000059],
                    [-1.687427840999931, 6.393003448000059],
                    [-1.687350528999957, 6.392887773000041],
                    [-1.68712181799998, 6.392888077000066],
                    [-1.68689040199996, 6.392926980000027],
                    [-1.686738896999941, 6.39296577500005],
                    [-1.686584583999945, 6.392965981000032],
                    [-1.686471555999958, 6.392927538000038],
                    [-1.686355568999943, 6.392737485000055],
                    [-1.686316836999936, 6.39262175500005],
                    [-1.686316682999973, 6.392505976000052],
                    [-1.686393712999973, 6.392412147000073],
                    [-1.686564352999937, 6.392257547000042],
                    [-1.686737875999938, 6.392199424000069],
                    [-1.686966383999959, 6.392047503000072],
                    [-1.687081989999967, 6.391950866000059],
                    [-1.687194864999981, 6.391873528000076],
                    [-1.68742610399994, 6.39170230600007],
                    [-1.687635216999979, 6.391470468000023],
                    [-1.688075545999936, 6.391050867000047],
                    [-1.688171912999962, 6.390992849000042],
                    [-1.688284838999948, 6.390954104000059],
                    [-1.68841983599998, 6.390934626000046],
                    [-1.688516279999931, 6.390934497000046],
                    [-1.688629232999972, 6.390915050000046],
                    [-1.688744964999955, 6.390914895000037],
                    [-1.689012150999929, 6.390837352000062],
                    [-1.689060283999936, 6.39077112700005],
                    [-1.689108416999943, 6.390704903000028],
                    [-1.68910826299998, 6.390589123000041],
                    [-1.689077830999963, 6.390498194000031],
                    [-1.688724882999963, 6.390322240000046],
                    [-1.688495966999938, 6.390168173000063],
                    [-1.688379927999961, 6.389939526000035],
                    [-1.688418299999967, 6.389785101000029],
                    [-1.688437437999937, 6.389672052000037],
                    [-1.688781265999978, 6.389211230000058],
                    [-1.688761923999948, 6.389172663000068],
                    [-1.688800347999972, 6.389056831000062],
                    [-1.688722885999937, 6.388828133000061],
                    [-1.688664942999935, 6.388770321000038],
                    [-1.688607, 6.388712507000037],
                    [-1.688493922999953, 6.388638229000037],
                    [-1.688378034999971, 6.388522604000059],
                    [-1.688205609999955, 6.388369840000053],
                    [-1.688149070999941, 6.388332701000024],
                    [-1.688071761999936, 6.388217024000028],
                    [-1.688032926999938, 6.38802411000006],
                    [-1.688129296999932, 6.387968848000071],
                    [-1.688205769999968, 6.387955838000039],
                    [-1.688357954999958, 6.387929949000068],
                    [-1.688473712999951, 6.387949091000053],
                    [-1.688616975999935, 6.387928210000041],
                    [-1.688740947999975, 6.387910142000067],
                    [-1.688875864999943, 6.387832773000071],
                    [-1.68895011199993, 6.38771689500004],
                    [-1.688978967999958, 6.38765965500005],
                    [-1.68900782399993, 6.38760241500006],
                    [-1.689065537999966, 6.38748793700006],
                    [-1.689103809999949, 6.387259082000071],
                    [-1.68910365499994, 6.387143303000073],
                    [-1.689084288999936, 6.387085439000032],
                    [-1.689064922999933, 6.387027575000047],
                    [-1.688910202999978, 6.386721794000039],
                    [-1.688910001999943, 6.386570177000067],
                    [-1.688874126999963, 6.386531631000025],
                    [-1.688909793999926, 6.38641580500007],
                    [-1.688873792999971, 6.386280776000035],
                    [-1.688891523999928, 6.386147054000048],
                    [-1.688909256999978, 6.386013332000061],
                    [-1.688947709999979, 6.385919554000054],
                    [-1.689024709999956, 6.385803671000076],
                    [-1.68914028699993, 6.385687737000069],
                    [-1.689140183999939, 6.38561055100007],
                    [-1.689178609999942, 6.385497476000069],
                    [-1.689216979999969, 6.385343052000053],
                    [-1.689291276999938, 6.385265766000032],
                    [-1.689348965999955, 6.385133370000062],
                    [-1.689445277999937, 6.385036758000069],
                    [-1.689483676999942, 6.384901630000059],
                    [-1.689502812999933, 6.384788580000077],
                    [-1.689576881999926, 6.384540382000068],
                    [-1.689634592999937, 6.384424525000043],
                    [-1.689711642999953, 6.384347235000064],
                    [-1.689865336999958, 6.38388666700007],
                    [-1.690055005999966, 6.38354183000007],
                    [-1.690112719999945, 6.383428730000048],
                    [-1.690209008999943, 6.38331282200005],
                    [-1.690321881999978, 6.383235484000068],
                    [-1.690437461999977, 6.383122307000065],
                    [-1.690495301999931, 6.383102932000043],
                    [-1.690553141999942, 6.38308355700002],
                    [-1.690666116999978, 6.383083406000026],
                    [-1.690781925999943, 6.383141141000067],
                    [-1.690897782999969, 6.383234713000036],
                    [-1.690972285999976, 6.383311798000022],
                    [-1.691049745999976, 6.383540498000059],
                    [-1.691127028999972, 6.383636878000061],
                    [-1.69126233399993, 6.383848958000044],
                    [-1.691356121999945, 6.383923263000042],
                    [-1.691471853999928, 6.383923108000033],
                    [-1.691587584999979, 6.383922952000034],
                    [-1.691700508999929, 6.383884207000051],
                    [-1.691854717999945, 6.383809571000029],
                    [-1.692083423999975, 6.383809264000035],
                    [-1.692160632999958, 6.383847752000065],
                    [-1.69219936099995, 6.38396072300003],
                    [-1.692122516999973, 6.384192386000052],
                    [-1.69202619999993, 6.38428624200003],
                    [-1.691971269999954, 6.384421393000025],
                    [-1.692007451999928, 6.384688739000069],
                    [-1.692084670999975, 6.384736877000023],
                    [-1.692161888999976, 6.384785016000023],
                    [-1.692276318999973, 6.384841373000029],
                    [-1.692390749999959, 6.384897730000034],
                    [-1.692506533999961, 6.384936168000024],
                    [-1.692735396999979, 6.385051640000029],
                    [-1.69285118099998, 6.385090077000029],
                    [-1.693079940999951, 6.385128363000035],
                    [-1.693195646999925, 6.385108912000021],
                    [-1.694113234999975, 6.385107675000029],
                    [-1.69422901799993, 6.385146112000029],
                    [-1.694344749999971, 6.38514595700002],
                    [-1.694457673999977, 6.385107211000047],
                    [-1.694515539999941, 6.385107133000076],
                    [-1.694573405999961, 6.385107055000049],
                    [-1.694689185999948, 6.385142736000034],
                    [-1.694802110999944, 6.38510399200004],
                    [-1.694917841999938, 6.385103835000052],
                    [-1.695146445999967, 6.385026339000035],
                    [-1.69526217799995, 6.385026183000036],
                    [-1.695377857999972, 6.384987434000038],
                    [-1.69549072999996, 6.384910096000056],
                    [-1.69564483399995, 6.384758271000067],
                    [-1.695683411999937, 6.384758219000048],
                    [-1.695682919999967, 6.384394340000028],
                    [-1.69564421299998, 6.384297910000043],
                    [-1.69564403499993, 6.384165590000066],
                    [-1.695624589999966, 6.384049839000056],
                    [-1.695662857999935, 6.383820984000067],
                    [-1.695794810999928, 6.383589245000053],
                    [-1.69587183799996, 6.383495415000027],
                    [-1.695987465999963, 6.38341807200004],
                    [-1.69610298799995, 6.383263544000044],
                    [-1.69613850099995, 6.38303469300007],
                    [-1.695948166999926, 6.382883334000041],
                    [-1.695832382999924, 6.382844897000041],
                    [-1.695719407999945, 6.382845050000071],
                    [-1.695603754999979, 6.382903096000064],
                    [-1.695488152999928, 6.382999735000055],
                    [-1.695413910999946, 6.383115614000076],
                    [-1.695337037999934, 6.383325224000032],
                    [-1.695260118999954, 6.383498997000061],
                    [-1.695105961999957, 6.383612228000061],
                    [-1.694915780999963, 6.383573892000072],
                    [-1.694780555999955, 6.383422458000041],
                    [-1.694725059999939, 6.383135840000023],
                    [-1.694724927999971, 6.383039358000076],
                    [-1.694760542999973, 6.382884936000039],
                    [-1.694760364999979, 6.382752617000051],
                    [-1.694837207999967, 6.382520954000029],
                    [-1.694894920999957, 6.382407854000064],
                    [-1.695123315999979, 6.38217598600005],
                    [-1.695354520999956, 6.381985465000071],
                    [-1.695467443999974, 6.381946719000041],
                    [-1.695698698999934, 6.381792034000057],
                    [-1.695811625999966, 6.381756045000031],
                    [-1.696042879999936, 6.381601360000047],
                    [-1.696252065999943, 6.381430167000076],
                    [-1.696386902999961, 6.381294908000029],
                    [-1.696615091999945, 6.380911423000043],
                    [-1.696730614999979, 6.380756894000058],
                    [-1.696862752999948, 6.380662989000029],
                    [-1.696978430999934, 6.380624240000031],
                    [-1.697094161999928, 6.380624083000043],
                    [-1.697284543999956, 6.380811278000067],
                    [-1.697323277999942, 6.380927005000046],
                    [-1.697381324999981, 6.381062003000068],
                    [-1.697494609999978, 6.381290652000075],
                    [-1.697706966999931, 6.381425441000033],
                    [-1.697935619999953, 6.381386539000061],
                    [-1.697974040999952, 6.381270708000045],
                    [-1.697973883999964, 6.381154927000068],
                    [-1.697935153999936, 6.381041957000036],
                    [-1.697857843999941, 6.380926283000065],
                    [-1.697783340999933, 6.380849197000032],
                    [-1.69768669399997, 6.380697711000039],
                    [-1.697628618999943, 6.380543417000069],
                    [-1.69766693899993, 6.380353157000059],
                    [-1.697705359999929, 6.380237325000053],
                    [-1.697782355999948, 6.380121441000028],
                    [-1.697895178999943, 6.380008266000061],
                    [-1.698010804999967, 6.379930922000028],
                    [-1.698126482999953, 6.379892172000041],
                    [-1.698228435999965, 6.379892034000022],
                    [-1.698928612999964, 6.38010059100003],
                    [-1.699005792999969, 6.380119783000055],
                    [-1.699121524999953, 6.380119626000067],
                    [-1.699234398999977, 6.380045044000042],
                    [-1.699311447999946, 6.379967753000074],
                    [-1.699198420999949, 6.379929314000037],
                    [-1.699235384999952, 6.379756972000052],
                    [-1.699272350999934, 6.379584631000057],
                    [-1.699233564999929, 6.379430310000032],
                    [-1.699310565999951, 6.379317183000069],
                    [-1.699426243999937, 6.379278433000025],
                    [-1.699597083999947, 6.379278201000034],
                    [-1.699861849999934, 6.379454269000064],
                    [-1.700076847999981, 6.379506353000068],
                    [-1.700154002999966, 6.37950624900003],
                    [-1.700231154999926, 6.379506143000071],
                    [-1.700382655999931, 6.379467344000034],
                    [-1.700498333999974, 6.379428594000046],
                    [-1.700575383999933, 6.379354059000036],
                    [-1.700688123999953, 6.37918023800006],
                    [-1.70070702299995, 6.37889351900003],
                    [-1.700706865999962, 6.378777740000032],
                    [-1.700726001999953, 6.378664692000029],
                    [-1.700764499999934, 6.378606750000074],
                    [-1.700800063999964, 6.378551602000073],
                    [-1.700801442999932, 6.37851807100003],
                    [-1.700804885999958, 6.378434477000042],
                    [-1.700841312999955, 6.378355790000057],
                    [-1.700879888999964, 6.37835573600006],
                    [-1.700869378999926, 6.378324349000025],
                    [-1.700861327999974, 6.378300308000064],
                    [-1.700839486999939, 6.37823508300005],
                    [-1.700828107999939, 6.378132524000023],
                    [-1.700802112999952, 6.377898237000068],
                    [-1.700709740999969, 6.377661338000053],
                    [-1.700663210999949, 6.377415747000043],
                    [-1.700572474999944, 6.377209385000072],
                    [-1.700566432999949, 6.37717045900007],
                    [-1.700533557999961, 6.376958583000032],
                    [-1.70053328399996, 6.376757402000067],
                    [-1.700533247999942, 6.376729782000041],
                    [-1.700571692999972, 6.376633247000029],
                    [-1.700571539999942, 6.376520224000046],
                    [-1.700532779999946, 6.376385199000026],
                    [-1.700532469999928, 6.376156397000045],
                    [-1.700606552999943, 6.375924738000037],
                    [-1.70068357699995, 6.375830908000069],
                    [-1.700721997999949, 6.375715076000063],
                    [-1.700798993999967, 6.375599193000028],
                    [-1.700914646999934, 6.375543902000061],
                    [-1.70141044899998, 6.375408152000034],
                    [-1.701526073999958, 6.375330807000068],
                    [-1.701564495999946, 6.375217732000067],
                    [-1.701564338999958, 6.375101953000069],
                    [-1.701525604999972, 6.374986226000033],
                    [-1.701448298999935, 6.374873308000076],
                    [-1.701313122999977, 6.374757713000065],
                    [-1.701199964999944, 6.374622790000046],
                    [-1.701064588999941, 6.374358335000068],
                    [-1.701103035999949, 6.374261800000056],
                    [-1.701083567999945, 6.374129507000021],
                    [-1.701160405999929, 6.373897844000055],
                    [-1.701237405999962, 6.373784716000046],
                    [-1.701330958999961, 6.373688106000031],
                    [-1.701427243999944, 6.373572196000055],
                    [-1.701751917999957, 6.373227172000043],
                    [-1.701905912999962, 6.372998162000044],
                    [-1.701982855999972, 6.372843683000042],
                    [-1.702002040999957, 6.37276784900007],
                    [-1.702021225999943, 6.372692015000041],
                    [-1.702021016999936, 6.372537643000044],
                    [-1.701907836999965, 6.372386181000024],
                    [-1.701792055999931, 6.372347746000059],
                    [-1.701676300999964, 6.372328606000053],
                    [-1.701563352999926, 6.372348056000021],
                    [-1.701447164999934, 6.372386169000038],
                    [-1.701345664999963, 6.37245391600004],
                    [-1.701216471999942, 6.372540146000063],
                    [-1.701027325999974, 6.372577037000042],
                    [-1.700987723999958, 6.372539047000032],
                    [-1.700949094999942, 6.372500506000051],
                    [-1.70083602099993, 6.372426231000077],
                    [-1.700797129999955, 6.372194725000043],
                    [-1.700796976999925, 6.37208170100007],
                    [-1.700835473999973, 6.372023759000058],
                    [-1.700873972999943, 6.371965817000046],
                    [-1.700986812999929, 6.371869183000058],
                    [-1.701102463999973, 6.371811134000041],
                    [-1.701218144999928, 6.371775140000068],
                    [-1.701331117999928, 6.371774987000038],
                    [-1.701446819999944, 6.371755533000055],
                    [-1.701562575999958, 6.371774672000072],
                    [-1.701675597999952, 6.371810355000036],
                    [-1.701791323999942, 6.371810199000038],
                    [-1.701907106999954, 6.371848635000049],
                    [-1.702020106999953, 6.371867777000034],
                    [-1.70213588799993, 6.371906212000056],
                    [-1.702403243999925, 6.371963739000023],
                    [-1.702670491999925, 6.371941322000055],
                    [-1.702795811999977, 6.371902559000034],
                    [-1.702921132999961, 6.371863796000071],
                    [-1.702987199999939, 6.371816842000044],
                    [-1.703053266999973, 6.371769889000063],
                    [-1.70307859199994, 6.371717386000057],
                    [-1.703052898999942, 6.371499736000032],
                    [-1.702978400999939, 6.37142540800005],
                    [-1.702843282999936, 6.371351162000053],
                    [-1.702746736999927, 6.371274107000033],
                    [-1.702633504999937, 6.371084052000072],
                    [-1.702556195999932, 6.370968378000043],
                    [-1.702536671999951, 6.370794735000061],
                    [-1.702536490999933, 6.370662416000073],
                    [-1.702555621999977, 6.370546612000055],
                    [-1.702726121999945, 6.370298280000043],
                    [-1.702957366999954, 6.370143592000034],
                    [-1.703089654999928, 6.370162709000056],
                    [-1.703166860999943, 6.370201197000029],
                    [-1.703357296999968, 6.37042974000002],
                    [-1.703473178999957, 6.370542605000026],
                    [-1.703588959999934, 6.370581040000047],
                    [-1.704046361999929, 6.370580417000042],
                    [-1.704200835999927, 6.370704255000021],
                    [-1.704355308999936, 6.370828094000046],
                    [-1.704507173999957, 6.371059446000061],
                    [-1.704584451999949, 6.371153068000069],
                    [-1.70481326099997, 6.37122994200007],
                    [-1.705157610999947, 6.371171581000056],
                    [-1.705273284999976, 6.371132829000032],
                    [-1.705388987999925, 6.37111337500005],
                    [-1.705694842999947, 6.371112958000026],
                    [-1.706000487999972, 6.370960923000041],
                    [-1.706093988999953, 6.370825719000038],
                    [-1.706057854999926, 6.370596966000051],
                    [-1.705999807999945, 6.370461970000065],
                    [-1.705999598999938, 6.370310354000026],
                    [-1.70603796499995, 6.37015592900002],
                    [-1.706076387999929, 6.370042855000065],
                    [-1.706189201999962, 6.369926920000069],
                    [-1.706304823999972, 6.369849576000036],
                    [-1.706419120999954, 6.369810826000048],
                    [-1.706533418999925, 6.36977207800004],
                    [-1.706687775999967, 6.369810459000064],
                    [-1.706765033999943, 6.369887539000047],
                    [-1.706800985999962, 6.369983974000036],
                    [-1.706820364999942, 6.370050108000044],
                    [-1.706839742999932, 6.370116239000026],
                    [-1.706839901999956, 6.370232018000024],
                    [-1.706801483999925, 6.370347851000076],
                    [-1.706727215999933, 6.370441679000066],
                    [-1.706592514999954, 6.370673421000049],
                    [-1.706534937999947, 6.370883007000032],
                    [-1.70657377699996, 6.371075918000031],
                    [-1.706649628999969, 6.371132326000065],
                    [-1.706725481999968, 6.371188733000054],
                    [-1.706954287999963, 6.371265606000065],
                    [-1.707070122999937, 6.37134263400003],
                    [-1.707183147999956, 6.371381072000077],
                    [-1.707414602999961, 6.371380755000075],
                    [-1.707471064999936, 6.371361381000042],
                    [-1.707527524999932, 6.371342007000067],
                    [-1.707643146999942, 6.371264664000023],
                    [-1.707720193999933, 6.371187371000076],
                    [-1.707833113999925, 6.371148624000057],
                    [-1.70794871399994, 6.371054738000055],
                    [-1.708293063999974, 6.370996376000051],
                    [-1.708408685999927, 6.370919032000074],
                    [-1.70852150099995, 6.370803097000021],
                    [-1.708598645999928, 6.370797478000043],
                    [-1.708656122999969, 6.370516222000049],
                    [-1.708675230999972, 6.370383876000062],
                    [-1.708716402999926, 6.370268039000052],
                    [-1.708793368999977, 6.370132859000023],
                    [-1.708907616999966, 6.370056893000026],
                    [-1.709021862999975, 6.369980928000075],
                    [-1.709366157999966, 6.369883973000071],
                    [-1.709481780999965, 6.36980662700006],
                    [-1.709671750999973, 6.369693344000041],
                    [-1.709787424999945, 6.369654592000074],
                    [-1.70984391199994, 6.369654516000026],
                    [-1.709900397999945, 6.369654436000076],
                    [-1.710013525999955, 6.36976730400005],
                    [-1.710052259999941, 6.369883031000029],
                    [-1.710033418999956, 6.370208341000023],
                    [-1.710052891999965, 6.370343389000027],
                    [-1.710141399999941, 6.370585854000069],
                    [-1.71035921999993, 6.370687549000024],
                    [-1.710475000999963, 6.370725983000057],
                    [-1.710551993999957, 6.370610099000032],
                    [-1.710568340999941, 6.370475],
                    [-1.710493655999926, 6.37026559800006],
                    [-1.710474208999926, 6.370149844000025],
                    [-1.710454684999945, 6.369978960000026],
                    [-1.710454210999956, 6.369634378000057],
                    [-1.710588856999948, 6.36936404100004],
                    [-1.710704455999974, 6.369270156000027],
                    [-1.710762293999949, 6.369250781000062],
                    [-1.710820130999934, 6.369231404000061],
                    [-1.710933102999945, 6.369231248000062],
                    [-1.71104893699993, 6.369308277000073],
                    [-1.711123488999931, 6.369421195000029],
                    [-1.711239322999973, 6.369498222000061],
                    [-1.711391030999948, 6.369613792000052],
                    [-1.711545440999942, 6.36969076500003],
                    [-1.711735509999926, 6.369651910000073],
                    [-1.711889761999942, 6.369613105000042],
                    [-1.711946195999928, 6.369574435000061],
                    [-1.712002628999926, 6.369535764000034],
                    [-1.712118141999952, 6.369381231000034],
                    [-1.71215656399994, 6.369268156000032],
                    [-1.712156404999973, 6.369152377000034],
                    [-1.712117667999962, 6.369036652000034],
                    [-1.712040414999933, 6.368962328000066],
                    [-1.711930090999942, 6.368885294000052],
                    [-1.71131563199998, 6.368886140000029],
                    [-1.711202498999967, 6.36877051700003],
                    [-1.711125034999952, 6.368541821000065],
                    [-1.711163451999937, 6.368425989000059],
                    [-1.711276316999943, 6.368348648000051],
                    [-1.711391968999976, 6.368293356000038],
                    [-1.711620668999956, 6.368293040000026],
                    [-1.711736421999944, 6.368312178000053],
                    [-1.711984512999948, 6.368386267000062],
                    [-1.712158157999966, 6.368424619000052],
                    [-1.712273884999945, 6.368424459000039],
                    [-1.712425276999966, 6.368311228000039],
                    [-1.712502322999967, 6.368233936000024],
                    [-1.712502162999954, 6.368118156000037],
                    [-1.712347544999943, 6.367889568000066],
                    [-1.712234412999976, 6.367773944000021],
                    [-1.712234043999956, 6.36750655000003],
                    [-1.712308307999933, 6.367409965000036],
                    [-1.712424061999968, 6.367429102000074],
                    [-1.712539815999946, 6.367448238000065],
                    [-1.71265297399998, 6.367583158000059],
                    [-1.712749437999946, 6.367602322000039],
                    [-1.712978454999927, 6.367830807000075],
                    [-1.713113602999954, 6.367927104000046],
                    [-1.71338093199995, 6.367965328000025],
                    [-1.713457976999962, 6.367888035000021],
                    [-1.713457474999927, 6.367524158000037],
                    [-1.713534386999925, 6.367350384000076],
                    [-1.713611382999943, 6.36723725500002],
                    [-1.713685670999951, 6.367159965000042],
                    [-1.713801344999979, 6.367121213000075],
                    [-1.713917072999948, 6.367121052000073],
                    [-1.714145665999979, 6.367043550000062],
                    [-1.71426136599996, 6.367024094000044],
                    [-1.71437436399998, 6.36704323400005],
                    [-1.714605764999931, 6.367004322000071],
                    [-1.714662264999959, 6.367013891000056],
                    [-1.71471876499993, 6.367023461000031],
                    [-1.714834571999972, 6.367081191000068],
                    [-1.714950401999943, 6.367155461000038],
                    [-1.715063425999972, 6.36719389600006],
                    [-1.715179260999946, 6.367270922000046],
                    [-1.715865674999975, 6.367498773000023],
                    [-1.715942987999938, 6.367614445000072],
                    [-1.716039502999934, 6.367669444000057],
                    [-1.716171895999935, 6.367765744000053],
                    [-1.716287756999975, 6.367862066000043],
                    [-1.716403665999962, 6.367994225000075],
                    [-1.71651669299996, 6.36803266000004],
                    [-1.716632581999932, 6.368148279000025],
                    [-1.716748414999927, 6.368225304000021],
                    [-1.716804979999949, 6.368281737000075],
                    [-1.716861544999972, 6.368338169000026],
                    [-1.716977378999957, 6.368415196000058],
                    [-1.717093265999949, 6.368530814000053],
                    [-1.717167822999954, 6.368646489000071],
                    [-1.71732228299993, 6.368759297000054],
                    [-1.717473938999944, 6.368836272000067],
                    [-1.71762829599993, 6.368874652000045],
                    [-1.71768618699997, 6.368893868000043],
                    [-1.717744077999953, 6.368913083000052],
                    [-1.717856994999977, 6.368874333000065],
                    [-1.71797264199995, 6.368816284000047],
                    [-1.718201128999965, 6.368661594000059],
                    [-1.71825892499993, 6.368614649000051],
                    [-1.718316725999955, 6.368567706000022],
                    [-1.718316564999952, 6.368451927000024],
                    [-1.718239251999933, 6.368336256000021],
                    [-1.718161996999925, 6.368261934000031],
                    [-1.718029602999934, 6.368165635000025],
                    [-1.717797880999967, 6.367972993000024],
                    [-1.717816822999964, 6.367724867000049],
                    [-1.717932443999928, 6.367647521000038],
                    [-1.718048170999964, 6.367647360000035],
                    [-1.718104683999968, 6.367666579000058],
                    [-1.718161194999936, 6.367685796000046],
                    [-1.718277084999954, 6.367801414000041],
                    [-1.718373630999963, 6.367878465000047],
                    [-1.718486682999981, 6.367936198000052],
                    [-1.718718349999961, 6.36808749100004],
                    [-1.718850687999975, 6.368145196000057],
                    [-1.718966524999928, 6.368222221000053],
                    [-1.719082249999929, 6.368222060000051],
                    [-1.719233799999927, 6.368221850000054],
                    [-1.719310843999949, 6.368144557000051],
                    [-1.719329969999933, 6.368028750000065],
                    [-1.71938767599994, 6.367915648000064],
                    [-1.719387513999948, 6.36779986800002],
                    [-1.719464505999952, 6.367683982000074],
                    [-1.719654418999937, 6.367532102000041],
                    [-1.71971225599998, 6.367512726000029],
                    [-1.71977009099993, 6.367493349000029],
                    [-1.719882955999935, 6.367416004000063],
                    [-1.720064732999958, 6.367357862000063],
                    [-1.720191350999926, 6.36726395900007],
                    [-1.720295010999962, 6.367150319000075],
                    [-1.720304, 6.367032245000075],
                    [-1.720284527999979, 6.36689995200004],
                    [-1.720220885999936, 6.366707077000058],
                    [-1.720035764999977, 6.366343458000074],
                    [-1.71991972099994, 6.366114818000028],
                    [-1.719845162999945, 6.365999143000067],
                    [-1.719771358999935, 6.365771351000035],
                    [-1.719759426999929, 6.365494124000065],
                    [-1.719919130999926, 6.365475639000067],
                    [-1.719961459999979, 6.365470739000045],
                    [-1.720123222999973, 6.365551376000042],
                    [-1.720360263999964, 6.36579363200002],
                    [-1.720608197999979, 6.365846463000025],
                    [-1.720723871999951, 6.365807711000059],
                    [-1.720762284999978, 6.365691876000028],
                    [-1.720762124999965, 6.365576098000076],
                    [-1.720687408999936, 6.365347401000065],
                    [-1.72068724899998, 6.365231621000021],
                    [-1.720706376999942, 6.365118573000075],
                    [-1.720706055999926, 6.364887015000022],
                    [-1.720647711999959, 6.364542515000039],
                    [-1.720570403999943, 6.36442960100004],
                    [-1.720570189999933, 6.364275229000043],
                    [-1.720608553999966, 6.364123560000053],
                    [-1.720646965999947, 6.364007727000057],
                    [-1.720801107999932, 6.363891735000038],
                    [-1.720914025999946, 6.363852984000061],
                    [-1.72101046399996, 6.363852848000022],
                    [-1.721126163999941, 6.363833390000025],
                    [-1.721354859999963, 6.363833070000055],
                    [-1.721583558999953, 6.363832752000064],
                    [-1.721699311999942, 6.363851887000067],
                    [-1.721766817999935, 6.363851793000038],
                    [-1.721834325999964, 6.363851699000065],
                    [-1.721928033999973, 6.363870864000035],
                    [-1.72206313099997, 6.363928565000037],
                    [-1.722178963999966, 6.364005590000033],
                    [-1.72223547699997, 6.364024806000032],
                    [-1.722291988999928, 6.364044025000055],
                    [-1.722407823999959, 6.364121049000062],
                    [-1.72250441999995, 6.364233936000062],
                    [-1.72263684099994, 6.364349529000037],
                    [-1.722752674999924, 6.364426553000044],
                    [-1.722829981999951, 6.364539469000022],
                    [-1.722943115999954, 6.364655089000053],
                    [-1.723094824999976, 6.364770655000029],
                    [-1.723191344999975, 6.36482841000003],
                    [-1.723478090999947, 6.364960327000063],
                    [-1.723545623999939, 6.364979529000038],
                    [-1.723613158999967, 6.36499873300005],
                    [-1.723880486999974, 6.365036950000047],
                    [-1.724012744999925, 6.36503676500007],
                    [-1.72412852399998, 6.365075196000021],
                    [-1.724244198999941, 6.36503644000004],
                    [-1.724395689999938, 6.364997635000066],
                    [-1.724588301999972, 6.36480715700003],
                    [-1.724626715999932, 6.364691324000034],
                    [-1.72481640899997, 6.364385070000026],
                    [-1.724970389999953, 6.364156054000034],
                    [-1.724931650999963, 6.364040329000034],
                    [-1.724873625999976, 6.363924631000032],
                    [-1.724856935999981, 6.363811632000022],
                    [-1.724779676999958, 6.363734556000054],
                    [-1.724702363999938, 6.363618884000061],
                    [-1.724682912999924, 6.363503132000062],
                    [-1.724682593999944, 6.36327433200006],
                    [-1.724740348999944, 6.363197065000065],
                    [-1.724778765999929, 6.363083989000074],
                    [-1.724855753999975, 6.362968101000035],
                    [-1.724894167999935, 6.36285226900003],
                    [-1.724951871999963, 6.36273916500005],
                    [-1.72504539199997, 6.362623255000074],
                    [-1.725141693999944, 6.362526638000077],
                    [-1.725370125999973, 6.362336108000022],
                    [-1.725543417999972, 6.362123604000033],
                    [-1.72554325699997, 6.362009203000071],
                    [-1.725543095999967, 6.361894803000041],
                    [-1.725581508999937, 6.361778970000046],
                    [-1.725542775999941, 6.36166600200005],
                    [-1.725504089999959, 6.361588870000048],
                    [-1.725426777999928, 6.361473200000034],
                    [-1.725294360999953, 6.361360364000063],
                    [-1.725197762999926, 6.361244720000059],
                    [-1.725159023999936, 6.361128996000048],
                    [-1.725236016999929, 6.36101586500007],
                    [-1.725351580999927, 6.360899924000023],
                    [-1.725445152999953, 6.360822606000056],
                    [-1.725676497999928, 6.360745097000063],
                    [-1.725808704999963, 6.360709074000056],
                    [-1.725866459999963, 6.360631807000061],
                    [-1.725924213999974, 6.360554540000066],
                    [-1.72598161999997, 6.360229175000029],
                    [-1.725962169999946, 6.360113425000065],
                    [-1.725961849999976, 6.359884623000028],
                    [-1.725923113999954, 6.359770276000063],
                    [-1.725884378999979, 6.359655930000031],
                    [-1.725807093999947, 6.359559557000068],
                    [-1.725746246999961, 6.359397],
                    [-1.725845077999963, 6.359137737000026],
                    [-1.725922064999963, 6.359021850000033],
                    [-1.72603763099994, 6.358908665000058],
                    [-1.726150492999977, 6.358831321000025],
                    [-1.726266163999981, 6.358792565000044],
                    [-1.726417388999948, 6.358563552000021],
                    [-1.726464029999931, 6.358422897000025],
                    [-1.726686982999979, 6.35825718600006],
                    [-1.726772411999946, 6.358266714000024],
                    [-1.726857842999948, 6.358276243000034],
                    [-1.726896736999947, 6.358504989000039],
                    [-1.726877639999941, 6.35864009200003],
                    [-1.726877799999954, 6.35875311500007],
                    [-1.726916591999952, 6.358907431000034],
                    [-1.72691674999993, 6.359020453000028],
                    [-1.72695548799993, 6.359136178000028],
                    [-1.727013458999977, 6.359213282000042],
                    [-1.727145878999977, 6.359328874000028],
                    [-1.727223187999925, 6.359441789000073],
                    [-1.727300634999949, 6.359653941000033],
                    [-1.727339531999974, 6.359882688000027],
                    [-1.727472165999927, 6.360149896000053],
                    [-1.727568793999978, 6.360284834000026],
                    [-1.727684677999946, 6.360397694000028],
                    [-1.727836385999979, 6.360513259000072],
                    [-1.728067943999974, 6.360590119000051],
                    [-1.728181022999934, 6.360667146000026],
                    [-1.728335424999955, 6.360738601000037],
                    [-1.728451259999929, 6.360815624000054],
                    [-1.728544968999927, 6.360834789000023],
                    [-1.728660776999959, 6.360892514000057],
                    [-1.728776527999969, 6.360911648000069],
                    [-1.728908865999927, 6.360969352000041],
                    [-1.729005251999979, 6.360930622000069],
                    [-1.729140209999969, 6.360891839000033],
                    [-1.729233781999937, 6.360814522000055],
                    [-1.729368687999965, 6.36073714500003],
                    [-1.72944567899998, 6.360624015000042],
                    [-1.72955854099996, 6.36054666900003],
                    [-1.729790044999959, 6.360584935000077],
                    [-1.729903123999975, 6.360661961000062],
                    [-1.730018876999964, 6.360681095000075],
                    [-1.730247572999929, 6.360680771000034],
                    [-1.730363270999931, 6.360661312000047],
                    [-1.73053531599993, 6.360545291000051],
                    [-1.730707364999944, 6.360429268000075],
                    [-1.731051193999974, 6.360009773000058],
                    [-1.73108971399995, 6.359971125000072],
                    [-1.732160628999964, 6.359319044000074],
                    [-1.732254147999924, 6.359203133000051],
                    [-1.732388859999958, 6.358990680000034],
                    [-1.732465876999925, 6.35889684600005],
                    [-1.732523224999966, 6.358532890000049],
                    [-1.732580951999978, 6.358436325000071],
                    [-1.732580599999949, 6.358188228000074],
                    [-1.732654667999952, 6.357956565000052],
                    [-1.732712368999955, 6.357843461000073],
                    [-1.73280866999994, 6.35774684200004],
                    [-1.732924340999944, 6.357708086000059],
                    [-1.732980810999948, 6.357698357000061],
                    [-1.733037281999941, 6.357688629000052],
                    [-1.733268786999929, 6.357726895000042],
                    [-1.733381810999958, 6.357765326000049],
                    [-1.733497616999955, 6.357823052000072],
                    [-1.73378422899998, 6.357861239000044],
                    [-1.734032154999966, 6.357822293000027],
                    [-1.73414782499998, 6.357783537000046],
                    [-1.734263548999934, 6.357783373000075],
                    [-1.734376409999925, 6.357706027000063],
                    [-1.734472686999936, 6.35759286900003],
                    [-1.734433782999929, 6.357361365000031],
                    [-1.734452799999929, 6.35717113100003],
                    [-1.734568360999958, 6.357055188000061],
                    [-1.734681274999957, 6.357016435000048],
                    [-1.734796998999968, 6.357016270000031],
                    [-1.734912779999945, 6.357054699000059],
                    [-1.73498868799993, 6.357151072000022],
                    [-1.735064596999962, 6.35724744700002],
                    [-1.735084044999951, 6.357360441000026],
                    [-1.735142071999974, 6.357476138000038],
                    [-1.735180860999947, 6.357627698000044],
                    [-1.735238805999927, 6.357685505000063],
                    [-1.735296750999964, 6.357743313000071],
                    [-1.735409774999937, 6.357781745000068],
                    [-1.735525499999937, 6.357781580000051],
                    [-1.735641276999957, 6.357820009000022],
                    [-1.735754247999978, 6.357819849000066],
                    [-1.735870026999976, 6.357858276000059],
                    [-1.735985779999965, 6.357877407000046],
                    [-1.736098830999936, 6.357935136000037],
                    [-1.736329574999957, 6.358002601000067],
                    [-1.736433451999972, 6.357973573000038],
                    [-1.736558274999936, 6.358048538000048],
                    [-1.736636014999931, 6.357857186000047],
                    [-1.736674369999946, 6.357702760000052],
                    [-1.736748602999967, 6.357589631000053],
                    [-1.73686416299995, 6.357473689000074],
                    [-1.736921995999978, 6.357454310000037],
                    [-1.736979832999964, 6.357434931000057],
                    [-1.737092856999936, 6.357473362000064],
                    [-1.737189403999935, 6.357550411000034],
                    [-1.737324520999948, 6.357624648000069],
                    [-1.737437654999951, 6.357740266000064],
                    [-1.737592117999952, 6.357855824000069],
                    [-1.737820923999948, 6.357932684000048],
                    [-1.737936593999962, 6.357893926000031],
                    [-1.738013631999934, 6.357816630000059],
                    [-1.738052014999937, 6.357681500000069],
                    [-1.738061162999941, 6.357626761000063],
                    [-1.738090262999947, 6.357452644000034],
                    [-1.738164464999954, 6.357317463000072],
                    [-1.738202878999971, 6.357204387000024],
                    [-1.738279863999935, 6.357088497000063],
                    [-1.738433998999938, 6.356972499000051],
                    [-1.738527651999959, 6.356953069000042],
                    [-1.738662691999934, 6.356972173000031],
                    [-1.738737470999979, 6.357021895000059],
                    [-1.73877852499993, 6.357049193000023],
                    [-1.738853030999962, 6.357126272000073],
                    [-1.738891770999942, 6.357241996000027],
                    [-1.738969081999926, 6.357354908000048],
                    [-1.739007791999938, 6.357451335000064],
                    [-1.739027246999967, 6.357567085000028],
                    [-1.739085269999975, 6.357680026000025],
                    [-1.739124037999943, 6.357815044000063],
                    [-1.739104888999975, 6.357911553000065],
                    [-1.739124363999963, 6.358043845000054],
                    [-1.73935051899997, 6.358195136000063],
                    [-1.739466296999979, 6.358233565000035],
                    [-1.739559870999926, 6.358156244000043],
                    [-1.73969477299994, 6.358078866000028],
                    [-1.739774509999961, 6.357962972000053],
                    [-1.739774184999931, 6.35773417300004],
                    [-1.739715968999974, 6.357486159000075],
                    [-1.739715641999965, 6.357257359000073],
                    [-1.739792629999954, 6.357144227000049],
                    [-1.740021042999956, 6.356948178000039],
                    [-1.740210833999924, 6.356719106000071],
                    [-1.740422751999972, 6.356547892000037],
                    [-1.740499733999968, 6.356432004000055],
                    [-1.740535389999934, 6.356316173000039],
                    [-1.740612376999934, 6.356203041000072],
                    [-1.74063149899996, 6.356087235000075],
                    [-1.74068919399997, 6.355971375000024],
                    [-1.740611395999963, 6.355516642000055],
                    [-1.740534080999964, 6.35540097300003],
                    [-1.74049815199993, 6.35532383900005],
                    [-1.74045941199995, 6.355208117000075],
                    [-1.740533478999964, 6.354979209000021],
                    [-1.740610489999938, 6.354882616000054],
                    [-1.740726078999955, 6.354788725000049],
                    [-1.740954661999979, 6.354711212000041],
                    [-1.741108904999976, 6.354672399000037],
                    [-1.741185780999956, 6.354482081000072],
                    [-1.741147040999977, 6.35436635800005],
                    [-1.741031207999924, 6.354289339000047],
                    [-1.740934660999926, 6.354212290000021],
                    [-1.74070586199997, 6.354138189000025],
                    [-1.740609315999961, 6.354061141000045],
                    [-1.740531890999932, 6.353868288000058],
                    [-1.740512386999967, 6.353716701000053],
                    [-1.740531507999947, 6.353600894000067],
                    [-1.740589203999946, 6.353485033000027],
                    [-1.740685478999978, 6.353371874000061],
                    [-1.740825696999934, 6.353159413000071],
                    [-1.741001738999955, 6.352949656000021],
                    [-1.741125589999967, 6.352852996000024],
                    [-1.741320057999928, 6.352723670000046],
                    [-1.741469704999929, 6.352643],
                    [-1.74171746199994, 6.352488273000063],
                    [-1.742099902999939, 6.352104553000061],
                    [-1.742157709999958, 6.352067256000055],
                    [-1.742215518999956, 6.35202995800006],
                    [-1.742289774999961, 6.35193337000004],
                    [-1.742405220999956, 6.351740240000026],
                    [-1.742462918999934, 6.351627135000058],
                    [-1.742501163999975, 6.351395523000065],
                    [-1.742500998999958, 6.351281123000035],
                    [-1.742500835999977, 6.351166724000052],
                    [-1.742481409999925, 6.351070269000047],
                    [-1.742500506999932, 6.35093792400005],
                    [-1.742558230999975, 6.350841359000071],
                    [-1.742558036999981, 6.350706283000022],
                    [-1.742689992999942, 6.350496591000024],
                    [-1.742918465999935, 6.350344649000021],
                    [-1.743053419999967, 6.350305863000074],
                    [-1.743169196999929, 6.350344288000031],
                    [-1.74324639799994, 6.350380013000063],
                    [-1.743282865999959, 6.350407795000024],
                    [-1.743398103999937, 6.350495576000071],
                    [-1.743475475999958, 6.35064983500007],
                    [-1.743514184999981, 6.350743505000025],
                    [-1.743552952999949, 6.350878524000052],
                    [-1.743533802999934, 6.350975035000033],
                    [-1.743608493999943, 6.351181675000021],
                    [-1.743705094999939, 6.351297314000021],
                    [-1.743820817999961, 6.351297147000025],
                    [-1.74401082199995, 6.351219689000061],
                    [-1.744049231999952, 6.351103855000076],
                    [-1.74412616099994, 6.350952131000042],
                    [-1.744164543999943, 6.350817],
                    [-1.744202978999965, 6.350720464000062],
                    [-1.744183500999952, 6.350588172000073],
                    [-1.744202567999935, 6.350433774000066],
                    [-1.744202238999947, 6.350204974000064],
                    [-1.744163526999955, 6.350108546000058],
                    [-1.744163363999974, 6.349995525000054],
                    [-1.744124598999974, 6.349863263000032],
                    [-1.744124434999947, 6.349748863000059],
                    [-1.744151706999958, 6.349637069000039],
                    [-1.744105996999963, 6.349520572000074],
                    [-1.744129728999951, 6.349391321000041],
                    [-1.744172636999963, 6.349290757000063],
                    [-1.744264204999979, 6.349175890000026],
                    [-1.74427646099997, 6.349125645000072],
                    [-1.744313586999965, 6.349077350000073],
                    [-1.744467939999936, 6.349115721000032],
                    [-1.744583606999925, 6.349076962000026],
                    [-1.744696573999931, 6.349076801000024],
                    [-1.744773829999929, 6.349151119000055],
                    [-1.745118213999945, 6.349131326000077],
                    [-1.745539470999972, 6.348921216000065],
                    [-1.745568319999961, 6.348863286000039],
                    [-1.74565470899995, 6.348723899000049],
                    [-1.74577413999998, 6.348613653000029],
                    [-1.745844895999937, 6.348632709000071],
                    [-1.745922069999949, 6.348650516000021],
                    [-1.746034985999927, 6.348614517000044],
                    [-1.746379396999941, 6.34861402100006],
                    [-1.746723557999928, 6.348439858000063],
                    [-1.746839252999962, 6.348420394000073],
                    [-1.746998712999925, 6.348411229000021],
                    [-1.747183636999978, 6.348400602000027],
                    [-1.74741221499994, 6.34832308600005],
                    [-1.747527857999955, 6.348267788000044],
                    [-1.747643468999968, 6.34819043400006],
                    [-1.747720504999961, 6.348113137000041],
                    [-1.74775761799998, 6.348055195000029],
                    [-1.747794730999942, 6.347997252000027],
                    [-1.747910289999936, 6.347884063000038],
                    [-1.748080755999979, 6.347632963000024],
                    [-1.74833123999997, 6.347461691000035],
                    [-1.74842483499998, 6.347403668000027],
                    [-1.748540502999958, 6.347364906000053],
                    [-1.748769134999975, 6.347325984000065],
                    [-1.749000578999926, 6.347325650000073],
                    [-1.749477438999975, 6.347460034000051],
                    [-1.74959316099995, 6.347459867000055],
                    [-1.74970443999996, 6.347538213000064],
                    [-1.749797347999959, 6.347637505000023],
                    [-1.750255405999951, 6.348008957000047],
                    [-1.75048402799996, 6.348087088000057],
                    [-1.75071470499995, 6.348065721000069],
                    [-1.751053909999939, 6.347773295000025],
                    [-1.751589158999934, 6.347427940000046],
                    [-1.751756179999973, 6.347150121000027],
                    [-1.751995095999973, 6.346972699000048],
                    [-1.752339393999932, 6.346895626000048],
                    [-1.752520880999953, 6.346699145000059],
                    [-1.752755062999938, 6.346555230000035],
                    [-1.752965582999934, 6.34658842500005],
                    [-1.753080499999953, 6.346664832000044],
                    [-1.75331510999996, 6.346817636000026],
                    [-1.753659737999953, 6.346965496000053],
                    [-1.753779358999964, 6.346989250000036],
                    [-1.754090205999944, 6.346936155000037],
                    [-1.755372894999937, 6.347427224000057],
                    [-1.755745798999953, 6.347514333000049],
                    [-1.756004162999943, 6.347081166000066],
                    [-1.756185321999965, 6.346606761000032],
                    [-1.757065889999978, 6.345839134000073],
                    [-1.757410018999963, 6.345645667000042],
                    [-1.757564054999932, 6.345711449000021],
                    [-1.757680204999929, 6.345761051000068],
                    [-1.757603447999941, 6.346028557000068],
                    [-1.757448911999973, 6.346211649000054],
                    [-1.757375153999931, 6.346299038000041],
                    [-1.757375492999927, 6.346530594000058],
                    [-1.757642974999953, 6.346681819000025],
                    [-1.758254227999942, 6.346394235000048],
                    [-1.758292466999933, 6.346165380000059],
                    [-1.758272760999944, 6.345878721000076],
                    [-1.758135076999963, 6.345599798000023],
                    [-1.75770859499994, 6.345083554000041],
                    [-1.757617395999944, 6.344868326000039],
                    [-1.757703173999971, 6.344648054000061],
                    [-1.757870281999942, 6.344432450000056],
                    [-1.757894016999956, 6.344307983000022],
                    [-1.757783655999958, 6.344073641000023],
                    [-1.757094064999933, 6.343543423000028],
                    [-1.756687012999976, 6.34322815400003],
                    [-1.756546444999969, 6.342950951000034],
                    [-1.756526989999941, 6.34283657800006],
                    [-1.756507536999948, 6.342722206000076],
                    [-1.756526486999974, 6.34249062300006],
                    [-1.756812393999951, 6.342051902000037],
                    [-1.757156462999944, 6.341819843000053],
                    [-1.757385039999974, 6.341745080000067],
                    [-1.757500422999954, 6.341513356000064],
                    [-1.757461213999932, 6.341077865000045],
                    [-1.756867769999928, 6.34034822600006],
                    [-1.756751741999949, 6.340136136000069],
                    [-1.756674261999933, 6.339907449000066],
                    [-1.756692876999978, 6.339447064000069],
                    [-1.75678894899994, 6.339198828000065],
                    [-1.756942935999973, 6.338989101000038],
                    [-1.75703627799993, 6.338757408000049],
                    [-1.757035774999963, 6.338412830000038],
                    [-1.757074183999976, 6.338299752000069],
                    [-1.757228307999981, 6.338183750000042],
                    [-1.75745707699997, 6.338241304000064],
                    [-1.757534667999948, 6.338547177000066],
                    [-1.757515715999943, 6.338776004000067],
                    [-1.757535171999962, 6.338891754000031],
                    [-1.757689770999946, 6.339101031000041],
                    [-1.757802819999938, 6.339158755000028],
                    [-1.758034314999975, 6.339197010000021],
                    [-1.758185824999941, 6.339177493000022],
                    [-1.758437214999958, 6.339078473000029],
                    [-1.758530032999943, 6.339041914000063],
                    [-1.758758664999959, 6.339005745000065],
                    [-1.758990131999951, 6.339024702000074],
                    [-1.759116996999978, 6.339109972000074],
                    [-1.759243849999962, 6.339194662000068],
                    [-1.759506532999978, 6.339826124000069],
                    [-1.759699681999962, 6.340018805000057],
                    [-1.759757736999973, 6.340151038000045],
                    [-1.759793893999927, 6.340382542000043],
                    [-1.760102899999936, 6.340668778000065],
                    [-1.760331776999976, 6.340800761000025],
                    [-1.760446176999949, 6.34083918500005],
                    [-1.760560576999978, 6.340877610000064],
                    [-1.761136563999969, 6.340973247000022],
                    [-1.761251029999926, 6.341058534000069],
                    [-1.761365499999954, 6.34114382100006],
                    [-1.76163340599993, 6.341584488000024],
                    [-1.761826497999948, 6.341738575000022],
                    [-1.762055183999962, 6.341738239000051],
                    [-1.762688356999945, 6.341373435000037],
                    [-1.76291720699993, 6.34148612000007],
                    [-1.763110358999938, 6.341678798000032],
                    [-1.763320462999957, 6.342158143000063],
                    [-1.763552409999932, 6.342502377000073],
                    [-1.763896763999981, 6.34246603400004],
                    [-1.764163823999979, 6.342330566000044],
                    [-1.764297184999975, 6.342148433000034],
                    [-1.764430545999971, 6.341966299000035],
                    [-1.764929471999949, 6.342119934000038],
                    [-1.765367951999963, 6.342386680000061],
                    [-1.765483797999934, 6.342471964000026],
                    [-1.765599643999963, 6.342557249000038],
                    [-1.765638317999958, 6.342624730000068],
                    [-1.765674452999974, 6.342699058000051],
                    [-1.765609739999945, 6.342864596000027],
                    [-1.765542492999941, 6.343036984000037],
                    [-1.765330674999973, 6.343266096000036],
                    [-1.765179586999977, 6.343572304000077],
                    [-1.765199215999928, 6.343803832000049],
                    [-1.765329319999978, 6.344102579000037],
                    [-1.765389974999948, 6.344241852000039],
                    [-1.765448513999957, 6.344702121000068],
                    [-1.765525998999976, 6.344930806000036],
                    [-1.765622574999952, 6.345027145000074],
                    [-1.765851374999954, 6.345103993000066],
                    [-1.766385951999951, 6.345141795000075],
                    [-1.76680711399996, 6.344873781000047],
                    [-1.767035742999951, 6.344834850000041],
                    [-1.767267265999976, 6.34488963900003],
                    [-1.767496123999933, 6.345005079000032],
                    [-1.76784044599998, 6.344946680000021],
                    [-1.767956222999942, 6.34498510100002],
                    [-1.768049988999962, 6.345042851000073],
                    [-1.768136976999926, 6.345176418000051],
                    [-1.768223963999958, 6.345309986000075],
                    [-1.768353949999948, 6.345639210000058],
                    [-1.768483935999939, 6.345968431000074],
                    [-1.768553353999948, 6.34637979200005],
                    [-1.76860346199993, 6.34667670500005],
                    [-1.768876163999948, 6.346629439000026],
                    [-1.769085, 6.346248715000058],
                    [-1.76918126399994, 6.346132794000027],
                    [-1.769296926999971, 6.346094030000074],
                    [-1.769583678999936, 6.34623143500005],
                    [-1.769807108999942, 6.346402014000034],
                    [-1.770063917999948, 6.346784801000069],
                    [-1.770292887999972, 6.34697466800003],
                    [-1.770331631999966, 6.347090388000026],
                    [-1.770312713999942, 6.347338513000068],
                    [-1.770045710999966, 6.347512576000042],
                    [-1.769814353999948, 6.347570808000057],
                    [-1.769643837999979, 6.347780565000051],
                    [-1.769682583999952, 6.347896284000058],
                    [-1.769795774999977, 6.348047732000055],
                    [-1.769930840999962, 6.348086124000076],
                    [-1.770198071999971, 6.348066429000028],
                    [-1.770333110999957, 6.348085526000034],
                    [-1.770523453999942, 6.348239613000032],
                    [-1.77060094199993, 6.348468296000021],
                    [-1.770640710999942, 6.349273168000025],
                    [-1.770812218999936, 6.349730511000075],
                    [-1.770986089999951, 6.349923216000036],
                    [-1.771214949999944, 6.35003865300007],
                    [-1.771330839999962, 6.350151501000028],
                    [-1.771369586999924, 6.35026722200007],
                    [-1.771141806999935, 6.350879529000053],
                    [-1.771254946999932, 6.350995139000077],
                    [-1.771491971999978, 6.351041648000034],
                    [-1.771841587999972, 6.350835759000063],
                    [-1.772191203999967, 6.350629871000024],
                    [-1.772441617999959, 6.350417238000034],
                    [-1.772670222999977, 6.35036176400007],
                    [-1.772785975999966, 6.350380890000054],
                    [-1.772899110999958, 6.350493740000047],
                    [-1.772973938999939, 6.350785830000063],
                    [-1.772957941999948, 6.351144214000044],
                    [-1.773112525999977, 6.35133694600006],
                    [-1.773567283999967, 6.351427236000063],
                    [-1.773743943999932, 6.35164198800004],
                    [-1.773744630999943, 6.352102340000044],
                    [-1.773648536999929, 6.352331283000069],
                    [-1.773629590999974, 6.35256011000007],
                    [-1.773668338999926, 6.352675832000045],
                    [-1.773822946999928, 6.352885102000073],
                    [-1.773861867999926, 6.353116600000021],
                    [-1.773823462999928, 6.353229678000048],
                    [-1.773611677999952, 6.353480846000025],
                    [-1.773479476999967, 6.35351687900004],
                    [-1.773239695999962, 6.353470375000029],
                    [-1.772941680999963, 6.353173106000042],
                    [-1.772790137999948, 6.353173333000029],
                    [-1.772703476999936, 6.35326029600003],
                    [-1.772616811999967, 6.353347258000042],
                    [-1.772493244999964, 6.353628617000027],
                    [-1.772066310999946, 6.35374984200007],
                    [-1.771822322999981, 6.353731061000076],
                    [-1.771602310999924, 6.353750533000039],
                    [-1.771380011999952, 6.353841794000061],
                    [-1.771155411999928, 6.353992882000057],
                    [-1.770952400999931, 6.354187007000064],
                    [-1.770799675999967, 6.354421739000031],
                    [-1.770761611999944, 6.354558191000024],
                    [-1.770760209999935, 6.355223418000037],
                    [-1.77069118299994, 6.355448452000076],
                    [-1.770185074999972, 6.356085716000052],
                    [-1.770321714999966, 6.356293695000033],
                    [-1.770549082999935, 6.356393858000047],
                    [-1.771015596999973, 6.356472129000053],
                    [-1.77122150799994, 6.356620182000029],
                    [-1.771298215999934, 6.356734925000069],
                    [-1.771320076999928, 6.356959825000047],
                    [-1.771241497999938, 6.357194446000051],
                    [-1.770952617999967, 6.357546631000048],
                    [-1.770898053999929, 6.357848218000072],
                    [-1.770207959999937, 6.358607794000022],
                    [-1.77007939899994, 6.359007599000051],
                    [-1.770099183999946, 6.359445468000047],
                    [-1.770061249999969, 6.35967045700005],
                    [-1.769906122999942, 6.359898014000066],
                    [-1.769793822999929, 6.359974754000064],
                    [-1.769586075999939, 6.360202387000072],
                    [-1.768936241999938, 6.360696290000021],
                    [-1.768673841999941, 6.361090175000072],
                    [-1.768533582999964, 6.361499224000056],
                    [-1.768402789999925, 6.362252466000029],
                    [-1.768365134999954, 6.362666493000063],
                    [-1.768272201999935, 6.362901135000072],
                    [-1.767978675999927, 6.363349042000038],
                    [-1.76798380799994, 6.363583539000047],
                    [-1.768039148999947, 6.363805996000053],
                    [-1.768206881999959, 6.364011536000021],
                    [-1.768329219999941, 6.364250643000048],
                    [-1.768564681999976, 6.364968162000025],
                    [-1.768517802999952, 6.365611920000049],
                    [-1.768557052999938, 6.366272302000027],
                    [-1.768493501999956, 6.366963942000041],
                    [-1.768248595999978, 6.367940609000073],
                    [-1.768304610999962, 6.36861532100005],
                    [-1.768221489999974, 6.369015058000059],
                    [-1.768142916999977, 6.369256857000039],
                    [-1.768004494999957, 6.369460459000038],
                    [-1.767873597999937, 6.369900947000076],
                    [-1.768003300999965, 6.370266869000034],
                    [-1.768614637999974, 6.371220724000068],
                    [-1.771959260999949, 6.374223492000056],
                    [-1.77522178199996, 6.377980798000067],
                    [-1.774631233999969, 6.384799937000025],
                    [-1.774534907999964, 6.384875890000046],
                    [-1.774440057999925, 6.384951984000054],
                    [-1.774142582999957, 6.38509563100007],
                    [-1.773843470999964, 6.385240027000066],
                    [-1.773751629999936, 6.385317860000043],
                    [-1.773657675999971, 6.385397485000055],
                    [-1.77356372099996, 6.385477109000021],
                    [-1.773474629999953, 6.385552615000051],
                    [-1.773414662999926, 6.385671609000042],
                    [-1.77331436999998, 6.385870631000046],
                    [-1.773195692999934, 6.385959466000031],
                    [-1.773081181999942, 6.386045183000022],
                    [-1.772987612999941, 6.386175497000067],
                    [-1.772919177999938, 6.386333609000076],
                    [-1.77285412699996, 6.386483902000066],
                    [-1.772864046999928, 6.38668120400007],
                    [-1.772873850999929, 6.386876307000023],
                    [-1.772566572999949, 6.38740894600005],
                    [-1.772540062999951, 6.387510149000036],
                    [-1.77251139599997, 6.387619603000076],
                    [-1.772511906999966, 6.387960350000071],
                    [-1.772472892999929, 6.388114919000031],
                    [-1.772452936999969, 6.388193986000033],
                    [-1.772269926999968, 6.38852150300005],
                    [-1.77218957499997, 6.38866530100006],
                    [-1.772164676999978, 6.388650025000061],
                    [-1.772092191999945, 6.388693555000032],
                    [-1.772052730999974, 6.388717256000064],
                    [-1.771940993999976, 6.38878436300007],
                    [-1.771483874999944, 6.388938153000026],
                    [-1.771265896999978, 6.389039976000049],
                    [-1.771247770999935, 6.389052057000072],
                    [-1.770856963999961, 6.389312502000053],
                    [-1.770784830999958, 6.389360576000058],
                    [-1.770810727999958, 6.39033353700006],
                    [-1.770814971999926, 6.390492934000065],
                    [-1.770849829999975, 6.390750979000074],
                    [-1.770926608999957, 6.391319367000051],
                    [-1.770795164999925, 6.391868130000034],
                    [-1.770737470999961, 6.391982615000074],
                    [-1.770679774999962, 6.392097101000047],
                    [-1.770429486999944, 6.39240621600004],
                    [-1.77035267499997, 6.392635130000031],
                    [-1.770382092999967, 6.392960366000068],
                    [-1.770411513999932, 6.393285603000038],
                    [-1.770296296999959, 6.39363035100007],
                    [-1.770335105999948, 6.393784663000076],
                    [-1.770470468999974, 6.394013260000065],
                    [-1.770489927999961, 6.39412763100006],
                    [-1.770509387999937, 6.394242],
                    [-1.770471157999964, 6.394473613000059],
                    [-1.770318725999971, 6.394808769000065],
                    [-1.770166296999946, 6.395143927000049],
                    [-1.770127889999969, 6.395258383000055],
                    [-1.770089483999925, 6.395372839000061],
                    [-1.770016938999959, 6.395431077000069],
                    [-1.76987687899998, 6.396035010000048],
                    [-1.769450881999944, 6.396673914000075],
                    [-1.769007902999931, 6.397600160000025],
                    [-1.768521453999938, 6.397908529000063],
                    [-1.768214428999954, 6.398242268000047],
                    [-1.767835003999949, 6.398851070000035],
                    [-1.767523915999959, 6.399191864000045],
                    [-1.767370497999934, 6.399422825000045],
                    [-1.767854413999942, 6.400489653000022],
                    [-1.767477879999944, 6.401544237000053],
                    [-1.76722098099998, 6.402268743000036],
                    [-1.766886678999924, 6.402677992000065],
                    [-1.766581218999931, 6.402884983000035],
                    [-1.766167715999927, 6.402955141000064],
                    [-1.763686069999949, 6.403376396000056],
                    [-1.763404931999958, 6.403889553000056],
                    [-1.763175044999969, 6.404402632000028],
                    [-1.763047367999945, 6.404710464000061],
                    [-1.76297158899996, 6.40545404900007],
                    [-1.762763382999935, 6.405768052000042],
                    [-1.762562235999951, 6.405916121000075],
                    [-1.762383452999927, 6.406326576000026],
                    [-1.761946416999933, 6.406908255000076],
                    [-1.761385009999969, 6.407020256000067],
                    [-1.761024364999969, 6.406947582000043],
                    [-1.760680257999979, 6.407179647000021],
                    [-1.760622418999958, 6.407199029000026],
                    [-1.760564579999937, 6.407218411000031],
                    [-1.76049911399997, 6.407234733000053],
                    [-1.760429831999943, 6.407292265000024],
                    [-1.760342560999959, 6.40731871600002],
                    [-1.760237325999981, 6.407327246000023],
                    [-1.760133264999979, 6.407321419000027],
                    [-1.76003756199998, 6.407306006000056],
                    [-1.759943047999968, 6.407287004000068],
                    [-1.759847327999978, 6.407259626000041],
                    [-1.759724123999945, 6.407219656000052],
                    [-1.759653490999938, 6.407203680000066],
                    [-1.759576918999926, 6.407184651000023],
                    [-1.759485997999946, 6.407168034000051],
                    [-1.759408464999979, 6.407160053000041],
                    [-1.759332890999929, 6.407156296000039],
                    [-1.759250380999958, 6.407165989000021],
                    [-1.759118847999957, 6.407185327000036],
                    [-1.758998093999935, 6.407214221000061],
                    [-1.758904848999975, 6.407244270000035],
                    [-1.75883313199995, 6.407273090000047],
                    [-1.758705243999941, 6.407330709000064],
                    [-1.758616801999949, 6.407372715000065],
                    [-1.758522366999955, 6.407407552000052],
                    [-1.758436289999963, 6.407431608000024],
                    [-1.758346662999941, 6.40745049100002],
                    [-1.758239015999948, 6.407477365000034],
                    [-1.758119467999961, 6.407512238000038],
                    [-1.757984399999941, 6.407567475000064],
                    [-1.75786848499996, 6.407633450000048],
                    [-1.757775295999977, 6.407701786000075],
                    [-1.757703619999972, 6.407759320000025],
                    [-1.757605673999933, 6.407845609000049],
                    [-1.757459969999957, 6.407987006000042],
                    [-1.757419744999936, 6.408035565000034],
                    [-1.757383560999926, 6.408079245000067],
                    [-1.75725224699994, 6.408246941000073],
                    [-1.757156769999938, 6.408384674000047],
                    [-1.757042200999933, 6.408554738000021],
                    [-1.75695868899993, 6.40869484600006],
                    [-1.756877601999975, 6.408858879000036],
                    [-1.756835877999947, 6.408951067000032],
                    [-1.756796517999931, 6.409025305000057],
                    [-1.756760764999967, 6.40911150200003],
                    [-1.75671067199994, 6.409206097000038],
                    [-1.756659353999964, 6.409281548000024],
                    [-1.756551869999953, 6.409389386000043],
                    [-1.756498111999974, 6.409431341000072],
                    [-1.756445539999959, 6.409466116000033],
                    [-1.756370249999975, 6.409508103000064],
                    [-1.756202944999927, 6.409599279000076],
                    [-1.756140843999958, 6.409662782000055],
                    [-1.756115802999943, 6.409713070000066],
                    [-1.756100319999973, 6.409757361000061],
                    [-1.756100405999973, 6.409815987000059],
                    [-1.756106487999944, 6.409870026000021],
                    [-1.756112524999935, 6.409923650000053],
                    [-1.75612936999994, 6.409991823000041],
                    [-1.756169095999951, 6.410167642000033],
                    [-1.756195538999975, 6.410256141000048],
                    [-1.756220784999925, 6.410343444000034],
                    [-1.756244854999977, 6.410446303000072],
                    [-1.756256894999979, 6.410500127000034],
                    [-1.756280996999976, 6.410623324000028],
                    [-1.756302790999939, 6.410803956000052],
                    [-1.75631130499994, 6.410899659000052],
                    [-1.756312174999948, 6.410966145000032],
                    [-1.756315346999941, 6.411208338000051],
                    [-1.756334409999965, 6.411482960000058],
                    [-1.756341008999925, 6.411578002000056],
                    [-1.756353187999935, 6.411727540000072],
                    [-1.756356927999946, 6.411830429000076],
                    [-1.756349940999939, 6.411958459000061],
                    [-1.756329800999936, 6.41208890200005],
                    [-1.756304832999945, 6.412189441000066],
                    [-1.756253615999981, 6.41233309100005],
                    [-1.756184467999958, 6.41248394400003],
                    [-1.756142730999954, 6.412567759000069],
                    [-1.756080710999925, 6.412685101000022],
                    [-1.755992567999954, 6.412850024000022],
                    [-1.755916069999955, 6.412965313000029],
                    [-1.755840853999928, 6.413053962000049],
                    [-1.755746491999957, 6.413139049000051],
                    [-1.755642550999937, 6.413215773000047],
                    [-1.755540984999925, 6.413280531000055],
                    [-1.755388036999932, 6.413377669000056],
                    [-1.755249411999955, 6.413455642000031],
                    [-1.75518249299995, 6.41349522400003],
                    [-1.755058212999927, 6.413568390000023],
                    [-1.754851481999935, 6.413689536000049],
                    [-1.754745138999965, 6.413760284000034],
                    [-1.754696155999966, 6.413797445000057],
                    [-1.75462566899995, 6.413851388000069],
                    [-1.754527718999952, 6.413935284000047],
                    [-1.754462048999926, 6.414010757000028],
                    [-1.75440836699994, 6.41410535600005],
                    [-1.754352297999958, 6.414203548000046],
                    [-1.75428669799993, 6.414326877000065],
                    [-1.754199616999927, 6.414482544000066],
                    [-1.754116109999927, 6.414628633000063],
                    [-1.75399325099994, 6.414854943000023],
                    [-1.753932419999956, 6.414968696000074],
                    [-1.753895456999942, 6.415046519000043],
                    [-1.753879963999964, 6.415083632000062],
                    [-1.753838268999971, 6.415196159000061],
                    [-1.753820935999954, 6.415272702000038],
                    [-1.753807370999937, 6.415332599000067],
                    [-1.753788435999979, 6.415469023000071],
                    [-1.753780217999974, 6.415574322000055],
                    [-1.753778, 6.415691578000065],
                    [-1.753779426999927, 6.415849507000075],
                    [-1.753780750999965, 6.415936846000022],
                    [-1.753785716999971, 6.416060074000029],
                    [-1.753779940999948, 6.416200066000044],
                    [-1.753768192999928, 6.416343657000027],
                    [-1.753753980999932, 6.416439394000065],
                    [-1.753737346999969, 6.416514795000069],
                    [-1.753723068999932, 6.416565066000032],
                    [-1.753706413999964, 6.416626110000038],
                    [-1.75368734999995, 6.41667519300006],
                    [-1.753643993999958, 6.416777925000076],
                    [-1.753607468999974, 6.41685067700007],
                    [-1.753565732999959, 6.416933804000053],
                    [-1.753518014999941, 6.417016429000057],
                    [-1.753451224999935, 6.417144548000067],
                    [-1.753383248999967, 6.417279847000032],
                    [-1.753342715999963, 6.417369639000071],
                    [-1.753320081999959, 6.417430692000039],
                    [-1.753278215999956, 6.417544840000062],
                    [-1.753464901999962, 6.417639254000051],
                    [-1.75342649199996, 6.417753710000056],
                    [-1.75331131799993, 6.418137049000052],
                    [-1.753427168999963, 6.41821406400004],
                    [-1.753504662999944, 6.418442751000043],
                    [-1.753656616999933, 6.418709918000047],
                    [-1.754001638999966, 6.419092581000029],
                    [-1.754156154999976, 6.419227428000056],
                    [-1.754384902999959, 6.419246388000033],
                    [-1.754729810999947, 6.419551864000027],
                    [-1.754961623999975, 6.419780322000065],
                    [-1.75507483399997, 6.419934526000077],
                    [-1.754998067999963, 6.420202031000031],
                    [-1.755037013999925, 6.420450069000026],
                    [-1.754998632999957, 6.420585200000062],
                    [-1.754963088999943, 6.420775459000026],
                    [-1.755001979999975, 6.420986283000047],
                    [-1.755040869999959, 6.421197107000069],
                    [-1.755214756999976, 6.42138705800005],
                    [-1.755462938999926, 6.421502470000064],
                    [-1.755501573999936, 6.421541005000051],
                    [-1.755807680999965, 6.421694924000064],
                    [-1.755884840999954, 6.421694811000066],
                    [-1.756345377999935, 6.421922930000051],
                    [-1.756381200999954, 6.421922877000043],
                    [-1.756651481999938, 6.422074092000059],
                    [-1.756725998999968, 6.422151167000038],
                    [-1.756957645999933, 6.422266603000025],
                    [-1.757109379999974, 6.422382156000026],
                    [-1.75737983199997, 6.422649148000062],
                    [-1.757531477999976, 6.422706813000048],
                    [-1.757724601999939, 6.422858141000063],
                    [-1.757837726999981, 6.42295445600007],
                    [-1.758105365999938, 6.423182859000065],
                    [-1.758221274999926, 6.423298466000062],
                    [-1.758365868999931, 6.423458827000047],
                    [-1.758421572999964, 6.423520608000047],
                    [-1.758566304999931, 6.423681124000041],
                    [-1.758892214999946, 6.424179588000072],
                    [-1.758968797999955, 6.424260937000042],
                    [-1.759015209999973, 6.424427501000025],
                    [-1.759074689999977, 6.424584540000069],
                    [-1.759257210999976, 6.425019815000041],
                    [-1.759257325999954, 6.425097],
                    [-1.759363811999947, 6.425283508000064],
                    [-1.759415599999954, 6.425703661000057],
                    [-1.759425543999953, 6.42578433500006],
                    [-1.759451555999931, 6.425995368000031],
                    [-1.759529083999951, 6.426243348000071],
                    [-1.759530161999976, 6.42697109300002],
                    [-1.759511044999954, 6.427086899000074],
                    [-1.759491925999953, 6.42720270500007],
                    [-1.759456660999945, 6.427580414000033],
                    [-1.75941831199998, 6.427734841000074],
                    [-1.759418425999968, 6.427812026000026],
                    [-1.759418537999977, 6.427889211000036],
                    [-1.759380356999941, 6.42815666000007],
                    [-1.759342229999959, 6.428462700000068],
                    [-1.759361830999978, 6.428672174000042],
                    [-1.759323477999942, 6.428826601000026],
                    [-1.759227396999961, 6.429074839000066],
                    [-1.759037649999925, 6.429342512000062],
                    [-1.759018502999936, 6.429439022000054],
                    [-1.758989751999934, 6.429563113000029],
                    [-1.758961, 6.429687203000071],
                    [-1.758806908999929, 6.429841803000045],
                    [-1.758617103999939, 6.430070882000052],
                    [-1.758578693999937, 6.430186717000026],
                    [-1.758520980999947, 6.430291554000064],
                    [-1.758463264999932, 6.430396391000045],
                    [-1.758350651999933, 6.430647410000063],
                    [-1.75815814799995, 6.430915087000074],
                    [-1.758158203999926, 6.430953679000027],
                    [-1.758084138999948, 6.43118258800007],
                    [-1.757968736999942, 6.431411558000036],
                    [-1.757968851999976, 6.431488743000045],
                    [-1.757776288999935, 6.431717828000046],
                    [-1.757776345999957, 6.431756421000046],
                    [-1.757625233999931, 6.43206262800004],
                    [-1.757586939999953, 6.432255648000023],
                    [-1.757397189999949, 6.432523321000076],
                    [-1.757320285999924, 6.432697101000031],
                    [-1.757185593999964, 6.432926100000032],
                    [-1.757127922999928, 6.433061259000056],
                    [-1.756861150999953, 6.433422771000039],
                    [-1.756765041999927, 6.433654469000032],
                    [-1.756710151999926, 6.433806164000032],
                    [-1.756594679999978, 6.433988271000032],
                    [-1.756479206999927, 6.434170379000022],
                    [-1.756479378999927, 6.434286157000031],
                    [-1.756308973999978, 6.434592393000059],
                    [-1.756251331999977, 6.434746849000021],
                    [-1.756155048999972, 6.434861391000027],
                    [-1.756058767999946, 6.434975933000032],
                    [-1.756023113999959, 6.435091763000059],
                    [-1.755907708999928, 6.435320733000026],
                    [-1.755792197999938, 6.435475274000055],
                    [-1.755641082999944, 6.435781482000039],
                    [-1.75539379099996, 6.436272525000049],
                    [-1.753850898999929, 6.435566352000023],
                    [-1.752171615999941, 6.435805895000044],
                    [-1.751059408999936, 6.43763636400007],
                    [-1.751354267999943, 6.438005382000028],
                    [-1.751603628999931, 6.439733285000045],
                    [-1.754546541999957, 6.440839976000063],
                    [-1.755427656999927, 6.44054247300005],
                    [-1.756586035999931, 6.440060821000031],
                    [-1.756851318999963, 6.439450668000063],
                    [-1.758050904999948, 6.440807413000073],
                    [-1.758373325999969, 6.44117207100004],
                    [-1.759195296999962, 6.44339714900002],
                    [-1.758598948999975, 6.443841575000022],
                    [-1.75833767499995, 6.444196189000024],
                    [-1.758089824999956, 6.444312334000074],
                    [-1.758022336999943, 6.444331730000044],
                    [-1.757610258999932, 6.444274453000048],
                    [-1.757436642999949, 6.444274711000048],
                    [-1.757227203999946, 6.444275021000067],
                    [-1.756998471999964, 6.444275360000063],
                    [-1.756537995999963, 6.444102376000046],
                    [-1.756386345999942, 6.444047469000054],
                    [-1.755986574999952, 6.443926770000076],
                    [-1.755821105999928, 6.443844316000025],
                    [-1.755424514999959, 6.444010300000059],
                    [-1.755311865999943, 6.444239266000068],
                    [-1.755234873999939, 6.444355158000064],
                    [-1.755080944999975, 6.444622777000063],
                    [-1.755006819999949, 6.44481309300005],
                    [-1.754472931999942, 6.445312830000034],
                    [-1.754302185999961, 6.44539026800004],
                    [-1.75414516099994, 6.44542909200004],
                    [-1.75391648599998, 6.445468023000046],
                    [-1.753591300999972, 6.445468503000029],
                    [-1.753552771999978, 6.445504397000036],
                    [-1.753015561999973, 6.445620967000025],
                    [-1.752709609999954, 6.445582825000031],
                    [-1.752577386999974, 6.445621613000071],
                    [-1.752020828999946, 6.445699618000049],
                    [-1.751389549999942, 6.445565474000034],
                    [-1.751254348999964, 6.445452651000039],
                    [-1.751140934999967, 6.44516337400006],
                    [-1.750873170999967, 6.444857783000032],
                    [-1.750451086999931, 6.444555176000051],
                    [-1.750110861999929, 6.444541750000042],
                    [-1.749406922999981, 6.444513973000028],
                    [-1.748185554999964, 6.444904677000068],
                    [-1.746968289999927, 6.445582641000044],
                    [-1.745832049999933, 6.446414731000061],
                    [-1.745057466999924, 6.446981971000071],
                    [-1.74453714699996, 6.447363006000046],
                    [-1.743489584999963, 6.448130148000075],
                    [-1.741701356999954, 6.450177937000035],
                    [-1.741751329999943, 6.450480847000051],
                    [-1.741828993999945, 6.450825311000074],
                    [-1.741849122999952, 6.451401416000067],
                    [-1.741753224999968, 6.451784726000028],
                    [-1.741662862999931, 6.452184568000064],
                    [-1.741690797999979, 6.452443650000021],
                    [-1.741934707999974, 6.45361319400007],
                    [-1.744036949999952, 6.456998157000044],
                    [-1.744781995999972, 6.457708920000073],
                    [-1.744718717999945, 6.458679720000021],
                    [-1.74430513599998, 6.458981512000037],
                    [-1.74400781199995, 6.459198469000057],
                    [-1.74329894899995, 6.459134385000027],
                    [-1.742955134999931, 6.459595243000024],
                    [-1.742724027999941, 6.459862972000053],
                    [-1.742305747999978, 6.460285345000045],
                    [-1.74213251599997, 6.460552990000053],
                    [-1.741808101999936, 6.461091004000025],
                    [-1.741712035999967, 6.461358536000034],
                    [-1.741618724999967, 6.461626064000029],
                    [-1.741349147999927, 6.461971035000033],
                    [-1.741330273999949, 6.462257751000038],
                    [-1.741275628999972, 6.462583112000061],
                    [-1.741199018999964, 6.462966394000034],
                    [-1.741238160999956, 6.463349507000032],
                    [-1.741200468999978, 6.463961532000042],
                    [-1.741654394999955, 6.464702578000072],
                    [-1.74175205399996, 6.465123075000065],
                    [-1.741817740999977, 6.465802475000032],
                    [-1.741835059999971, 6.466353355000024],
                    [-1.741970630999958, 6.46671703100003],
                    [-1.742084073999933, 6.467025607000039],
                    [-1.742315909999945, 6.46725682500005],
                    [-1.74266118099996, 6.46779110600005],
                    [-1.743152383999927, 6.467988360000049],
                    [-1.743468225999948, 6.468565541000032],
                    [-1.743574069999966, 6.469143028000076],
                    [-1.743427260999965, 6.46962865200004],
                    [-1.743582069999945, 6.469953707000059],
                    [-1.743850262999956, 6.470545988000026],
                    [-1.744079650999936, 6.470986712000069],
                    [-1.744350432999966, 6.471463211000071],
                    [-1.744463878999966, 6.471771786000033],
                    [-1.74463783899995, 6.472000330000071],
                    [-1.744809324999949, 6.472421842000074],
                    [-1.74494489999995, 6.472785517000034],
                    [-1.744993535999924, 6.47306248600006],
                    [-1.745042170999966, 6.47333945500003],
                    [-1.744945907999977, 6.473473292000051],
                    [-1.744849644999931, 6.473607129000072],
                    [-1.744621121999955, 6.473760456000036],
                    [-1.744392602999937, 6.473913783000057],
                    [-1.744084102999977, 6.474030013000061],
                    [-1.743816944999935, 6.474146182000027],
                    [-1.74364474999993, 6.474183648000064],
                    [-1.743472557999951, 6.474221115000034],
                    [-1.743128454999976, 6.474491767000075],
                    [-1.742748690999974, 6.474875492000024],
                    [-1.742559032999964, 6.475220347000061],
                    [-1.742292483999961, 6.475755520000064],
                    [-1.742100179999966, 6.476177564000068],
                    [-1.741756186999964, 6.476522644000056],
                    [-1.741737006999927, 6.476599857000053],
                    [-1.741717827999935, 6.47667707100004],
                    [-1.741450892999978, 6.476947609000035],
                    [-1.741106894999973, 6.477292689000024],
                    [-1.740954106999936, 6.477407311000036],
                    [-1.740801314999942, 6.477521934000038],
                    [-1.74036351999996, 6.477800991000038],
                    [-1.740132360999951, 6.478038397000034],
                    [-1.739923271999942, 6.47828955500006],
                    [-1.73961498999995, 6.478557396000042],
                    [-1.739462267999954, 6.478720259000056],
                    [-1.739309546999948, 6.47888312200007],
                    [-1.73889122099996, 6.479286197000022],
                    [-1.738698632999956, 6.479515277000075],
                    [-1.738450956999941, 6.479765112000052],
                    [-1.738203278999947, 6.48001494600004],
                    [-1.737894966999932, 6.480263490000027],
                    [-1.737550882999926, 6.480550679000032],
                    [-1.737303230999942, 6.480818431000046],
                    [-1.736862715999962, 6.481127812000068],
                    [-1.736634274999972, 6.481340404000036],
                    [-1.73640577499998, 6.481511646000058],
                    [-1.736138832999927, 6.481782182000074],
                    [-1.735717712999929, 6.482163207000042],
                    [-1.735412074999942, 6.482356613000036],
                    [-1.735161609999977, 6.482585776000064],
                    [-1.734685372999934, 6.482969636000064],
                    [-1.734454144999972, 6.483162935000053],
                    [-1.734166952999942, 6.483430233000036],
                    [-1.733920194999939, 6.483659899000031],
                    [-1.73322905699996, 6.48409368800003],
                    [-1.73306406599994, 6.484350293000034],
                    [-1.732890765999969, 6.484579343000064],
                    [-1.732662568999956, 6.484962844000052],
                    [-1.732547255999975, 6.485268995000069],
                    [-1.732518515999971, 6.485405490000062],
                    [-1.732489771999951, 6.485541984000065],
                    [-1.732471034999946, 6.485925182000074],
                    [-1.73247166699997, 6.486363485000027],
                    [-1.73245258999998, 6.486512370000071],
                    [-1.73239480999996, 6.48697319300004],
                    [-1.732280272999958, 6.487227415000064],
                    [-1.731784866999931, 6.487578970000072],
                    [-1.731637193999973, 6.487743001000069],
                    [-1.731512006999935, 6.487889283000072],
                    [-1.731199242999935, 6.488275446000046],
                    [-1.730885615999966, 6.488868698000033],
                    [-1.730499361999932, 6.489425760000074],
                    [-1.729840751999973, 6.489838038000073],
                    [-1.72913374999996, 6.490244336000046],
                    [-1.728735180999934, 6.490650191000043],
                    [-1.728511831999924, 6.490940863000048],
                    [-1.728154558999961, 6.491331629000058],
                    [-1.727906978999954, 6.491657266000061],
                    [-1.727598571999977, 6.49184791600004],
                    [-1.727062079999939, 6.49213459200007],
                    [-1.726693313999931, 6.492237954000075],
                    [-1.725961827999924, 6.492444668000076],
                    [-1.725381346999939, 6.492518086000075],
                    [-1.725024666999957, 6.492615380000075],
                    [-1.724854962999927, 6.492654109000057],
                    [-1.72457123099997, 6.492718861000071],
                    [-1.724238758999945, 6.492828219000046],
                    [-1.723891678999962, 6.492882133000023],
                    [-1.723767134999946, 6.492901480000057],
                    [-1.723495095999965, 6.492980505000048],
                    [-1.722848165999949, 6.493108456000073],
                    [-1.722255465999979, 6.493097204000037],
                    [-1.722092277999934, 6.493065952000052],
                    [-1.721919968999941, 6.493027604000076],
                    [-1.721652461999952, 6.492912207000074],
                    [-1.721114700999976, 6.492684172000054],
                    [-1.720846761999951, 6.492262789000051],
                    [-1.72065599299998, 6.491841295000029],
                    [-1.72063649699993, 6.491697978000047],
                    [-1.720626747999972, 6.491626320000023],
                    [-1.720617, 6.491554661000066],
                    [-1.72042361299998, 6.491229654000051],
                    [-1.719736066999928, 6.490620705000026],
                    [-1.71950448299998, 6.490274408000062],
                    [-1.719236873999932, 6.49008458000003],
                    [-1.718967964999933, 6.489949886000034],
                    [-1.718699056999981, 6.489815193000027],
                    [-1.718565334999937, 6.489778168000043],
                    [-1.71843161299995, 6.48974114300006],
                    [-1.718125551999947, 6.489645094000025],
                    [-1.717819383999938, 6.489471860000037],
                    [-1.71752692299998, 6.489414039000053],
                    [-1.716975433999949, 6.489054045000046],
                    [-1.716477855999926, 6.488977563000049],
                    [-1.715980276999971, 6.488901080000062],
                    [-1.715693700999964, 6.488940077000052],
                    [-1.715101255999969, 6.48901809900002],
                    [-1.71464104599994, 6.489057341000034],
                    [-1.713990665999972, 6.489094093000062],
                    [-1.713533251999934, 6.489160896000044],
                    [-1.71329908599995, 6.489232898000068],
                    [-1.712841818999948, 6.48940445300002],
                    [-1.71249746899997, 6.489517959000068],
                    [-1.71219165399998, 6.489595575000067],
                    [-1.711885891999941, 6.489711783000075],
                    [-1.711464425999964, 6.489863989000071],
                    [-1.711263634999966, 6.490313936000064],
                    [-1.711120994999931, 6.490633573000025],
                    [-1.711102104999952, 6.490920290000076],
                    [-1.710932112999956, 6.491551798000046],
                    [-1.710684381999954, 6.491733533000058],
                    [-1.710243202999948, 6.492152392000037],
                    [-1.709938185999931, 6.492280943000026],
                    [-1.709599306999962, 6.492366874000027],
                    [-1.709323848999929, 6.492474768000022],
                    [-1.708943773999977, 6.492665508000073],
                    [-1.708635411999978, 6.492894740000054],
                    [-1.708501875999957, 6.492991409000069],
                    [-1.708368340999925, 6.493088078000028],
                    [-1.708139823999943, 6.493259309000052],
                    [-1.707872885999961, 6.49354912900003],
                    [-1.707551459999934, 6.493753409000021],
                    [-1.707233780999957, 6.494172488000061],
                    [-1.706873780999956, 6.494523618000073],
                    [-1.706929248999927, 6.494771638000032],
                    [-1.707015080999952, 6.495052695000027],
                    [-1.707345650999969, 6.495355472000028],
                    [-1.707611969999959, 6.495509955000045],
                    [-1.707805879999967, 6.495780679000063],
                    [-1.707946526999933, 6.496022443000072],
                    [-1.707826980999926, 6.496201080000048],
                    [-1.707696098999975, 6.496855135000033],
                    [-1.707575472999963, 6.497092424000073],
                    [-1.707035182999959, 6.497609450000027],
                    [-1.706490194999958, 6.498127080000074],
                    [-1.706278210999926, 6.498298287000068],
                    [-1.706192932999954, 6.498414185000058],
                    [-1.706100238999966, 6.498511313000051],
                    [-1.705798048999952, 6.49882795700006],
                    [-1.70561332099993, 6.499021519000053],
                    [-1.705515913999932, 6.499123585000063],
                    [-1.705324063999967, 6.49941354200007],
                    [-1.705087249999963, 6.499602601000049],
                    [-1.705024229999935, 6.499634541000034],
                    [-1.70434850099997, 6.499977012000045],
                    [-1.704308448999939, 6.500037281000061],
                    [-1.704205480999974, 6.500192229000049],
                    [-1.704044195999927, 6.500392469000076],
                    [-1.703360801999963, 6.501240927000026],
                    [-1.701613290999944, 6.501157897000041],
                    [-1.701153121999937, 6.501235720000068],
                    [-1.700808760999962, 6.501349220000066],
                    [-1.70074901199996, 6.50135434300006],
                    [-1.700531448999925, 6.501349593000043],
                    [-1.700351142999978, 6.501278180000043],
                    [-1.700235384999928, 6.501278340000056],
                    [-1.699546027999929, 6.501047736000032],
                    [-1.699431649999951, 6.501047894000067],
                    [-1.699317269999938, 6.501048052000044],
                    [-1.698052492999977, 6.501262059000055],
                    [-1.697250742999927, 6.501472669000066],
                    [-1.696982201999958, 6.501606737000031],
                    [-1.696636490999936, 6.501740910000024],
                    [-1.696063737999964, 6.502124871000035],
                    [-1.695777219999968, 6.502212100000065],
                    [-1.695490698999947, 6.502299328000049],
                    [-1.695259180999926, 6.50229964600004],
                    [-1.695030369999927, 6.502261367000074],
                    [-1.69480155499997, 6.502223088000051],
                    [-1.694608413999958, 6.502068981000036],
                    [-1.694495384999925, 6.502049840000041],
                    [-1.694092620999925, 6.501782998000067],
                    [-1.693805927999961, 6.501744798000061],
                    [-1.69311694299995, 6.501784335000025],
                    [-1.693001225999978, 6.501813438000056],
                    [-1.692885505999925, 6.501842542000077],
                    [-1.692656904999978, 6.501958634000061],
                    [-1.692196729999978, 6.502033693000044],
                    [-1.691011191999962, 6.501748622000036],
                    [-1.690341449999949, 6.50175091400007],
                    [-1.690006578999942, 6.501752060000058],
                    [-1.689671706999945, 6.501753206000046],
                    [-1.688828516999934, 6.501894943000025],
                    [-1.688511700999925, 6.502000127000031],
                    [-1.687164806999931, 6.502638743000034],
                    [-1.686749883999937, 6.503120773000035],
                    [-1.686420273999943, 6.503376433000028],
                    [-1.68637483699996, 6.50341167800002],
                    [-1.685786794999956, 6.503706057000045],
                    [-1.685198750999973, 6.504000438000048],
                    [-1.684320775999936, 6.504919591000032],
                    [-1.683897464999973, 6.505763699000056],
                    [-1.683358147999968, 6.506426024000064],
                    [-1.683124581999948, 6.506952860000069],
                    [-1.682976004999944, 6.507143270000029],
                    [-1.682827428999929, 6.507333679000055],
                    [-1.682274187999951, 6.507891270000073],
                    [-1.681508275999931, 6.508121105000043],
                    [-1.681274242999962, 6.508301981000045],
                    [-1.681040208999946, 6.508482857000047],
                    [-1.682106914999963, 6.508525525000039],
                    [-1.682561891999967, 6.508676527000034],
                    [-1.682951699999933, 6.508936465000033],
                    [-1.683019832999946, 6.508981897000069],
                    [-1.683422417999964, 6.509115051000038],
                    [-1.683825001999935, 6.509248204000073],
                    [-1.684205601999963, 6.509429628000021],
                    [-1.68458620499996, 6.509611051000036],
                    [-1.68546973399998, 6.50973390300004],
                    [-1.686353263999933, 6.509856753000065],
                    [-1.686582158999954, 6.50995292500005],
                    [-1.687233359999937, 6.510495100000071],
                    [-1.687732451999977, 6.510657063000053],
                    [-1.688191982999967, 6.511115420000067],
                    [-1.688651517999972, 6.511573776000034],
                    [-1.688806281999973, 6.511879553000028],
                    [-1.688947614999961, 6.512441716000069],
                    [-1.689419569999927, 6.512912459000063],
                    [-1.689687103999972, 6.513045791000025],
                    [-1.689954639999939, 6.513179123000043],
                    [-1.690453744999957, 6.513346597000066],
                    [-1.690881737999973, 6.513916638000069],
                    [-1.691604276999954, 6.51421612300004],
                    [-1.691604588999951, 6.514443546000052],
                    [-1.691604898999969, 6.514670969000065],
                    [-1.691489401999945, 6.514864092000039],
                    [-1.691509009999947, 6.515092867000021],
                    [-1.691662358999963, 6.515369700000065],
                    [-1.691815708999968, 6.515646532000062],
                    [-1.692359540999973, 6.516271546000041],
                    [-1.69266233999997, 6.516481604000035],
                    [-1.692994080999938, 6.516711739000073],
                    [-1.693253752999965, 6.517138662000036],
                    [-1.693345177999959, 6.517480360000036],
                    [-1.693436602999952, 6.517822059000025],
                    [-1.693789987999935, 6.518248853000046],
                    [-1.693886744999929, 6.518458225000074],
                    [-1.69387786599998, 6.518575349000059],
                    [-1.69395878399996, 6.518733790000056],
                    [-1.693942514999947, 6.518928156000072],
                    [-1.693893703999947, 6.519511254000065],
                    [-1.694289655999967, 6.520827006000047],
                    [-1.69445679699993, 6.521109332000037],
                    [-1.694739781999942, 6.521448010000029],
                    [-1.694864331999952, 6.521825498000055],
                    [-1.694865255999957, 6.52249536100004],
                    [-1.69532671199994, 6.523338258000024],
                    [-1.695386815999939, 6.524134885000024],
                    [-1.695673011999929, 6.524618241000042],
                    [-1.695679963999964, 6.525512259000038],
                    [-1.695355242999938, 6.526039729000047],
                    [-1.695574014999977, 6.526783720000026],
                    [-1.695539237999981, 6.52754735700006],
                    [-1.695597433999978, 6.527776078000045],
                    [-1.69586540399996, 6.528216771000075],
                    [-1.69598211999994, 6.528905770000051],
                    [-1.696680438999977, 6.529611884000076],
                    [-1.696833863999927, 6.529936955000039],
                    [-1.69675428499994, 6.530194122000069],
                    [-1.695810149999943, 6.53012168600003],
                    [-1.695501351999951, 6.530054575000065],
                    [-1.69519255299997, 6.529987464000044],
                    [-1.69479307499995, 6.530123090000075],
                    [-1.693837734999931, 6.530921076000027],
                    [-1.693551313999933, 6.531092382000054],
                    [-1.692231041999946, 6.531094198000062],
                    [-1.692058823999957, 6.531133027000067],
                    [-1.691886609999926, 6.531171857000061],
                    [-1.691545140999949, 6.531401127000038],
                    [-1.690987854999946, 6.532034542000076],
                    [-1.690430568999943, 6.532667955000022],
                    [-1.690178653999965, 6.532879184000024],
                    [-1.689926739999976, 6.533090411000046],
                    [-1.68931889199996, 6.534042287000034],
                    [-1.688867553999955, 6.53455288400005],
                    [-1.688684425999952, 6.534675805000063],
                    [-1.688501296999959, 6.534798726000076],
                    [-1.688135039999963, 6.535044568000046],
                    [-1.68759917999995, 6.535225861000072],
                    [-1.687063319999936, 6.535407152000062],
                    [-1.686468513999955, 6.535822839000048],
                    [-1.685873711999932, 6.536238524000055],
                    [-1.685644983999964, 6.536274672000047],
                    [-1.685300340999959, 6.536200713000028],
                    [-1.684812467999961, 6.536201376000065],
                    [-1.684437829999979, 6.53636728500004],
                    [-1.683702106999931, 6.536530927000058],
                    [-1.683087130999979, 6.536301581000032],
                    [-1.682472153999925, 6.536072235000063],
                    [-1.681796949999978, 6.536147579000044],
                    [-1.681595827999956, 6.536214011000027],
                    [-1.681394703999956, 6.536280443000066],
                    [-1.681027103999952, 6.536556605000044],
                    [-1.680659504999937, 6.536832767000021],
                    [-1.680384093999976, 6.536998538000034],
                    [-1.680206368999961, 6.537042885000062],
                    [-1.677724839999939, 6.53904372900007],
                    [-1.673446982999963, 6.540593623000063],
                    [-1.671387639999978, 6.539126374000034],
                    [-1.669197270999973, 6.53791936600004],
                    [-1.667816071999937, 6.53753585100003],
                    [-1.666346117999979, 6.537867777000031],
                    [-1.665423514999929, 6.542286416000024],
                    [-1.66449972099997, 6.546710709000024],
                    [-1.663685301999976, 6.546150698000076],
                    [-1.66299176299998, 6.546011198000031],
                    [-1.662799310999958, 6.545964600000048],
                    [-1.662400987999945, 6.545947206000051],
                    [-1.661638795999977, 6.545913752000047],
                    [-1.661054182999976, 6.545721555000057],
                    [-1.659391795999966, 6.545514232000073],
                    [-1.658772576999979, 6.54520629700005],
                    [-1.658153360999961, 6.544898362000026],
                    [-1.657808758999977, 6.544860219000043],
                  ],
                ],
              },
            },
          ],
        };

        setBoundaryGeoJson(geojson);
      } catch (err) {
        console.error("Failed to load GeoJSON boundary", err);
      }
    };
    fetchBoundary();
  }, []);
  const handleVisualize = async (file) => {
    // The API endpoint is updated for the Tamale dataset
    const url = `https://ghclimatevulnerabilityhub.com/dataset/Bekwai/${file}`;
    setSelectedFile(file);
    setLoading(true);
    setResponse(null);
    setSelectedLocation(null);

    try {
      const res = await fetch(
        `https://climate.misconm.org/api/load?url=${encodeURIComponent(url)}`
      );
      const json = await res.json();

      if (json.error) {
        alert("Error loading data: " + json.error);
        return;
      }

      const validVariables = json.variables.filter(
        (v) => !["time", "latitude", "longitude", "spatial_ref"].includes(v)
      );

      if (validVariables.length === 0) {
        alert("No valid visualizable variable found in this dataset.");
        return;
      }

      setResponse(json);
      setSelectedVariable(validVariables[0]);
    } catch (err) {
      console.error("Failed to load file", err);
      alert("Failed to load file.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="tamale-page-container">
      <header className="page-header">
        <h1 className="page-title">Bekwai Dataset Viewer</h1>
      </header>

      <main className="page-content">
        <section className="file-list-section">
          <h2 className="section-title">📁 Available Datasets</h2>
          <div className="file-list-grid">
            {ncFiles.map((file) => {
              const key = file.split("_")[0];
              const isSelected = selectedFile === file;
              return (
                <div
                  key={file}
                  className={`file-card ${isSelected ? "selected" : ""}`}
                >
                  <div className="file-info">
                    <p className="file-name">{file}</p>
                    <p className="file-description">
                      {descriptions[key] || "No description"}
                    </p>
                  </div>
                  <button
                    className="visualize-button"
                    onClick={() => handleVisualize(file)}
                    disabled={loading && isSelected}
                  >
                    {loading && isSelected ? "Loading..." : "Visualize"}
                  </button>
                </div>
              );
            })}
          </div>
        </section>

        {loading && (
          <div className="loading-message-container">
            <div className="spinner"></div>
            <p>Loading dataset...</p>
          </div>
        )}

        {response && selectedVariable && (
          <section className="visualization-section">
            <div className="visualization-grid">
              <div className="chart-container">
                <h3 className="chart-title">🗺 Map Visualization</h3>
                <MapVisualization
                  response={response}
                  selectedVariable={selectedVariable}
                  onLocationSelect={(loc) => setSelectedLocation(loc)}
                  boundaryGeoJson={geojson}
                />
              </div>

              <div className="chart-container">
                <h3 className="chart-title">🟦 Spatial Grid Preview</h3>
                <div style={{ padding: "20px", width: "100%", height: "100%" }}>
                  <SpatialGridOverlay
                    response={response}
                    selectedVariable={selectedVariable}
                  />
                </div>
              </div>
            </div>

            {selectedLocation && response.coords.time?.length > 0 && (
              <div className="chart-container time-series-container">
                <h3 className="chart-title">
                  📈 Time Series at ({selectedLocation.lat.toFixed(2)}°N,{" "}
                  {selectedLocation.lon.toFixed(2)}°E)
                </h3>
                <TimeSeriesChart
                  data={{
                    variables: {
                      [selectedVariable]: {
                        data: response.data[selectedVariable],
                      },
                      latitude: { data: response.coords.latitude },
                      longitude: { data: response.coords.longitude },
                      time: { data: response.coords.time },
                    },
                  }}
                  location={selectedLocation}
                  variable={selectedVariable}
                />
              </div>
            )}
          </section>
        )}
      </main>
    </div>
  );
}

export default TamalePage;
